// tr translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const tr = {
    // Payouts
    "payouts.title": "Ödeme Merkezi",
    "payouts.subtitle": "Kraliyet, kazanç ve ödeme yöntemlerinizi yönetin.",
    "payouts.withdrawableBalance": "Çekilebilir Bakiye",
    "payouts.totalEarnings": "Toplam Kazanç",
    "payouts.pending": "Bekleyen",
    "payouts.requestPayout": "Çekim Yap",
    "payouts.createRequest": "Para Çekme Talebi",
    "payouts.requestDesc": "Kayıtlı ödeme yönteminize transfer başlatın.",
    "payouts.amount": "Tutar ($)",
    "payouts.minAmountShort": "Min: $50",
    "payouts.bankTransfer": "Banka Transferi",
    "payouts.paypal": "PayPal",
    "payouts.confirmRequest": "Talebi Onayla",
    "payouts.completedWithdrawals": "Tamamlanan Çekimler",
    "payouts.totalWithdrawn": "Toplam Çekilen",
    "payouts.transactionHistory": "İşlem Geçmişi",
    "payouts.paymentMethods": "Ödeme Yöntemleri",
    "payouts.recentTransactions": "Son İşlemler",
    "payouts.noTransactions": "Henüz İşlem Yok",
    "payouts.noTransactionsDesc": "Geçmiş ödeme talepleriniz burada listelenecektir.",
    "payouts.statusPaid": "Ödendi",
    "payouts.statusRequested": "Bekliyor",
    "payouts.noPaymentMethod": "Ödeme Yöntemi Bulunmuyor",
    "payouts.addMethodDesc": "Kazançlarınızı çekebilmek için bir ödeme yöntemi ekleyin.",
    "payouts.addMethod": "Yöntem Ekle",
    "payouts.verified": "Doğrulandı",
    "payouts.pendingVerification": "Doğrulama Bekliyor",
    "payouts.changeMethod": "Ödeme Yöntemini Değiştir",
    "payouts.methodDesc": "Kazançlarınızı alabilmek için ödeme yöntemi bilgilerinizi girin.",
    "payouts.bank": "Banka",
    "payouts.accountHolder": "Hesap Sahibi Adı",
    "payouts.bankName": "Banka Adı",
    "payouts.ibanOrAccount": "IBAN veya Hesap Numarası",
    "payouts.swiftBic": "SWIFT/BIC Kodu",
    "payouts.paypalEmail": "PayPal E-posta Adresi",
    "payouts.securityVerification": "Güvenlik Doğrulaması",
    "payouts.enterVerificationCodeDesc": "İşlemi onaylamak için e-posta adresinize gönderilen 6 haneli kodu girin.",
    "payouts.remainingAttempts": "Kalan deneme:",
    "payouts.sendNewCode": "Yeni Kod Gönder",
    "payouts.deleteMethod": "Yöntemi Sil",
    "payouts.deleteMethodConfirm": "Bu ödeme yöntemini silmek istediğinize emin misiniz?",
    
    // Viral Campaign
    "viral.tiktokName": "TikTok Kampanyası",
    "viral.instagramName": "Instagram Reels",
    "viral.twitterName": "Twitter/X Viral",
    "viral.campaignTitleFallback": "Viral Kampanya",
    "viral.campaignDescFallback": "Viral Kampanya",
    "viral.day": "Gün",
    "viral.activeCampaignsTitle": "Aktif Kampanyalar",
    "viral.campaignFallback": "Kampanya",
    "viral.activeStatus": "Aktif",

    // Mastering
    "mastering.presetStreaming": "Streaming (Spotify/Apple)",
    "mastering.presetYoutube": "Video (YouTube)",
    "mastering.presetCD": "CD Master",
    "mastering.presetClub": "Club / EDM",
    "mastering.presetAcoustic": "Akustik / Caz",
    "mastering.presetPodcast": "Podcast / Ses",
    "mastering.band": "Band",
    "mastering.loudness": "Ses Yüksekliği",
    "mastering.integratedLufs": "Entegre LUFS",
    "mastering.truePeak": "Gerçek Tepe",
    "mastering.dynamicRange": "Dinamik Aralık",
    "mastering.eq": "EQ",
    "mastering.bass": "Bas",
    "mastering.mid": "Orta",
    "mastering.treble": "Tiz",
    "mastering.processing": "İşleme",
    "mastering.stereoWidth": "Stereo Genişliği",
    "mastering.compression": "Sıkıştırma",
    "mastering.saturation": "Doygunluk",
    "mastering.additionalProcessing": "Ek İşleme",
    "mastering.deEsser": "De-Esser",
    "mastering.limiterCeiling": "Limiter Tavanı",
    "mastering.aiAnalyzing": "Yapay Zeka Analizi",
    "mastering.masteringProcessing": "Mastering İşleniyor",
    "mastering.analyzingDesc": "Ses analiz ediliyor...",
    "mastering.processingDesc": "Mastering uygulanıyor...",
    "mastering.brightness": "Parlaklık",

    // Subscription
    "subscription.freeDesc": "Müzik yolculuğuna başla",
    "subscription.artistDesc": "Ciddi sanatçılar için",
    "subscription.labelDesc": "Label ve yöneticiler için",
    "subscription.featFree1": "1 yayın (ömür boyu)",
    "subscription.featFree2": "%20 komisyon",
    "subscription.featFree3": "Standart teslimat (2-5 gün)",
    "subscription.featFree4": "E-posta desteği",
    "subscription.featArtist1": "Sınırsız yükleme",
    "subscription.featArtist2": "%0 komisyon",
    "subscription.featArtist3": "Hızlı teslimat (24-72sa)",
    "subscription.featArtist4": "Temel analitik",
    "subscription.featArtist5": "Split sistemi",
    "subscription.featArtist6": "Öncelikli e-posta desteği",
    "subscription.featLabel1": "Çoklu sanatçı yönetimi",
    "subscription.featLabel2": "Gelişmiş splits",
    "subscription.featLabel3": "Toplu yükleme",
    "subscription.featLabel4": "Gelişmiş analitik",
    "subscription.featLabel5": "Hızlı dağıtım",
    "subscription.featLabel6": "Öncelikli destek",

    // Common
    "common.loading": "Yükleniyor...",
    "common.save": "Kaydet",
    "common.cancel": "İptal",
    "common.delete": "Sil",
    "common.edit": "Düzenle",
    "common.submit": "Gönder",
    "common.back": "Geri",
    "common.next": "İleri",
    "common.previous": "Önceki",
    "common.search": "Ara",
    "common.filter": "Filtre",
    "common.all": "Tümü",
    "common.yes": "Evet",
    "common.no": "Hayır",
    "common.logout": "Çıkış Yap",
    "common.login": "Giriş Yap",
    "common.register": "Kayıt Ol",
    
    // Auth
    "auth.welcome": "Hoş Geldiniz",
    "auth.signIn": "Hesabınıza giriş yapın",
    "auth.email": "E-posta",
    "auth.password": "Şifre",
    "auth.loginButton": "Giriş Yap",
    "auth.noAccount": "Hesabınız yok mu? Davet linki ile kayıt olabilirsiniz.",
    "auth.loginSuccess": "Giriş başarılı",
    "auth.loginFailed": "Giriş başarısız",

    "auth.loginBtn": "GİRİŞ YAP",
    "auth.createAccount": "Hesap Oluştur",
    "auth.firstName": "Ad",
    "auth.lastName": "Soyad",
    "auth.accountType": "Hesap Türü",
    "auth.artist": "Sanatçı",
    "auth.label": "Plak Şirketi",
    "auth.address": "Adres",
    "auth.city": "Şehir",
    "auth.country": "Ülke",
    "auth.postalCode": "Posta Kodu",
    "auth.phone": "Telefon",
    "auth.currency": "Para Birimi",
    "auth.hasAccount": "Zaten hesabınız var mı?",
    "auth.registerBtn": "KAYIT OL",
    "auth.agreeTerms": "Hizmet Şartlarını ve Gizlilik Politikasını kabul ediyorum",
    "auth.registerSubtitle": "Müzik dağıtım platformuna katılın",
    "auth.individualArtist": "Bireysel sanatçı",
    "auth.recordLabel": "Plak şirketi",
    "auth.labelInformation": "Plak Şirketi Bilgileri",
    "auth.labelName": "Şirket Adı",
    "auth.labelDescription": "Şirket Açıklaması",
    "auth.website": "Web Sitesi",
    "auth.instagram": "Instagram",
    
    // Navigation
    "nav.dashboard": "Anasayfa",
    "nav.releases": "Yayınlar",
    "nav.payouts": "Ödemeler",
    "nav.support": "Destek",
    "nav.help": "Yardım & Rehber",
    "nav.analytics": "İstatistik",
    "nav.referrals": "Referanslar",
    "nav.subscription": "Abonelik",
    "nav.splits": "Gelir Paylaşımı",
    "nav.promotions": "Promosyonlar",
    "nav.profile": "Profil",
    "nav.playlistExplorer": "Playlist Keşfet",
    "nav.aiMatcher": "AI Eşleştirici",
    "nav.campaigns": "Kampanyalar",
    "nav.bioLink": "Bio Link",
    "nav.canvasStudio": "Canvas Studio",
    "nav.aiVideo": "AI Video",
    "nav.viralCampaign": "Viral Kampanya",
    "nav.aiStudio": "AI Stüdyo",
    "nav.aiMastering": "AI Mastering",
    "nav.mixMastering": "Mix Mastering",
    "nav.lyricsManager": "Şarkı Sözleri",
    "nav.contributors": "Katkıda Bulunanlar",
    "nav.aiAdvisor": "AI Danışman",
    "nav.connections": "Bağlantılar",
    "nav.preSave": "Ön Kayıt",
    "nav.smartLinks": "Akıllı Linkler",
    "nav.qrCodes": "QR Kod",
    "nav.collaborations": "Kolaborasyonlar",
    "nav.lyricsSync": "Şarkı Sözü Senk.",
    "nav.section.music": "Müzik",
    "nav.section.discover": "Keşfet",
    "nav.section.promotion": "Tanıtım",
    "nav.section.aiStudio": "AI Stüdyo",
    "nav.section.career": "Kariyer",
    "nav.section.finance": "Finans",
    "nav.section.growth": "Büyüme",
    "nav.section.marketing": "Pazarlama",
    "nav.section.tools": "Araçlar",
    "nav.section.community": "Topluluk",
    "nav.section.support": "Destek",
    "nav.logout": "Çıkış Yap",
    "nav.comingSoon": "Beta",
    "notifications.markAllRead": "Tümünü oku",
    "notifications.empty": "Bildirim yok",
    
    // Dashboard
    "dashboard.welcome": "Hoş Geldiniz",
    "dashboard.subtitle": "Müziğinizi yönetin, yayınlarınızı takip edin ve kazançlarınızı görüntüleyin.",
    "dashboard.totalReleases": "Toplam Yayın",
    "dashboard.totalTracks": "Toplam Parça",
    "dashboard.balance": "Mevcut Bakiye",
    "dashboard.withdrawable": "Çekilebilir",
    "dashboard.recentReleases": "Son Yayınlar",
    "dashboard.viewAll": "Tümünü Gör",
    "dashboard.topTracks": "En Çok Dinlenenler",
    "dashboard.recentActivities": "Son Aktiviteler",

    "dashboard.viewDetails": "Detayları Gör",
    "dashboard.viewAnalytics": "Analizlere Git",
    "upload.status": "Yükleme Durumu",
    "upload.none": "Yükleme Yok",
    "upload.noneDesc": "Şu anda devam eden bir yükleme bulunmuyor.",
    "auth.pendingApproval": "Onay Bekleniyor",
    "auth.pendingApprovalDesc": "Hesabınız yönetici onayı bekliyor. Onaylandığında portala erişebileceksiniz.",
    "auth.accountApproved": "Hesabınız onaylandı! / Your account has been approved!",
    "auth.accountRejected": "Hesabınız reddedildi. / Your account has been rejected.",
    "auth.accountPendingInfo": "Hesabınız hala onay bekliyor. / Your account is still pending approval.",
    "auth.invalidResetLink": "Geçersiz şifre sıfırlama linki",
    "auth.passwordLengthError": "Şifre en az 6 karakter olmalıdır",
    "auth.passwordsDoNotMatch": "Şifreler eşleşmiyor",
    "auth.passwordChangedSuccess": "Şifreniz başarıyla değiştirildi!",
    "auth.passwordResetFailed": "Şifre sıfırlama başarısız",
    "auth.passwordChanged": "Şifre Değiştirildi!",
    "auth.passwordChangedDesc": "Şifreniz başarıyla güncellendi. Yeni şifrenizle giriş yapabilirsiniz.",
    "auth.goToLogin": "Giriş Sayfasına Git",
    "auth.setNewPassword": "Yeni Şifre Belirle",
    "auth.setNewPasswordDesc": "Hesabınız için yeni bir şifre oluşturun.",
    "auth.newPassword": "Yeni Şifre",
    "auth.confirmPassword": "Şifreyi Onayla",
    "auth.changePassword": "Şifreyi Değiştir",
    "releases.release": "Yayın",
    "releases.artist": "Sanatçı",
    "releases.status": "Durum",
    "releases.date": "Tarih",
    "releases.actions": "İşlemler",
    "releases.deleteRelease": "Yayını Sil",
    "releases.noSearchMatch": "Arama kriterlerinize uygun yayın bulunamadı. Lütfen farklı anahtar kelimeler deneyin.",
    "releases.createFirst": "İlk müzik yayınınızı oluşturun ve tüm platformlarda dinleyicilerinizle buluşturun.",
    "releases.deleteReleaseConfirm": "{releaseName} adlı yayını silmek istediğinize emin misiniz?",
    "releases.cannotBeUndone": "Bu işlem geri alınamaz.",
    "metadata.copied": "{label} kopyalandı!",
    "metadata.copyFailed": "Kopyalama başarısız",
    "metadata.copy": "Kopyala",
    "metadata.downloaded": "{label} indirildi!",
    "metadata.downloadFailed": "İndirme başarısız",
    "metadata.dspCopied": "DSP özeti panoya kopyalandı!",
    "metadata.copyDsp": "DSP Özeti Kopyala",
    "metadata.noAudio": "Audio dosyası yüklenmemiş",
    "metadata.noCover": "Cover art yüklenmemiş",
    "dashboard.drafts": "Taslaklar",
    "dashboard.untitled": "İsimsiz Yayın",
    "dashboard.noGenre": "Tür yok",
    "dashboard.clickToEdit": "Düzenlemeye devam etmek için tıklayın",
    "dashboard.newRelease": "Yeni Yayın Oluştur",
    "dashboard.newReleaseDesc": "Müziğinizi dünyayla paylaşın",
    "dashboard.requestPayout": "Ödeme Talep Et",
    "dashboard.noReleases": "Henüz yayın yok",
    "dashboard.createFirst": "İlk yayınınızı oluşturarak başlayın.",
    "dashboard.greetingMorning": "Günaydın",
    "dashboard.greetingAfternoon": "İyi günler",
    "dashboard.greetingEvening": "İyi akşamlar",
    "dashboard.artist": "Sanatçı",
    "dashboard.lastLogin": "Son giriş",
    "dashboard.today": "Bugün",
    "dashboard.range7d": "7G",
    "dashboard.range30d": "30G",
    "dashboard.range90d": "90G",
    "dashboard.range1y": "1Y",
    "dashboard.rangeAll": "Tümü",
    "dashboard.income": "Gelir",
    "dashboard.liveReleases": "Canlı Yayın",
    "dashboard.last30days": "son 30 gün",
    "dashboard.inReview": "İncelemede",
    "dashboard.revenueAnalysis": "Gelir Analizi",
    "dashboard.platformFilter": "Platform Filtresi",
    "dashboard.totalRevenue": "Toplam Gelir",
    "dashboard.welcomeBack": "Tekrar hoş geldin",
    "dashboard.searchPlaceholder": "Ne yapmak istiyorsun?",
    "dashboard.totalEarnings": "Toplam Kazanç",
    "dashboard.availableBalance": "Kullanılabilir Bakiye",
    "dashboard.artistNetPay": "Split sonrası net pay",
    "dashboard.period6m": "6 Ay",
    "dashboard.period1y": "1 Yıl",
    "dashboard.periodAll": "Tümü",
    "dashboard.noEarnings": "Henüz kazanç kaydı bulunmuyor",
    "dashboard.noEarningsDesc": "Kazançlarınız eklendiğinde burada görüntülenecek.",
    "dashboard.setupTitle": "Hesap Kurulumunu Tamamla",
    "dashboard.stepProfile": "Sanatçı profilini tamamla",
    "dashboard.stepProfileDesc": "Adını, türünü ekle ve platformları bağla",
    "dashboard.stepPayoutProfile": "Ödeme profilini doğrula",
    "dashboard.stepPayoutProfileDesc": "Ödeme almak için bilgilerini tamamla",
    "dashboard.stepPayment": "Ödeme yöntemini bağla",
    "dashboard.stepPaymentDesc": "Banka veya PayPal hesabı ekle",
    "dashboard.stepRelease": "İlk yayınını yükle",
    "dashboard.stepReleaseDesc": "Müziğini dünyayla paylaş",
    "dashboard.stepConnections": "Platform bağlantılarını tamamla",
    "dashboard.stepConnectionsDesc": "Sosyal medya ve müzik platformlarını bağla",
    "dashboard.notifications": "Bildirimler",
    "dashboard.noNotifications": "Bildirim bulunmuyor",
    "dashboard.whatsHappening": "Neler Oluyor?",
    "dashboard.supportTickets": "Destek Talepleri",
    "dashboard.newTicket": "Yeni Talep",
    "dashboard.noTickets": "Açık destek talebiniz bulunmuyor",
    "dashboard.noTicketsDesc": "Yardıma ihtiyacınız olduğunda yeni bir talep oluşturabilirsiniz.",
    "dashboard.ticketOpen": "Açık",
    "dashboard.ticketPending": "Bekliyor",
    "dashboard.ticketWaiting": "Yanıt Bekliyor",
    "dashboard.ticketResolved": "Çözüldü",
    "dashboard.ticketClosed": "Kapatıldı",
    "dashboard.learnMore": "Detaylar",
    "dashboard.sectionError": "Veriler yüklenemedi",
    "dashboard.retry": "Tekrar Dene",
    "dashboard.justNow": "Az önce",
    "dashboard.minAgo": "dk önce",
    "dashboard.hrsAgo": "sa önce",
    "dashboard.yesterday": "Dün",
    "dashboard.daysAgo": "gün önce",
    "dashboard.catPlatform": "Platform",
    "dashboard.catDSP": "DSP Haberleri",
    "dashboard.catCampaign": "Kampanya",
    "dashboard.catEducation": "Eğitim",
    "dashboard.catGeneral": "Genel",
    "dashboard.liveStreamingMap": "Canlı Akış Haritası",
    "dashboard.live": "Canlı",
    "dashboard.noDataYet": "Henüz veri yok",
    "dashboard.streams": "dinlenme",
    "dashboard.wentLive": "Yayına alındı",
    "dashboard.rejected": "Reddedildi",
    "dashboard.inReview": "İnceleniyor",
    
    // Layout
    "layout.profile": "Profil",
    "layout.subscription": "Abonelik",
    "layout.logout": "Çıkış Yap",
    
    // QR Code Generator
    "qr.title": "QR Kod Oluşturucu",
    "qr.create": "QR Kod Oluştur",
    "qr.createTitle": "Yeni QR Kod",
    "qr.url": "URL",
    "qr.qrTitle": "Başlık",
    "qr.fgColor": "Ön Plan Rengi",
    "qr.bgColor": "Arka Plan Rengi",
    "qr.size": "Boyut",
    "qr.small": "Küçük",
    "qr.medium": "Orta",
    "qr.large": "Büyük",
    "qr.download": "İndir",
    "qr.delete": "Sil",
    "qr.scanCount": "Tarama",
    "qr.empty": "Henüz QR kod yok",
    "qr.emptyDesc": "İlk QR kodunuzu oluşturun.",
    
    // Smart Links
    "smartLinks.title": "Akıllı Linkler",
    "smartLinks.subtitle": "Müziğiniz için akıllı yönlendirme sayfaları oluşturun",
    "smartLinks.createBtn": "Akıllı Link Oluştur",
    "smartLinks.cover": "Kapak",
    "smartLinks.backgroundImage": "Arkaplan Görseli",
    "smartLinks.cancel": "İptal",
    "smartLinks.create": "Akıllı Link Oluştur",
    "smartLinks.linkTitle": "Başlık",
    "smartLinks.slug": "Özel URL Kısaltması",
    "smartLinks.platforms": "Platform Linkleri",
    "smartLinks.clicks": "Tıklama",
    "smartLinks.copy": "Linki Kopyala",
    "smartLinks.copied": "Kopyalandı!",
    "smartLinks.empty": "Henüz akıllı link yok",
    "smartLinks.emptyDesc": "Müziğinizi paylaşmak için ilk akıllı linkinizi oluşturun.",
    
    // Pre-Save Campaign
    "preSave.title": "Pre-Save Kampanyaları",
    "preSave.subtitle": "Yaklaşan yayınlarınız için ön kayıt kampanyaları oluşturun",
    "preSave.createNew": "Yeni Kampanya",
    "preSave.createBtn": "Kampanya Oluştur",
    "preSave.descPlaceholder": "Kampanya açıklaması...",
    "preSave.backgroundImage": "Arkaplan Görseli",
    "preSave.uploadBg": "Arkaplan Yükle",
    "preSave.bgHint": "Önerilen: 1920x1080px yatay görsel",
    "preSave.cancel": "İptal",
    "preSave.all": "Tümü",
    "preSave.pending": "Bekleyen",
    "preSave.approved": "Onaylanan",
    "preSave.rejected": "Reddedilen",
    "preSave.create": "Kampanya Oluştur",
    "preSave.selectRelease": "Yayın Seçin",
    "preSave.releaseDate": "Yayın Tarihi",
    "preSave.description": "Açıklama",
    "preSave.saves": "Kayıtlar",
    "preSave.daysLeft": "gün kaldı",
    "preSave.released": "Yayınlandı",
    "preSave.active": "Aktif",
    "preSave.copy": "Linki Kopyala",
    "preSave.empty": "Henüz pre-save kampanyası yok",
    "preSave.emptyDesc": "Yaklaşan yayınınız için pre-save kampanyası oluşturun.",
    
    // Email Marketing
    "email.title": "E-posta Pazarlama",
    "email.subscribers": "Aboneler",
    "email.campaigns": "Kampanyalar",
    "email.addSubscriber": "Abone Ekle",
    "email.name": "İsim",
    "email.emailAddr": "E-posta Adresi",
    "email.subject": "Konu",
    "email.template": "Şablon",
    "email.content": "İçerik",
    "email.send": "Gönder",
    "email.draft": "Taslak",
    "email.sent": "Gönderildi",
    "email.opened": "Açıldı",
    "email.clicked": "Tıklandı",
    "email.import": "CSV İçe Aktar",
    "email.export": "CSV Dışa Aktar",
    "email.empty": "Henüz veri yok",
    "email.totalSubscribers": "Toplam Abone",
    
    // Social Media Scheduler
    "social.title": "Sosyal Medya Planlayıcı",
    "social.newPost": "Yeni Gönderi",
    "social.content": "İçerik",
    "social.platforms": "Platformlar",
    "social.schedule": "Zamanla",
    "social.draft": "Taslak",
    "social.scheduled": "Zamanlandı",
    "social.published": "Yayınlandı",
    "social.edit": "Düzenle",
    "social.delete": "Sil",
    "social.calendar": "Takvim",
    "social.list": "Liste",
    "social.empty": "Henüz gönderi yok",
    "social.emptyDesc": "Sosyal medya gönderilerinizi planlayın.",
    
    // Press Kit
    "pressKit.title": "Basın Kiti (EPK)",
    "pressKit.bio": "Biyografi",
    "pressKit.photos": "Fotoğraflar",
    "pressKit.discography": "Diskografi",
    "pressKit.social": "Sosyal Medya Linkleri",
    "pressKit.contact": "İletişim Bilgileri",
    "pressKit.save": "Basın Kitini Kaydet",
    "pressKit.preview": "Önizleme",
    "pressKit.publicUrl": "Herkese Açık URL",
    "pressKit.empty": "Basın kitiniz boş",
    
    // Lyrics Sync
    "lyricsSync.title": "Şarkı Sözü Senkronizasyonu",
    "lyricsSync.subtitle": "Parçalarınız için zamanlı şarkı sözü oluşturun",
    "lyricsSync.lyricsEditor": "Şarkı Sözü Editörü",
    "lyricsSync.resetTimestamps": "Zaman Damgalarını Sıfırla",
    "lyricsSync.tapToSync": "Senkronlamak İçin Tıkla",
    "lyricsSync.timestamps": "Zaman Damgaları",
    "lyricsSync.save": "Şarkı Sözlerini Kaydet",
    "lyricsSync.synced": "Senkronlandı",
    "lyricsSync.selectTrack": "Parça Seçin",
    "lyricsSync.lyrics": "Sözler",
    "lyricsSync.sync": "Senkronize Et",
    "lyricsSync.tap": "Zamanla",
    "lyricsSync.preview": "Önizleme",
    "lyricsSync.export": "LRC Aktar",
    "lyricsSync.save": "Kaydet",
    "lyricsSync.empty": "Başlamak için parça seçin",
    
    // Collaborations
    "collab.title": "İş Birlikleri",
    "collab.subtitle": "Diğer sanatçıları davet edin ve projelerde iş birliği yapın",
    "collab.received": "Gelen",
    "collab.sent": "Gönderilen",
    "collab.reject": "Reddet",
    "collab.create": "Yeni Proje",
    "collab.invite": "Davet Et",
    "collab.projects": "Projelerim",
    "collab.invitations": "Davetler",
    "collab.accept": "Kabul Et",
    "collab.decline": "Reddet",
    "collab.notes": "Notlar",
    "collab.status": "Durum",
    "collab.empty": "Henüz iş birliği yok",
    "collab.emptyDesc": "Diğer sanatçılarla iş birliği projeleri başlatın.",
    "collab.send_invite": "Sanatçı Davet Et",
    "collab.email": "İsim veya e-posta ile arayın",
    "collab.type": "İş Birliği Türü",
    "collab.type_featured": "Feat. Sanatçı",
    "collab.type_producer": "Yapımcı",
    "collab.type_writer": "Söz Yazarı",
    "collab.type_remix": "Remix",
    "collab.message": "Mesaj",
    "collab.send": "Davet Gönder",
    "collab.no_received": "Henüz iş birliği yok",
    "collab.no_sent": "Henüz iş birliği yok",
    "collab.invite_success": "Davet başarıyla gönderildi!",
    "collab.invite_error": "Davet gönderilemedi",
    "collab.accepted": "Kabul Edildi",
    "collab.rejected": "Reddedildi",
    "collab.respond_error": "Davete yanıt verilemedi",
    "collab.delete_confirm": "Bunu silmek istediğinizden emin misiniz?",
    "collab.delete_success": "İş birliği silindi",
    "collab.delete_error": "İş birliği silinemedi",
    "collab.error_fetch": "İş birliği yüklenemedi",
    "collab.status_accepted": "Aktif",
    "collab.status_rejected": "Reddedildi",
    "collab.status_pending": "Beklemede",
    
    // Notification translations

    "notif.release_status.title": "Yayın Durumu Güncellendi",
    "notif.release_status.approved.title": "Yayın Onaylandı",
    "notif.release_status.approved.message": "Yayınınız onaylandı.",
    "notif.release_status.rejected.title": "Yayın Reddedildi",
    "notif.release_status.rejected.message": "Yayınınız reddedildi.",
    "notif.release_status.live.title": "Yayın Aktif",
    "notif.release_status.live.message": "Yayınınız artık aktif.",
    "notif.release_status.needs_edits.title": "Düzenleme Gerekli",
    "notif.release_status.needs_edits.message": "Yayınınız onaylanmadan önce bazı düzenlemeler gerekiyor.",
    "notif.release_status.in_review.title": "Yayın İnceleniyor",
    "notif.release_status.in_review.message": "Yayınınız inceleniyor.",
    "notif.release_status.taken_down.title": "Yayın Kaldırıldı",
    "notif.release_status.taken_down.message": "Yayınınız kaldırıldı.",
    "notif.release_deleted.title": "Yayın Silindi",
    "notif.release_deleted.message": "Bir yayın kaldırıldı.",
    "notif.account_status.title": "Hesap Durumu",
    "notif.account_status.approved.title": "Hesap Onaylandı",
    "notif.account_status.rejected.title": "Hesap Reddedildi",
    "notif.referral_bonus.title": "Referans Bonusu Alındı!",
    "notif.referral_bonus.message": "Referans bonusu aldınız.",
    "notif.payout_status.title": "Ödeme Güncellendi",
    "notif.payout_status.approved.title": "Ödeme Onaylandı",
    "notif.payout_status.rejected.title": "Ödeme Reddedildi",
    "notif.payout_status.completed.title": "Ödeme Tamamlandı",
    "notif.payout_status.message": "Ödeme talebiniz güncellendi.",
    "notif.ticket_reply.title": "Yeni Destek Yanıtı",
    "notif.ticket_reply.message": "Destek talebinize yeni bir yanıt verildi.",
    "notif.announcement.title": "Yeni Duyuru",
    "notif.spotify_linked.title": "Spotify Profili Bağlandı",
    "notif.spotify_linked.message": "Sanatçı profiliniz Spotify'a bağlandı. İstatistikler artık kullanılabilir.",
    "notif.artist_needs_spotify.title": "Sanatçının Spotify Bağlantısı Gerekiyor",
    "notif.split_response.title": "Split Yanıtı",
    "notif.split_response.accepted": "kabul etti",
    "notif.split_response.rejected": "reddetti",
    "notif.revenue_added.title": "Gelir Eklendi",
    "notif.kyc_submission.title": "Yeni KYC Başvurusu",
    "notif.kyc_review.title": "Kimlik Doğrulama",
    "notif.kyc_review.approved.message": "Kimlik doğrulamanız onaylandı!",
    "notif.kyc_review.rejected.message": "Kimlik doğrulamanız reddedildi.",
    "notif.playlist_campaign.title": "Yeni Playlist Başvurusu",
    "notif.playlist_campaign_approved.title": "Playlist Başvurusu Onaylandı",
    "notif.playlist_campaign_approved.message": "Playlist başvurunuz onaylandı.",
    "notif.playlist_campaign_rejected.title": "Playlist Başvurusu Reddedildi",
    "notif.playlist_campaign_rejected.message": "Playlist başvurunuz reddedildi.",
    "notif.reason": "Sebep",

        // Fan Engagement
    "fanScore.title": "Fan Etkileşimi",
    "fanScore.subtitle": "Dinleyici etkileşimi ve büyüme metriklerini takip edin",
    "fanScore.overall": "Genel Skor",
    "fanScore.streaming": "Dinlenme",
    "fanScore.social": "Sosyal Erişim",
    "fanScore.loyalty": "Fan Sadakati",
    "fanScore.activity": "İçerik Aktivitesi",
    "fanScore.trend": "Haftalık Trend",
    "fanScore.last12weeks": "Son 12 hafta",
    "fanScore.now": "Şimdi",
    "fanScore.platforms": "Platform Dağılımı",
    "fanScore.platformHint": "Platform bazlı skor",
    "fanScore.tips": "AI Önerileri",
    "fanScore.noData": "Henüz etkileşim verisi yok.",
    "fanScore.noDataHint": "Müzik yayınlayıp dinleyici kitlenizi büyütün.",
    
    // Copyright Scan
    "copyright.title": "Telif Hakkı Taraması",
    "copyright.newScan": "Yeni Tarama",
    "copyright.upload": "Dosya Yükle",
    "copyright.selectTrack": "Parça Seç",
    "copyright.scanning": "Taranıyor...",
    "copyright.clean": "Temiz",
    "copyright.warning": "Uyarı",
    "copyright.flagged": "İşaretlendi",
    "copyright.matches": "Eşleşmeler",
    "copyright.similarity": "Benzerlik",
    "copyright.empty": "Henüz tarama yok",
    "copyright.emptyDesc": "Parçalarınızı telif sorunları için tarayın.",
    
    // Releases
    "releases.title": "Yayınlar",
    "releases.createNew": "Yeni Yayın",
    "releases.noReleases": "Henüz yayın yok",
    "releases.searchPlaceholder": "Yayın ara...",
    
    // Analytics
    "analytics.title": "İstatistikler",
    "analytics.subtitle": "Yayınlarınızın performansını takip edin",
    "analytics.totalStreams": "Toplam Dinlenme",
    "analytics.listeners": "Dinleyici",
    "analytics.estimatedEarnings": "Tahmini Kazanç",
    "analytics.monthlyGrowth": "Bu Ay Büyüme",
    "analytics.streamsChart": "Dinlenme Grafiği",
    "analytics.platformDistribution": "Platform Dağılımı",
    "analytics.topTracks": "En Popüler Parçalar",
    "analytics.trackName": "Parça İsmi",
    "analytics.streams": "dinlenme",
    "analytics.comingSoonTitle": "Çok Yakında",
    "analytics.comingSoonDesc": "Detaylı istatistikler ve analizler yakında kullanıma sunulacak. artist.tools entegrasyonu ile tüm platform verilerinizi tek yerden takip edebileceksiniz.",
    "analytics.performance": "Performans",
    "analytics.noDataTitle": "Henüz Veri Yok",
    "analytics.noDataDesc": "Yayınlarınız YouTube veya Spotify'da takip edilmeye başlandığında istatistikleriniz burada görünecek.",
    "analytics.contactAdmin": "YouTube videolarınızı veya Spotify sanatçı profilinizi bağlamak için admin ile iletişime geçin.",
    "analytics.totalViews": "Toplam İzlenme",
    "analytics.totalLikes": "Toplam Beğeni",
    "analytics.totalComments": "Toplam Yorum",
    "analytics.trackedVideos": "Takip Edilen Video",
    "analytics.daily": "Günlük",
    "analytics.weekly": "Haftalık",
    "analytics.topVideos": "En Çok İzlenen Videolar",
    "analytics.totalFollowers": "Toplam Takipçi",
    "analytics.monthlyListeners": "Aylık Dinleyici",
    "analytics.linkedArtists": "Bağlı Sanatçılar",
    "analytics.avgPopularity": "Ort. Popülerlik",
    "analytics.linkedSpotifyArtists": "Bağlı Spotify Sanatçıları",
    "analytics.followers": "takipçi",
    "analytics.popularity": "popülerlik",
    "analytics.advancedTitle": "Gelişmiş İstatistikler Çok Yakında",
    "analytics.advancedDesc": "Detaylı dinlenme sayıları, coğrafi dağılım ve gelir analizleri yakında kullanılabilir olacak.",
    
    // Payouts
    "payouts.title": "Kazançlarınızı Yönetin",
    "payouts.subtitle": "Müziğinizden elde ettiğiniz geliri kolayca çekin. Minimum $50 ile ödeme talep edebilirsiniz.",
    "payouts.fastPayment": "Hızlı ödeme",
    "payouts.secureTransfer": "Güvenli transfer",
    "payouts.totalBalance": "Toplam Bakiye",
    "payouts.withdrawableBalance": "Çekilebilir",
    "payouts.requestPayout": "Ödeme Talep Et",
    "payouts.payoutHistory": "Ödeme Geçmişi",
    "payouts.noPayouts": "Henüz ödeme talebi yok",
    "payouts.noPaymentMethod": "Ödeme Yöntemi Yok",
    "payouts.addMethodDesc": "Kazançlarınızı çekebilmek için bir ödeme yöntemi eklemeniz gerekiyor.",
    "payouts.addMethod": "Ödeme Yöntemi Ekle",
    "payouts.changeMethodVerification": "Mevcut ödeme yönteminizi değiştirmek için e-posta doğrulaması gerekecektir",
    "payouts.availableBalance": "Kullanılabilir Bakiye",
    "payouts.pendingBalance": "Bekleyen Bakiye",
    "payouts.withdrawalHistory": "Çekim Geçmişi",
    "payouts.requestWithdrawal": "Çekim Talep Et",
    "payouts.minWithdrawal": "Minimum çekim: $50",
    
    // Support
    "support.title": "Size Nasıl Yardımcı Olabiliriz?",
    "support.subtitle": "EAM Music ekibi olarak sorularınızı yanıtlamak ve size en iyi hizmeti sunmak için buradayız. Destek talebinizi oluşturun, en kısa sürede size dönüş yapalım.",
    "support.responseTime": "24 saat içinde yanıt",
    "support.professional": "Profesyonel destek",
    "support.tickets": "Destek Talepleri",
    "support.createTicket": "Talep Oluştur",
    "support.noTickets": "Henüz destek talebi yok",
    
    // Referrals
    "referrals.title": "Referans Programı",
    "referrals.commission5": "%5 Komisyon",
    "referrals.lifetimeEarnings": "Ömür Boyu Kazanç",
    "referrals.copiedBtn": "Kopyalandı",
    "referrals.copyBtn": "Kopyala",
    "referrals.invitedUsersDesc": "Platforma kazandırdığınız kişiler ve durumları",
    "referrals.subtitle": "Arkadaşlarınızı EAM Music'e davet edin ve onların kazançlarından %5 komisyon kazanın. Ne kadar çok davet ederseniz, o kadar çok kazanırsınız!",
    "referrals.commission": "%5 Komisyon",
    "referrals.lifetime": "Ömür Boyu Kazanç",
    "referrals.totalInvites": "Toplam Davet",
    "referrals.activeReferrals": "Aktif Referanslar",
    "referrals.totalEarnings": "Toplam Kazanç",
    "referrals.yourLink": "Referans Linkiniz",
    "referrals.yourCode": "Referans Kodunuz",
    "referrals.copy": "Kopyala",
    "referrals.copied": "Kopyalandı!",
    "referrals.link": "Referans Linki",
    "referrals.code": "Referans Kodu",
    "referrals.invitedUsers": "Davet Edilen Kullanıcılar",
    "referrals.startSharing": "Kazanmaya başlamak için referans linkinizi paylaşın!",
    "referrals.registerDate": "Kayıt Tarihi",
    "referrals.active": "Aktif",
    "referrals.pending": "Bekliyor",
    "referrals.commissionRate": "Komisyon Oranı",
    "referrals.totalReferrals": "Toplam Davet",
    "referrals.noReferrals": "Henüz davet yok",
    "referrals.howItWorks": "Nasıl Çalışır?",
    "referrals.howItWorksDesc": "💡 Bu linki arkadaşlarınızla paylaşın. Linkinizle kayıt olan her sanatçının kazançlarından %5 komisyon kazanırsınız!",
    "referrals.earnBonus": "Her davet için bonus",
    "referrals.noLimit": "Limit yok",
    
    // Releases extras
    "releases.myReleases": "Yayınlarım",
    "releases.manageAll": "Tüm yayınlarınızı yönetin",
    "releases.tracks": "parça",
    "releases.noResults": "Sonuç bulunamadı",
    "releases.tryDifferent": "Arama kriterlerinizi değiştirmeyi deneyin.",
    "releases.deleteDraft": "Taslak Sil",
    "releases.deleteDraftMsg": "Bu taslak yayın kalıcı olarak silinecektir. Bu işlem geri alınamaz.",
    "releases.removeFromQueue": "İnceleme Kuyruğundan Çıkar",
    "releases.removeFromQueueMsg": "Bu yayın inceleme kuyruğundan çıkarılacak. Tekrar göndermek için yeniden submit etmeniz gerekecek.",
    "releases.takedown": "Yayını Kaldır (Takedown)",
    "releases.takedownMsg": "⚠️ DİKKAT: Bu yayın tüm mağazalardan kaldırılacaktır! Bu işlem 7 güne kadar sürebilir.",
    "releases.delete": "Yayını Sil",
    "releases.deleteMsg": "Bu yayın silinecektir.",
    "releases.yesRemove": "Evet, Kaldır",
    "releases.localTime": "Yerel",
    "releases.globalTime": "Global",
    "releases.records": "kayıt",
    "releases.allReleases": "Tüm Yayınlar",
    "releases.drafts": "Taslaklar",
    "releases.filter": "Filtrele",
    "releases.sort": "Sırala",
    "releases.newest": "En Yeni",
    "releases.oldest": "En Eski",
    "releases.nameAZ": "İsim (A-Z)",
    "releases.nameZA": "İsim (Z-A)",
    "releases.inReview": "İncelemede",
    "releases.approved": "Onaylananlar",
    "releases.scheduled": "Planlananlar",
    "releases.live": "Yayında",
    "releases.tableTitle": "Başlık",
    "releases.tableTracks": "Parça",
    "releases.tableArtist": "Sanatçı",
    "releases.tableLastUpdate": "Son Güncelleme",
    "releases.tableProgress": "İlerleme",
    "releases.tableActions": "İşlemler",
    "releases.releaseDate": "Yayın Tarihi",
    "releases.untitled": "İsimsiz Yayın",
    "releases.deleteFailed": "Silme başarısız oldu",
    
    // Payouts extras
    "payouts.manageEarnings": "Kazançlarınızı yönetin",
    "payouts.createRequest": "Ödeme Talebi Oluştur",
    "payouts.amount": "Tutar",
    "payouts.accountHolder": "Hesap Sahibi Adı",
    "payouts.bankName": "Banka Adı",
    "payouts.minAmount": "Minimum çekim tutarı $50'dır",
    "payouts.insufficientBalance": "Yetersiz bakiye",
    "payouts.fillRequired": "Lütfen tüm zorunlu alanları doldurun",
    "payouts.requestCreated": "Çekim talebi oluşturuldu",
    "payouts.requestFailed": "Talep oluşturulamadı",
    "payouts.minNotMet": "Minimum tutar karşılanmadı",
    "payouts.minNotMetMsg": "Ödeme talebi oluşturabilmek için en az $50 çekilebilir bakiyeniz olmalıdır.",
    "payouts.statusRequested": "Talep Edildi",
    "payouts.statusPaid": "Ödendi",
    "payouts.paymentMethod": "Ödeme Yöntemi",
    "payouts.bankTransfer": "Banka Transferi",
    "payouts.paypalEmail": "PayPal E-posta",
    "payouts.paypalNote": "PayPal hesabınızla ilişkili e-posta adresini girin",
    "payouts.fillPaypalRequired": "Lütfen PayPal e-posta ve hesap sahibi adını girin",
    "payouts.selectCountry": "Ülkenizi seçin",
    "payouts.tabProfile": "Ödeme Profili",
    "payouts.tabMethod": "Ödeme Yöntemi",
    "payouts.tabRequests": "Çekim Talepleri",
    "payouts.requirements": "Çekim Talebi İçin Gereklilikler",
    "payouts.completeProfile": "Ödeme profilinizi tamamlayın (Kimlik ve Adres bilgileri)",
    "payouts.addPaymentMethod": "Bir ödeme yöntemi ekleyin (Banka veya PayPal)",
    "payouts.verifyPaymentMethod": "Ödeme yönteminizi doğrulayın",
    "payouts.profileComplete": "Tamamlandı",
    "payouts.savedProfile": "Kayıtlı Profil Bilgileri",
    "payouts.fullName": "Ad Soyad",
    "payouts.phoneNumber": "Telefon",
    "payouts.location": "Konum",
    "payouts.profileType": "Profil Türü",
    "payouts.individual": "Bireysel",
    "payouts.business": "İşletme / Şirket",
    "payouts.edit": "Düzenle",
    "payouts.firstName": "Adınız",
    "payouts.lastName": "Soyadınız",
    "payouts.displayName": "Görünen İsim",
    "payouts.companyName": "Şirket Adı",
    "payouts.saveProfile": "Profili Kaydet",
    "payouts.saving": "Kaydediliyor...",
    "payouts.changeMethod": "Ödeme Yöntemi Değiştir",
    "payouts.phoneRequired": "Telefon numarası zorunludur",
    "payouts.operationFailed": "İşlem başarısız",
    "payouts.verificationSent": "Doğrulama kodu e-posta adresinize gönderildi",
    "payouts.maxAttemptsReached": "Maksimum deneme sayısına ulaştınız. Lütfen yeni kod isteyin.",
    "payouts.methodUpdated": "Ödeme yönteminiz başarıyla güncellendi",
    "payouts.verificationFailed": "Doğrulama başarısız",
    "payouts.newCodeSent": "Yeni doğrulama kodu gönderildi",
    "payouts.codeSendFailed": "Kod gönderilemedi",
    "payouts.weeklyLimitReached": "Bu hafta çekim limitinize ulaştınız (2/2). Gelecek hafta tekrar deneyiniz.",
    "payouts.profileMethodRequired": "Çekim talebi oluşturmak için profil ve ödeme yöntemi tamamlanmalıdır",
    "payouts.methodSaved": "Ödeme yöntemi kaydedildi",
    "payouts.methodDeleted": "Ödeme yöntemi silindi",
    "payouts.paymentComplete": "Ödemeniz tamamlandı",
    "payouts.paymentApproved": "Ödemeniz onaylandı",
    "payouts.transferComplete": "Transfer başarıyla gerçekleştirildi",
    "payouts.bankAccount": "Banka Hesabı",
    "payouts.ibanSwift": "IBAN / Swift",
    "payouts.accountNumber": "Hesap Numarası",
    "payouts.enterAccountNumber": "Hesap numarası",
    "payouts.securityNotice": "Güvenlik Bildirimi",
    "payouts.securityNoticeDesc": "Ödeme yönteminizdeki tüm değişiklikler e-posta doğrulaması gerektirir (2 dakika geçerli). Sadece tek bir ödeme yöntemi kaydedebilirsiniz.",
    "payouts.completeProfileFirst": "Önce Profil Tamamlayın",
    "payouts.completeProfileFirstDesc": "Ödeme yöntemi eklemek için önce ödeme profilinizi tamamlamanız gerekiyor.",
    "payouts.completeProfileBtn": "Profili Tamamla",
    "payouts.requirementsNotMet": "Gereklilikler karşılanmadı",
    "payouts.minBalanceRequired": "Minimum $50 çekilebilir bakiye gereklidir.",
    "payouts.completeProfileRequired": "Ödeme profilinizi tamamlayın.",
    "payouts.addVerifyMethodRequired": "Ödeme yönteminizi ekleyin ve doğrulayın.",
    "payouts.weeklyWithdrawalLimit": "Haftalık Çekim Limiti",
    "payouts.withdrawalsMadeThisWeek": "Bu hafta {count} / 2 çekim yapıldı",
    "payouts.weeklyLimitReachedMsg": "Bu hafta çekim limitinize ulaştınız. Gelecek hafta tekrar çekim yapabilirsiniz.",
    "payouts.verified": "Doğrulanmış",
    "payouts.pendingVerification": "Doğrulama Bekliyor",
    "payouts.change": "Değiştir",
    "payouts.changePaymentMethod": "Ödeme Yöntemi Değiştir",
    "payouts.deletePaymentMethod": "Ödeme Yöntemi Sil",
    "payouts.deleteMethodConfirm": "Bu ödeme yöntemini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    "payouts.cancel": "İptal",
    "payouts.identityInfo": "Kimlik Bilgileri",
    "payouts.identityInfoDesc": "Yasal kimlik bilgileriniz fatura ve ödeme uyumluluğu için kullanılacaktır",
    "payouts.profileTypeLabel": "Profil Türü",
    "payouts.individualOption": "Bireysel",
    "payouts.individualOptionDesc": "Şahıs olarak gelir elde ediyorum",
    "payouts.businessOption": "İşletme / Şirket",
    "payouts.businessOptionDesc": "Şirket adına gelir elde ediyorum",
    "payouts.companyInfo": "Şirket Bilgileri",
    "payouts.companyTitle": "Şirket Ünvanı",
    "payouts.registrationNumber": "Ticaret Sicil No",
    "payouts.vatNumber": "KDV/Vergi No",
    "payouts.legalFirstName": "Yasal Ad",
    "payouts.legalLastName": "Yasal Soyad",
    "payouts.displayNameOptional": "Görünen Ad (Opsiyonel)",
    "payouts.email": "E-posta (Hesap E-postası)",
    "payouts.emailChangeNote": "E-posta adresi hesap ayarlarından değiştirilebilir",
    "payouts.addressInfo": "Adres Bilgileri",
    "payouts.country": "Ülke",
    "payouts.city": "Şehir",
    "payouts.stateOptional": "İl/Bölge (Opsiyonel)",
    "payouts.postalCode": "Posta Kodu",
    "payouts.addressLine1": "Adres Satırı 1",
    "payouts.addressLine2Optional": "Adres Satırı 2 (Opsiyonel)",
    "payouts.taxInfo": "Vergi Bilgileri",
    "payouts.taxRequired": "Çekim için zorunlu",
    "payouts.taxInfoDesc": "Çekim talebi oluşturabilmek için vergi bilgilerinizi doldurmanız zorunludur",
    "payouts.taxStatus": "Vergi Durumu",
    "payouts.taxStatusPersonal": "Bireysel vergi numarası (TCKN)",
    "payouts.taxStatusCompany": "Şirket / Vergi Kimlik No",
    "payouts.taxStatusRequired": "Çekim talebi için vergi durumu seçmeniz zorunludur",
    "payouts.taxIdCompany": "Vergi Kimlik No",
    "payouts.taxIdPersonal": "TC Kimlik No",
    "payouts.taxCountry": "Vergi Ülkesi",
    "payouts.savedTaxId": "Kayıtlı",
    "payouts.fullAddress": "Tam Adres",
    "payouts.taxInfoDisplay": "Vergi Bilgisi",
    "payouts.companyTax": "Şirket",
    "payouts.personalTax": "Bireysel",
    "payouts.profileIncomplete": "Profil Eksik",
    "payouts.profileIncompleteDesc": "Lütfen zorunlu alanları doldurun",
    "payouts.paymentCurrency": "Ödeme Para Birimi",
    "payouts.paymentCurrencyDesc": "Ödemelerin hangi para biriminde gönderilmesini istediğinizi seçin",
    "payouts.paypalEmailRequired": "PayPal E-posta Adresi",
    "payouts.paymentToAccount": "Ödeme Yapılacak Hesap",
    "payouts.requestRejected": "Çekim talebiniz reddedildi",
    "payouts.rejectionReason": "Sebep",
    "payouts.paymentCompleteMsg": "Ödemeniz tamamlandı",
    "payouts.paymentApprovedMsg": "Ödemeniz onaylandı",
    "payouts.transferCompleteMsg": "Transfer başarıyla gerçekleştirildi",
    "payouts.paymentInProgress": "2-3 iş günü içerisinde bankanızda olacak",
    "payouts.nameAndSurnameRequired": "Ad ve soyad zorunludur",
    "payouts.addressRequired": "Adres bilgileri zorunludur (Ülke, Şehir, Posta Kodu, Adres)",
    "payouts.profileSaved": "Ödeme profili kaydedildi",
    "payouts.profileSaveFailed": "Profil kaydedilemedi",
    "payouts.accountHolderCountryRequired": "Hesap sahibi adı ve ülke zorunludur",
    "payouts.bankNameRequired": "Banka adı zorunludur",
    "payouts.swiftRequired": "SWIFT/BIC kodu zorunludur",
    "payouts.ibanRequired": "IBAN zorunludur",
    "payouts.accountNumberRequired": "Hesap numarası zorunludur",
    "payouts.paypalEmailRequiredMsg": "PayPal e-posta adresi zorunludur",
    "payouts.withdrawRequestFailed": "Çekim talebi oluşturmak için profil ve ödeme yöntemi tamamlanmalıdır",
    "payouts.minWithdrawalAmount": "Minimum çekim tutarı $50",
    "payouts.insufficientBalanceMsg": "Yetersiz bakiye",
    "payouts.withdrawRequestCreated": "Çekim talebi oluşturuldu",
    "payouts.withdrawRequestFailedMsg": "Çekim talebi başarısız",
    "payouts.enterVerificationCode": "6 haneli doğrulama kodunu girin",
    "payouts.selectCountryPlaceholder": "Ülke seçin",
    
    // Wizard TR
    "wizard.editRelease": "Yayını Düzenle",
    "wizard.newSingleRelease": "Yeni Tekli Yayın",
    "wizard.completeSectionsToSubmit": "Yayınınızı göndermek için tüm bölümleri tamamlayın",
    "wizard.editAlbum": "Albümü Düzenle",
    "wizard.newEpAlbum": "Yeni EP / Albüm",
    "wizard.completeSectionsToSubmitAlbum": "Tüm bölümleri tamamlayarak albümünüzü gönderin",
    "wizard.sections.albumInfo": "Albüm Bilgileri",
    "wizard.sections.tracks": "Parçalar",
    "wizard.sections.releaseSettings": "Yayın Ayarları",
    "wizard.sections.moreOptions": "Ek Seçenekler",
    "wizard.sections.review": "İnceleme",
    "wizard.selectPRO": "PRO seçin",
    
    // Album wizard specific TR
    "wizard.album.title": "Albüm Başlığı",
    "wizard.album.titlePlaceholder": "Albüm başlığını girin",
    "wizard.album.titleRequired": "Albüm başlığı zorunludur",
    "wizard.album.titleLanguage": "Başlık Dili",
    "wizard.album.version": "Versiyon",
    "wizard.album.versionPlaceholder": "örn. Deluxe Edition",
    "wizard.album.primaryGenre": "Ana Tür",
    "wizard.album.subGenre": "Alt Tür",
    "wizard.album.selectGenre": "Tür seçin",
    "wizard.album.selectSubGenre": "Önce ana tür seçin",
    "wizard.album.genreRequired": "Ana tür seçimi zorunludur",
    "wizard.album.primaryArtists": "Ana Sanatçılar",
    "wizard.album.addArtist": "Sanatçı ekle",
    "wizard.album.artistRequired": "En az bir ana sanatçı zorunludur",
    "wizard.album.recordLabel": "Plak Şirketi",
    "wizard.album.recordLabelPlaceholder": "Plak şirketi adı (opsiyonel)",
    "wizard.album.coverArt": "Kapak Görseli",
    "wizard.album.coverRequired": "Kapak görseli zorunludur",
    "wizard.album.coverRequirements": "Kapak Gereksinimleri",
    "wizard.album.squareFormat": "Kare format (1:1 oran)",
    "wizard.album.minResolution": "Minimum 1400x1400 piksel (3000x3000 önerilir)",
    "wizard.album.maxFileSize": "Maksimum 20MB",
    "wizard.album.jpgPng": "JPG veya PNG format",
    "wizard.album.uploadCover": "Kapak Görseli Yükle",
    "wizard.album.uploading": "Yükleniyor...",
    "wizard.album.distribution": "Dağıtım",
    "wizard.album.newRelease": "Yeni Yayın",
    "wizard.album.newReleaseDesc": "Bu yepyeni bir yayındır",
    "wizard.album.transfer": "Başka Dağıtımcıdan Transfer / Daha Önce Yayınlanmış",
    "wizard.album.transferDesc": "Bu içerik daha önce başka bir dağıtımcı üzerinden yayınlanmıştı",
    "wizard.album.existingUpc": "Mevcut UPC Kodu",
    "wizard.album.upcPlaceholder": "Mevcut UPC kodunu girin",
    "wizard.album.originalReleaseDate": "Orijinal Yayın Tarihi",
    "wizard.album.minTracks": "EP/Albüm için en az 2 parça gereklidir",
    "wizard.album.addTrack": "Parça Ekle",
    "wizard.album.untitled": "Başlıksız Albüm",
    "wizard.album.errorsFound": "Hata Bulundu",
    "wizard.album.fixErrors": "Hataları Düzelt",
    "wizard.album.readyToSubmit": "Albüm Gönderime Hazır",
    "wizard.album.allComplete": "Tüm bölümler tamamlandı. Albümünüz incelemeye gönderilebilir.",
    "wizard.album.submitAlbum": "Albümü Gönder",
    "wizard.album.saveDraft": "Taslak Kaydet",
    "wizard.album.errorsDetected": "Hata Tespit Edildi",
    "wizard.album.fixBeforeSubmit": "Albümünüzü göndermeden önce aşağıdaki hataları düzeltmeniz gerekiyor:",
    "wizard.album.loadFailed": "Albüm yüklenemedi",
    "wizard.album.distributionPlatforms": "Dağıtım Platformları",
    
    // Track related TR
    "wizard.track.title": "Parça Başlığı",
    "wizard.track.titlePlaceholder": "Parça başlığını girin",
    "wizard.track.titleRequired": "Parça başlığı zorunludur",
    "wizard.track.titleLanguage": "Başlık Dili",
    "wizard.track.trackLanguage": "Parça Dili",
    "wizard.track.languageDesc": "Şarkı sözlerinin veya vokalin dili",
    "wizard.track.version": "Versiyon",
    "wizard.track.versionPlaceholder": "örn. Deluxe Edition, Acoustic, Remix",
    "wizard.track.versionDesc": "Versiyon bilgisi: Acoustic, Live, Remix vb.",
    "wizard.track.primaryGenre": "Ana Tür",
    "wizard.track.subGenre": "Alt Tür",
    "wizard.track.primaryArtists": "Ana Sanatçılar",
    "wizard.track.featuredArtists": "Konuk Sanatçılar",
    "wizard.track.add": "Ekle",
    "wizard.track.explicit": "Açık İçerik",
    "wizard.track.explicitNone": "Yok",
    "wizard.track.explicitYes": "Evet, açık içerik var",
    "wizard.track.explicitCleaned": "Temizlenmiş versiyon",
    "wizard.track.isRadioEdit": "Radyo Edit",
    "wizard.track.radioEditDesc": "Radyo yayını için kısaltılmış veya düzenlenmiş",
    "wizard.track.instrumental": "Enstrümantal",
    "wizard.track.instrumentalDesc": "Vokal içermiyor",
    "wizard.track.isrcCode": "ISRC Kodu",
    "wizard.track.useExistingIsrc": "Mevcut ISRC Kullan",
    "wizard.track.isrcPlaceholder": "örn. USRC11234567",
    "wizard.track.audioFile": "Ses Dosyası",
    "wizard.track.audioRequired": "Ses dosyası zorunludur",
    "wizard.track.uploadAudio": "Ses Dosyası Yükle",
    "wizard.track.audioFormats": "WAV veya FLAC • 44.1-96kHz • 16/24 bit",
    "wizard.track.recordLabel": "Plak Şirketi",
    "wizard.track.albumRecordLabel": "Albüm genelinde aynı plak şirketi kullanılır. 1. parçada değiştirin.",
    "wizard.track.credits": "Kredi Bilgileri",
    "wizard.track.songwriters": "Söz Yazarları",
    "wizard.track.addSongwriter": "Söz Yazarı Ekle",
    "wizard.track.role": "Rol",
    "wizard.track.name": "İsim",
    "wizard.track.composer": "Besteci",
    "wizard.track.lyricist": "Söz Yazarı",
    "wizard.track.composerLyricist": "Besteci & Söz Yazarı",
    "wizard.track.contributors": "Katkıda Bulunanlar",
    "wizard.track.addContributor": "Katkıda Bulunan Ekle",
    "wizard.track.productionTeam": "Prodüksiyon Ekibi",
    "wizard.track.addProduction": "Prodüksiyon Kredisi Ekle",
    "wizard.track.lyrics": "Şarkı Sözleri",
    "wizard.track.lyricsLanguage": "Şarkı Sözü Dili",
    "wizard.track.lyricsPlaceholder": "Şarkı sözlerini buraya yazın...",
    "wizard.track.lyricsOptional": "Şarkı Sözleri (Opsiyonel)",
    "wizard.track.lyricsDesc": "Şarkı sözleri DSP'lerde görüntülenebilir (Apple Music, Spotify vb.)",
    "wizard.track.licenseRequired": "Lisans Belgesi Zorunlu",
    "wizard.track.licenseRequiredDesc": "Sample, remix veya üçüncü taraf materyal içeren içerikler için lisans belgesi gereklidir.",
    "wizard.track.uploadLicense": "Lisans Belgesi Yükle",
    "wizard.track.licenseUploaded": "PDF • Yüklendi",
    "wizard.track.unknownArtist": "Bilinmeyen Sanatçı",
    
    // Review section TR
    "wizard.review.summary": "İnceleme Özeti",
    "wizard.review.errorsFound": "Hata Bulundu",
    "wizard.review.fixErrors": "Hataları Düzelt",
    "wizard.review.readyToSubmit": "Gönderime Hazır",
    "wizard.review.allComplete": "Tüm bölümler tamamlandı. Yayınınız incelemeye gönderilebilir.",
    
    // Common wizard TR
    "wizard.next": "İleri",
    "wizard.back": "Geri",
    "wizard.previous": "Önceki",
    "wizard.saveDraft": "Taslak Kaydet",
    "wizard.submitRelease": "Yayını Gönder",
    "wizard.fixLater": "Sonra Düzelt (Taslak Kaydet)",
    "wizard.fixNow": "Şimdi Düzelt",
    "wizard.errorsDetected": "{{count}} Hata Tespit Edildi",
    "wizard.fixErrorsBeforeSubmit": "Yayınınızı göndermeden önce aşağıdaki hataları düzeltmeniz gerekiyor:",
    "wizard.submit": "Gönder",
    "wizard.save": "Kaydet",
    "wizard.cancel": "İptal",
    "wizard.delete": "Sil",
    "wizard.edit": "Düzenle",
    "wizard.loading": "Yükleniyor...",
    "wizard.selectOption": "Bir seçenek seçin",
    
    // Release Settings Section TR
    "wizard.releaseSettings.streamingPlatforms": "Streaming Platformları",
    "wizard.releaseSettings.socialPlatforms": "Sosyal Platformlar",
    "wizard.releaseSettings.selectAll": "Tümünü Seç",
    "wizard.releaseSettings.selected": "seçili",
    "wizard.releaseSettings.timeSync": "Yayın Zamanlaması",
    "wizard.releaseSettings.timeSyncDesc": "Yayınınızın global olarak nasıl yayınlanacağını seçin",
    "wizard.releaseSettings.localTime": "Yerel Saat (Kademeli Yayın)",
    "wizard.releaseSettings.localTimeDesc": "Her bölgede gece yarısı (00:00) yayınlanır. Müziğiniz her saat diliminde yayın tarihine ulaştığında canlıya geçer.",
    "wizard.releaseSettings.globalTime": "Global Saat (Eşzamanlı Yayın)",
    "wizard.releaseSettings.globalTimeDesc": "Dünya genelinde aynı anda yayınlanır. Tek bir UTC zaman damgasına göre her yerde aynı anda canlıya geçer.",
    "wizard.releaseSettings.releaseDate": "Yayın Tarihi",
    "wizard.releaseSettings.releaseDateRequired": "Yayın Tarihi *",
    "wizard.releaseSettings.releaseTime": "Yayın Saati (UTC)",
    "wizard.releaseSettings.minDaysNotice": "Bugünden en az 7 gün sonra",
    
    // More Options Section TR
    "wizard.moreOptions.publishingRights": "Yayın Hakları",
    "wizard.moreOptions.publishingQuestion": "Yayın haklarının yüzde kaçına sahipsiniz?",
    "wizard.moreOptions.pub100": "%100 - Tüm yayın hakları bana ait",
    "wizard.moreOptions.pub0": "%0 - Yayın haklarım yok",
    "wizard.moreOptions.pubOther": "Diğer yüzde",
    "wizard.moreOptions.proQuestion": "Bir PRO/CMO'ya kayıtlı mısınız?",
    "wizard.moreOptions.proAffiliation": "PRO / Bağlı Kuruluş *",
    "wizard.moreOptions.ipiNumber": "IPI Numarası *",
    "wizard.moreOptions.ipiPlaceholder": "IPI numaranızı girin",
    "wizard.moreOptions.youtubeContentId": "YouTube Content ID",
    "wizard.moreOptions.youtubeQuestion": "YouTube Content ID'yi etkinleştirmek istiyor musunuz?",
    "wizard.moreOptions.youtubeYes": "Evet, Content ID'yi etkinleştir",
    "wizard.moreOptions.youtubeNo": "Hayır, etkinleştirme",
    "wizard.moreOptions.youtubeDesc": "Content ID, başkaları müziğinizi videolarında kullandığında para kazanmanızı sağlar.",
    
    // Review Section TR
    "wizard.review.errorsFoundCount": "{{count}} Hata Bulundu",
    "wizard.review.fixBeforeSubmit": "Göndermeden önce aşağıdaki sorunları düzeltin:",
    "wizard.review.releaseReady": "Yayın Gönderime Hazır",
    "wizard.review.allFieldsComplete": "Tüm gerekli alanlar dolduruldu.",
    "wizard.review.genre": "Tür",
    "wizard.review.content": "İçerik",
    "wizard.review.releaseDate": "Yayın Tarihi",
    "wizard.review.timeMode": "Zaman Modu",
    "wizard.review.distribution": "Dağıtım",
    "wizard.review.platforms": "Platformlar",
    "wizard.review.distributionPlatforms": "Dağıtım Platformları",
    "wizard.review.localStaggered": "Yerel (Kademeli)",
    "wizard.review.global": "Global",
    "wizard.review.explicit": "Explicit",
    "wizard.review.clean": "Temiz",
    "wizard.review.upcIsrcAssigned": "UPC ve ISRC kodları gönderim sonrası admin tarafından atanacaktır.",
    "wizard.review.creditsSummary": "Kredi Özeti",
    "wizard.review.songwriters": "Söz Yazarları",
    "wizard.review.productionTeam": "Prodüksiyon Ekibi",
    "wizard.review.contributors": "Katkıda Bulunanlar",
    "wizard.review.licensedContent": "Lisanslı İçerik",
    "wizard.review.licensedContentYes": "Evet - Lisanslı içerik içeriyor",
    "wizard.review.licensedContentNo": "Hayır - Sadece orijinal içerik",
    "wizard.review.licenseDocUploaded": "Lisans belgesi yüklendi",
    
    // Additional wizard keys TR
    "wizard.track.track": "Parça",
    "wizard.trackCount": "Parça Sayısı",
    "wizard.subgenre": "Alt Tür",
    "wizard.track.creditInfo": "Kredi Bilgileri",
    "wizard.track.songwriterRequired": "En az bir söz yazarı zorunludur",
    "wizard.track.productionRequired": "En az bir prodüksiyon ekibi üyesi eklemelisiniz",
    
    // Review section - Publishing & YouTube TR
    "wizard.review.publishingRightsInfo": "Yayın Hakları Bilgisi",
    "wizard.review.ownership": "Sahiplik",
    "wizard.review.publisher": "Yayıncı",
    "wizard.review.youtubeContentIdEnabled": "YouTube Content ID Etkin",
    "wizard.review.youtubeMonetizeDesc": "Müziğiniz YouTube'da monetize edilecek",
    "wizard.review.originalReleaseDate": "Orijinal Yayın Tarihi",
    "wizard.review.trackList": "Parça Listesi",
    "wizard.review.upcAssignedAfterSubmit": "UPC kodu gönderim sonrası admin tarafından atanacaktır.",
    "wizard.review.documentUploaded": "✓ Belge yüklendi:",
    "wizard.review.documentMissing": "⚠ Belge eksik",
    
    // Release extras TR
    "release.untitledTrack": "Başlıksız Parça",
    "release.unknownArtist": "Bilinmeyen Sanatçı",
    "release.artistNotSpecified": "Sanatçı belirtilmemiş",
    
    // Common extras TR
    "common.draft": "Taslak",
    
    // Support extras
    "support.trackTickets": "Tüm destek taleplerinizi buradan takip edebilirsiniz",
    "support.subject": "Konu",
    "support.subjectPlaceholder": "Sorununuzu kısaca açıklayın",
    "support.category": "Kategori",
    "support.message": "Mesaj",
    "support.messagePlaceholder": "Sorununuzu detaylı olarak açıklayın...",
    "support.fillAllFields": "Lütfen tüm alanları doldurun",
    "support.ticketCreated": "Destek talebi oluşturuldu",
    "support.ticketFailed": "Talep oluşturulamadı",
    "support.statusOpen": "Açık",
    "support.statusPending": "Beklemede",
    "support.statusWaiting": "Yanıt Bekleniyor",
    "support.statusResolved": "Çözüldü",
    "support.statusClosed": "Kapatıldı",
    "support.categoryRelease": "Yayın",
    "support.categoryPayout": "Ödeme",
    "support.categoryAccount": "Hesap",
    "support.categoryTechnical": "Teknik",
    "support.priorityLow": "Düşük",
    "support.priorityMedium": "Orta",
    "support.priorityHigh": "Yüksek",
    
    // Track Upload
    "track.stepTitle": "Şarkınızı Yükleyin",
    "track.stepSubtitle": "İlk adım: Şarkı adını girin ve ses dosyasını yükleyin",
    "track.songName": "Şarkı Adı",
    "track.enterSongName": "Şarkınızın adını girin",
    "track.uploadAfterName": "Şarkı adını girdikten sonra ses dosyasını yükleyebilirsiniz",
    "track.createAndContinue": "Parça Oluştur ve Devam Et",
    "track.tracks": "Parçalar",
    "track.addTrack": "Parça Ekle",
    "track.bulkUploadTitle": "Birden Fazla Parça Yükle",
    "track.bulkUploadDesc": "Birden fazla ses dosyası seçin. Her dosya, dosya adıyla ayrı bir parça olarak oluşturulacak.",
    "track.selectMultipleFiles": "Ses Dosyalarını Seç",
    "track.uploading": "Yükleniyor...",
    "track.addOneByOne": "Parçaları tek tek ekle",
    "track.addSingleTrack": "Tek Parça Ekle",
    "track.addMoreFiles": "Dosya Ekle",
    "track.addManually": "Manuel Ekle",
    "track.epAlbumSubtitle": "EP/Albümünüz için birden fazla ses dosyası yükleyin. Her dosya ayrı bir parça oluşturacak.",
    "track.audioFormatInfo": "Ses dosyanı yükle (WAV, MP3, M4A, FLAC, AIFF, WMA) - Önerilen: WAV 44.1kHz 16-bit stereo",
    "track.audioRequired": "Ses dosyası yüklemeden bir sonraki adıma geçemezsiniz!",
    "track.addTrackPrompt": "Parça ekleyin",
    "track.song": "Şarkı",
    "track.trackName": "Parça Adı",
    "track.warnings": "Uyarılar",
    "track.warning1": "Parça adına 'feat.' veya özellik bilgisi eklemeyin",
    "track.warning2": "Parça adında parantez içinde versiyon bilgisi kullanmayın",
    "track.warning3": "Tüm büyük harfler kullanmaktan kaçının",
    "track.isrcCode": "ISRC Kodu",
    "track.isrcNote": "Kodunuz yok ise sizin için oluşturacağız.",
    "track.audioFile": "Ses Dosyası",
    "track.uploading": "Yükleniyor",
    "track.uploadOrDrag": "Ses dosyası yükle veya sürükle",
    "track.selectFile": "Dosya Seç",
    "track.contentType": "İçerik Türü",
    "track.clean": "Clean (Temiz)",
    "track.explicit": "Explicit (Müstehcen)",
    "track.songPrice": "Şarkı Fiyatı – iTunes ve Amazon (USD)",
    "track.priceNote": "10 dakikadan uzun şarkıların fiyatı daha fazla olacaktır.",
    "track.instrumental": "Instrumental (Sözsüz)",
    "track.radioEdit": "Radio Edit",
    "track.guestArtist": "Konuk Sanatçı",
    "track.guestArtistNote": "Şarkıda yer alan konuk sanatçı varsa ekleyin",
    "track.version": "Versiyon",
    "track.versionNote": "Acoustic, Live, Remix gibi versiyon bilgisi",
    
    // Track - Artists
    "track.primaryArtists": "Ana Sanatçılar",
    "track.primaryArtistsNote": "Bu parçada performans sergileyen ana sanatçı(lar)",
    "track.addPrimaryArtist": "Ana Sanatçı Ekle",
    "track.artistNamePlaceholder": "Sanatçı adı",
    "track.featuredArtists": "Konuk Sanatçılar",
    "track.featuredArtistsNote": "Bu parçada yer alan konuk sanatçılar ('feat.' olarak görünecek)",
    "track.addFeaturedArtist": "Konuk Sanatçı Ekle",
    "track.featuredArtistPlaceholder": "Konuk sanatçı adı",
    "track.required": "Zorunlu",
    
    // Track - Previously Released
    "track.previouslyReleased": "Bu parça daha önce yayınlandı mı?",
    "track.originalReleaseDate": "Orijinal Yayın Tarihi",
    "track.originalReleaseDateNote": "Bu parçanın ilk yayınlandığı tarihi girin",
    "track.preReleaseDate": "Ön Yayın Tarihi",
    "track.preReleaseDateNote": "Ön sipariş/ön yayın için bir tarih belirleyin",
    
    // Track - Credits
    "track.creditsTitle": "Yazarlar, Besteciler ve Prodüktörler",
    "track.creditsRequired": "Mağazalar için zorunlu",
    "track.creditsWarning": "En az bir yazar/söz yazarı olmadan parçalar mağazalara teslim edilemez!",
    "track.writers": "Yazarlar / Söz Yazarları",
    "track.writersPlaceholder": "John Doe, Jane Smith (virgülle ayırın)",
    "track.writersNote": "Şarkı sözlerini yazan kişiler",
    "track.composers": "Besteciler",
    "track.composersPlaceholder": "John Doe, Jane Smith (virgülle ayırın)",
    "track.composersNote": "Müziği/melodiyi besteleyen kişiler",
    "track.producers": "Prodüktörler",
    "track.producersPlaceholder": "Prodüktör Adı (virgülle ayırın)",
    "track.producersNote": "Parçayı üreten kişiler",
    
    // Track - Lyrics
    "track.lyricsTitle": "Şarkı Sözleri",
    "track.lyricsLanguage": "Şarkı Sözleri Dili",
    "track.lyrics": "Şarkı Sözleri",
    "track.lyricsPlaceholder": "Şarkı sözlerini buraya girin...",
    "track.lyricsNote": "Şarkı sözleri eklemek, şarkınızın streaming platformlarında keşfedilmesine yardımcı olabilir",
    
    // Track - Licensed Content
    "track.licensedContent": "Bu parça lisanslı içerik içeriyor (samples, beats, stok sesler, remix içerik vb.)",
    "track.licensedContentNote": "Bu parçada kullanılan tüm örneklenmiş veya üçüncü taraf içerikler için uygun lisanslara sahip olduğunuzdan emin olun.",
    
    // Create Release Page
    "release.editTitle": "Yayın Düzenle",
    "release.newTitle": "Yeni Yayın",
    "release.stepOf": "Adım {current} / {total}",
    "release.fetchError": "Yayın bilgileri alınamadı",
    "release.saveError": "Yayın kaydedilemedi",
    "release.statusChanged": "Yayın durumu 'Düzenleme Gerekli' olarak değiştirildi. Değişikliklerinizi tamamladıktan sonra yeniden göndermeniz gerekecek.",
    "release.addTrackRequired": "Lütfen en az bir parça ekleyin",
    "release.audioRequired": "Tüm parçalara ses dosyası yüklemelisiniz",
    "release.fillRequired": "Lütfen zorunlu alanları doldurun",
    "release.maxImages": "Maksimum 10 görsel",
    "release.imageDimensions": "Görsel 3000x3000 piksel olmalı. Yüklenen: {width}x{height}",
    "release.imageReadError": "Görsel okunamadı",
    "release.imageUploaded": "Görsel yüklendi",
    "release.imageUploadError": "{filename} yüklenemedi",
    "release.imageDeleteError": "Görsel silinemedi",
    "release.trackAddError": "Parça eklenemedi",
    "release.trackUpdateError": "Parça güncellenemedi",
    "release.trackDeleteError": "Parça silinemedi",
    "release.audioUploaded": "Ses dosyası yüklendi",
    "release.audioUploadError": "Ses dosyası yüklenemedi",
    "release.acceptTerms": "Lütfen koşulları kabul edin",
    "release.trackCoverRequired": "Parça ve kapak görseli gerekli",
    "release.missingAudio": "{count} parça için ses dosyası yüklenmedi",
    "release.submitted": "Yayın gönderildi!",
    "release.submitCancelled": "Gönderim iptal edildi",
    "release.submitError": "Yayın gönderilemedi",
    "release.enterSongName": "Lütfen şarkı adını girin",
    "release.trackAdded": "Parça eklendi",
    "release.uploading": "Yükleniyor...",
    "release.coverUploading": "Görsel",
    "release.audioFileUploading": "Ses Dosyası",
    "release.back": "Geri",
    "release.next": "İleri",
    "release.submitRelease": "Yayını Gönder",
    "release.selectTypeTitle": "Ne yayınlamak istersiniz?",
    "release.selectTypeDesc": "Oluşturmak istediğiniz yayın türünü seçin",
    "release.singleSong": "Tekli Şarkı",
    "release.singleSongDesc": "Kendi kapak görseli ile tek bir parça yayınlayın. Bağımsız single'lar için ideal.",
    "release.epAlbum": "EP / Albüm",
    "release.epAlbumDesc": "Ortak albüm kapağı ile birden fazla parça yayınlayın. EP ve albümler için ideal.",
    "release.track": "parça",
    "release.tracks": "parça",
    "release.coverImage": "kapak",
    "release.albumCover": "albüm kapağı",
    "release.continue": "Devam Et",
    "release.orContinueDraft": "Veya taslaklarınızdan devam edin",
    "release.untitled": "İsimsiz",
    "release.addFromDrafts": "Taslaklarımdan ekle",
    "release.selectReleaseType": "Lütfen bir yayın türü seçin",
    "release.singleTrackOnly": "Single yayınlarında sadece 1 parça olabilir",
    "release.albumCoverLabel": "Albüm Kapağı (Tüm parçalar bu kapağı kullanacak)",
    "release.singleCoverLabel": "Kapak Görseli",
    "release.albumCoverInfo": "Albüm Kapağı",
    "release.albumCoverInfoDesc": "Bu kapak görseli EP/Albümünüzdeki tüm parçalar için kullanılacak.",
    "release.uploadCover": "Kapak Yükle",
    "release.coverUploaded": "Kapak görseli yüklendi",
    "release.releaseType": "Yayın Türü",
    "release.releaseDate": "Yayın Tarihi",
    "release.language": "Dil",
    "release.mainGenre": "Ana Tür",
    "release.selectGenre": "Tür seçin",
    "release.labelName": "Label Adı (Opsiyonel)",
    "release.labelPlaceholder": "Plak şirketi adı",
    "release.upcCode": "UPC Kodu (Opsiyonel)",
    "release.upcNote": "Kodunuz yok ise sizin için oluşturacağız.",
    "release.platforms": "Platformlar",
    "release.aiCoverTitle": "AI görsel oluşturabilirsiniz",
    "release.aiCoverSubtitle": "Kapak görseli için AI ile benzersiz tasarımlar oluşturabilirsiniz",
    "release.coverImportant": "ÖNEMLİ: Kapak görseli tam olarak 3000x3000 piksel olmalıdır. Diğer boyutlar reddedilecektir.",
    "release.coverWarning": "Platformlar URL, web sitesi veya X (Twitter) adı içeren ya da düşük kaliteli kapakları reddeder. Resminizin yüksek kaliteli olduğundan ve hiçbir metin içermediğinden emin olun.",
    "release.coverOwnership": "Bu görsel ve içeriğinin sahibi sensin. Diğer sanatçıların, film şirketlerinin, plak şirketlerinin vb. izinsiz görsel veya logolarını kullanmak telif hakkı ihlaline yol açabilir.",
    "release.coverImages": "Kapak Görselleri (Maksimum 10)",
    "release.uploadOrDrag": "Yükle veya Sürükle",
    "release.imagesUploaded": "{count}/10 görsel yüklendi",
    "release.platformInfo": "Artist linkiniz yoksa sizin için oluşturacağız. / If you don't have an artist link, we will create one for you.",
    "release.platformUrlPlaceholder": "Platform profil URL'lerinizi girin (opsiyonel).",
    "release.leaveEmpty": "Artist linkiniz yoksa boş bırakın, sizin için oluşturacağız.",
    "release.almostDone": "Neredeyse bitti!",
    "release.previewDetails": "Yayın ayrıntılarını önizle",
    "release.releaseInfo": "Yayın Bilgileri",
    "release.releaseTypeLabel": "Yayın Türü",
    "release.releaseDateLabel": "Yayın Tarihi",
    "release.mainGenreLabel": "Ana Tür",
    "release.languageLabel": "Dil",
    "release.coverLabel": "Kapak",
    "release.trackLabel": "Parça",
    "release.imagesText": "görsel",
    "release.songsText": "şarkı",
    "release.platformsDistribute": "Dağıtılacak Platformlar",
    "release.tracksTitle": "Parçalar",
    "release.audioUploadedStatus": "Ses yüklendi",
    "release.audioMissingStatus": "Ses eksik",
    "release.looksGood": "İyi görünüyor mu?",
    "release.confirmBelow": "Aşağıdaki maddeleri onaylayarak yayınınızı gönderin",
    "release.importantConfirms": "Önemli Onaylar",
    "release.confirm1": "Yayınımın içeriği %100 orijinaldir. Müziğimin, sözlerimin, bestelerimin ve kapak resmimin sahibi benim.",
    "release.confirm2": "İzinsiz başka birinin sesini klonlamak veya taklit etmek için AI kullanmadım.",
    "release.confirm3": "Girdiğim tüm bilgiler doğrudur ve hatalardan kaynaklanabilecek sorunları kabul ediyorum.",
    "release.confirm4": "Bot, sahte stream, yapay dinleme veya herhangi bir manipülasyon yöntemi kullanmayacağım. Bu tür faaliyetlerin telif hakkı ihlali olduğunu biliyorum.",
    "release.confirm5": "EAM Music'in Hizmet Koşullarını okudum ve kabul ediyorum.",
    "release.warningEditing": "Dikkat: Bu yayın inceleme sürecinde",
    "release.warningEditingDesc": "Bu yayında değişiklik yaparsanız, durumu 'Düzenleme Gerekli' olarak değişecek ve yeniden göndermeniz gerekecektir.",
    "release.adminNote": "Admin Notu",
    
    // Common extras
    "common.filter": "Filtre",
    "common.all": "Tümü",
    "common.copy": "Kopyala",
    "common.optional": "Opsiyonel",
    "common.user": "Kullanıcı",
    "common.status": "Durum",
    "common.logout": "Çıkış Yap",
    "common.default": "Varsayılan",
    "common.yes": "Evet",
    "common.no": "Hayır",
    "common.other": "Diğer",
    "common.noResults": "Sonuç bulunamadı",
    
    // Profile
    "profile.title": "Profilim",
    "profile.subtitle": "Hesap bilgilerinizi görüntüleyin ve düzenleyin",
    "profile.accountInfo": "Hesap Bilgileri",
    "profile.addressInfo": "Adres Bilgileri",
    "profile.statistics": "İstatistikler",
    "profile.financial": "Finansal Bilgiler",
    "profile.firstName": "Ad",
    "profile.lastName": "Soyad",
    "profile.email": "E-posta",
    "profile.status": "Hesap Durumu",
    "profile.address": "Adres",
    "profile.city": "Şehir",
    "profile.country": "Ülke",
    "profile.postalCode": "Posta Kodu",
    
    // Statuses
    "status.draft": "Taslak",
    "status.submitted": "Gönderildi",
    "status.inReview": "İnceleniyor",
    "status.needsEdits": "Düzenleme Gerekli",
    "status.approved": "Onaylandı",
    "status.rejected": "Reddedildi",
    "status.live": "Yayında",
    "status.takenDown": "Kaldırıldı",
    
    // Release Detail Page
    "releaseDetail.backToReleases": "Yayınlara Dön",
    "releaseDetail.releaseTime": "Yayın Zamanı",
    "releaseDetail.genre": "Tür",
    "releaseDetail.releaseType": "Yayın Türü",
    "releaseDetail.explicitContent": "Müstehcen İçerik",
    "releaseDetail.releaseInfo": "Yayın Bilgileri",
    "releaseDetail.version": "Versiyon",
    "releaseDetail.subGenre": "Alt Tür",
    "releaseDetail.titleLanguage": "Başlık Dili",
    "releaseDetail.recordLabel": "Plak Şirketi",
    "releaseDetail.publisher": "Yayıncı",
    "releaseDetail.timeMode": "Zaman Modu",
    "releaseDetail.localTime": "Yerel Saat",
    "releaseDetail.global": "Global",
    "releaseDetail.selectedPlatforms": "Seçili Platformlar",
    "releaseDetail.trackInfo": "Parça Bilgileri",
    "releaseDetail.noTracks": "Henüz parça eklenmedi",
    "releaseDetail.statusHistory": "Durum Geçmişi",
    "releaseDetail.untitled": "Başlıksız",
    "releaseDetail.englishTitle": "İngilizce Başlık",
    "releaseDetail.lyricsLanguage": "Şarkı Sözü Dili",
    "releaseDetail.primaryArtists": "Ana Sanatçılar",
    "releaseDetail.featuredArtists": "Featuring Sanatçılar",
    "releaseDetail.songwriters": "Söz Yazarları",
    "releaseDetail.writers": "Yazarlar",
    "releaseDetail.composers": "Besteciler",
    "releaseDetail.producers": "Yapımcılar",
    "releaseDetail.trackAudio": "Parça Sesi",
    "releaseDetail.browserNotSupported": "Tarayıcınız ses oynatmayı desteklemiyor.",
    "releaseDetail.lyrics": "Şarkı Sözleri",
    
    // Admin Release
    "adminRelease.downloadPackage": "Paket İndir",
    "adminRelease.editNotes": "Düzenleme Notları",
    "adminRelease.newStatus": "Yeni Durum",
    "adminRelease.reasonRequired": "Sebep (Zorunlu)",
    "adminRelease.noteOptional": "Not (Opsiyonel)",
    "adminRelease.reasonPlaceholder": "Sebep/not...",
    
    // Admin Review Queue
    "adminReview.subtitle": "Yayınları inceleyin ve onaylayın",
    "adminReview.statusFilter": "Durum Filtresi",
    "adminReview.allStatuses": "Tüm Durumlar",
    "adminReview.noReleases": "İncelenecek yayın yok",
    "adminReview.noReleasesDesc": "Seçili filtre için bekleyen yayın bulunmuyor.",
    "adminReview.noDateSet": "Tarih belirtilmemiş",
    
    // Admin Artists
    "adminArtists.searchPlaceholder": "İsim veya e-posta ile ara...",
    "adminArtists.pendingApproval": "Onay Bekliyor",
    "adminArtists.banned": "Banlı",
    "adminArtists.plan": "Plan",
    "adminArtists.balance": "Bakiye",
    "adminArtists.withdrawable": "Çekilebilir",
    
    // Release Form - Genre & Language
    "releaseForm.primaryGenre": "Ana Tür",
    "releaseForm.subGenre": "Alt Tür",
    "releaseForm.subGenreOptional": "opsiyonel",
    "releaseForm.selectPrimaryGenre": "Ana tür seçin",
    "releaseForm.selectSubGenre": "Alt tür seçin",
    "releaseForm.selectPrimaryFirst": "Önce ana tür seçin",
    "releaseForm.searchGenre": "Tür ara...",
    "releaseForm.searchSubGenre": "Alt tür ara...",
    "releaseForm.noGenreFound": "Tür bulunamadı",
    "releaseForm.noSubGenreFound": "Alt tür bulunamadı",
    "releaseForm.trackLanguage": "Parça Dili",
    "releaseForm.titleLanguage": "Başlık Dili",
    "releaseForm.selectTrackLanguage": "Parça dili seçin",
    "releaseForm.selectTitleLanguage": "Başlık dili seçin",
    "releaseForm.searchLanguage": "Dil ara...",
    "releaseForm.noLanguageFound": "Dil bulunamadı",
    "releaseForm.instrumentalNote": "Enstrümantal parça olarak işaretlendi",
    "releaseForm.multipleLanguagesNote": "Birden fazla dil içeren parça",
    "releaseForm.selectType": "Yayın türünü seçin",
    "releaseForm.track": "Parça",
    "releaseForm.tracks": "Parça",
    
    // Release Form - Explicit
    "releaseForm.explicitLyrics": "Explicit Lyrics / Parental Advisory",
    "releaseForm.selectExplicit": "İçerik türü seçin",
    "releaseForm.explicitRequired": "İçerik türü seçimi zorunludur",
    "releaseForm.explicitWarning": "Uyarı: Clean/Edited versiyonu için aynı parçanın explicit versiyonu da olmalıdır",
    "releaseForm.explicitMarked": "Bu parça müstehcen içerik içeriyor olarak işaretlenecek",
    "releaseForm.radioEditVersion": "Radio Edit versiyonu",
    "releaseForm.explicit": "Müstehcen (Explicit)",
    "releaseForm.explicitDesc": "Küfür veya müstehcen içerik içerir",
    "releaseForm.cleanEdited": "Temiz / Düzenlenmiş (Radio Edit)",
    "releaseForm.cleanEditedDesc": "Müstehcen parçanın düzenlenmiş versiyonu",
    "releaseForm.notExplicit": "Müstehcen Değil",
    "releaseForm.notExplicitDesc": "Müstehcen içerik içermez",
    "releaseForm.unknown": "Bilinmiyor",
    "releaseForm.unknownDesc": "Müstehcen durumu bilinmiyor",
    
    // Release Form - Other
    "releaseForm.isInstrumental": "Enstrümantal mı?",
    "releaseForm.instrumentalDesc": "Bu parça enstrümantal (vokal yok)",
    "releaseForm.featuredArtists": "Konuk Sanatçılar",
    "releaseForm.addFeaturedArtist": "Featured sanatçı ekle",
    "releaseForm.primaryArtist": "Ana Sanatçı",
    "releaseForm.trackTitle": "Parça Başlığı",
    "releaseForm.enterTrackTitle": "Parça başlığını girin",
    "releaseForm.trackTitleRequired": "Parça başlığı zorunludur",
    "releaseForm.primaryArtistRequired": "Ana sanatçı zorunludur",
    "releaseForm.primaryGenreRequired": "Ana tür seçimi zorunludur",
    "releaseForm.trackLanguageRequired": "Parça dili seçimi zorunludur",
    
    // Single Release Wizard
    "wizard.audioFile": "Ses Dosyası",
    "wizard.readyForDistribution": "Dağıtıma hazır",
    "wizard.uploading": "Yükleniyor...",
    "wizard.pleaseWait": "Lütfen bekleyin",
    "wizard.uploadAudioFile": "Ses Dosyası Yükle",
    "wizard.audioFormatInfo": "WAV veya FLAC • 44.1-96kHz • 16/24 bit",
    "wizard.trackDetails": "Parça Bilgileri",
    "wizard.trackTitle": "Parça Başlığı",
    "wizard.enterTrackTitle": "Parça başlığını girin",
    "wizard.primaryArtist": "Ana Sanatçı",
    "wizard.artistName": "Sanatçı adı",
    "wizard.trackSettings": "Parça Bazlı Ayarlar",
    "wizard.coverArt": "Kapak Görseli",
    "wizard.coverRequirements": "Kapak Gereksinimleri",
    "wizard.squareFormat": "Kare format (1:1 oran)",
    "wizard.minResolution": "Minimum 3000x3000 piksel",
    "wizard.formatJpgPng": "JPG veya PNG format",
    "wizard.noUrlsAllowed": "URL veya sosyal medya linkleri olmayacak",
    "wizard.noBluryImages": "Bulanık veya pikselleşmiş görsel olmayacak",
    "wizard.uploadCover": "Kapak Görseli Yükle",
    "wizard.coverUploaded": "Kapak yüklendi",
    "wizard.distributionType": "Dağıtım Türü",
    "wizard.wasThisReleased": "Bu parça daha önce yayınlandı mı?",
    "wizard.newRelease": "Yeni Yayın",
    "wizard.newReleaseDesc": "İlk kez yayınlanıyor. UPC ve ISRC kodları admin tarafından atanacak.",
    "wizard.transferRelease": "Başka Dağıtımcıdan Transfer / Daha Önce Yüklenmiş Şarkı",
    "wizard.transferReleaseDesc": "Mevcut UPC ve ISRC kodlarınızı girmeniz gerekiyor.",
    "wizard.upcCode": "UPC Kodu",
    "wizard.isrcCode": "ISRC Kodu",
    "wizard.originalReleaseDate": "Orijinal Yayın Tarihi",
    
    // Explicit options
    "explicit.explicit": "Explicit (Müstehcen)",
    "explicit.explicitDesc": "Küfür, şiddet veya cinsel içerik gibi yetişkinlere yönelik içerik barındırır.",
    "explicit.clean": "Temiz / Düzenlenmiş",
    "explicit.cleanDesc": "Müstehcen içeriği kaldırılmış veya düzenlenmiş radyo versiyonu. Explicit versiyon mevcut olmalıdır.",
    "explicit.notExplicit": "Müstehcen Değil",
    "explicit.notExplicitDesc": "Herhangi bir müstehcen içerik barındırmaz. Aile dostu.",
    "explicit.unknown": "Bilinmiyor",
    "explicit.unknownDesc": "İçerik derecesi belirlenmemiş veya uygulanamaz.",
    
    "wizard.credits": "Krediler",
    "wizard.songwriters": "Söz Yazarları",
    "wizard.add": "Ekle",
    "wizard.songwriterName": "Ad Soyad (örn: Ahmet Yılmaz)",
    "wizard.songwriterPlaceholder": "örn: Ahmet Yılmaz",
    "wizard.lyricists": "Şarkı Sözü Yazarları",
    "wizard.lyricistName": "Şarkı sözü yazarı adı",
    "wizard.contributors": "Katkıda Bulunanlar",
    "wizard.contributorPlaceholder": "örn: Mehmet Demir",
    "wizard.producerPlaceholder": "örn: Ali Kaya",
    "wizard.name": "İsim",
    "wizard.selectRole": "Rol seçin *",
    "wizard.productionTeam": "Prodüksiyon Ekibi",
    "wizard.recordLabel": "Plak Şirketi",
    "wizard.recordLabelOptional": "Plak şirketi adı (opsiyonel)",
    "wizard.versionPlaceholder": "örn: Deluxe Edition, Acoustic, Remix",
    "wizard.isrcPlaceholder": "örn: USRC17607839",
    "wizard.minResolutionRecommended": "Min 1400x1400 px (3000x3000 önerilir)",
    "wizard.upcPlaceholder": "12 haneli UPC kodunu girin",
    "wizard.licensedContent": "Lisanslı İçerik",
    "wizard.licensedContentQuestion": "Bu parça sample, beat, stok ses veya remix içeriyor mu?",
    "wizard.noOriginal": "Hayır, tamamen orijinal",
    "wizard.yesLicensed": "Evet, lisanslı içerik var",
    "wizard.licenseRequired": "Lisans Belgesi Zorunlu",
    "wizard.licenseRequiredDesc": "Lisanslı içerik kullandığınızı doğrulamak için lisans belgenizi (PDF) yüklemeniz gerekmektedir.",
    "wizard.uploadLicense": "Lisans Belgesi Yükle",
    "wizard.pdfOnly": "Sadece PDF formatı kabul edilir",
    
    // Credit roles
    "creditRoles.composer": "Besteci",
    "creditRoles.lyricist": "Söz Yazarı",
    "creditRoles.composerLyricist": "Besteci & Söz Yazarı",
    "creditRoles.arranger": "Aranjör",
    "creditRoles.mixer": "Miksaj",
    "creditRoles.mastering": "Mastering",
    "creditRoles.recording": "Kayıt",
    "creditRoles.instrumentalist": "Enstrümanist",
    "creditRoles.vocalist": "Vokal",
    "creditRoles.other": "Diğer",
    "creditRoles.producer": "Prodüktör",
    "creditRoles.executiveProducer": "Executive Producer",
    "creditRoles.coProducer": "Co-Producer",
    "creditRoles.engineer": "Mühendis",
    "creditRoles.assistant": "Asistan",
    
    // Release form
    "releaseForm.instrumental": "Enstrümantal (Söz Yok)",
    "releaseForm.multipleLanguages": "Çoklu Dil",
    
    // Track specific
    "wizard.track.lyricsLanguage": "Parça Dili (Language of Lyrics)",
    "wizard.track.lyricsLanguageDesc": "Şarkı sözlerinin veya vokalin dili",
    "wizard.track.explicitLyrics": "Explicit Lyrics / Parental Advisory",
    "wizard.track.selectContentType": "İçerik türü seçin",
    "wizard.track.addFeaturedArtist": "Featured sanatçı ekle",
    "wizard.track.useExistingIsrc": "Mevcut ISRC kodunu kullan",
    
    "wizard.licenseDocument": "Lisans belgesi",
    "wizard.uploaded": "Yüklendi",
    "wizard.licenseUploaded": "Lisans belgesi yüklendi",
    "wizard.licenseUploadFailed": "Lisans belgesi yüklenemedi",
    
    // Wizard Section Tabs
    "wizard.sections.trackInfo": "Parça Bilgileri",
    "wizard.sections.releaseSettings": "Yayın Ayarları",
    "wizard.sections.moreOptions": "Ek Seçenekler",
    "wizard.sections.review": "İnceleme",
    
    // Wizard Page Header
    "wizard.newSingleRelease": "Yeni Tekli Yayın",
    "wizard.newSingleReleaseDesc": "Yayınınızı göndermek için tüm bölümleri tamamlayın",
    "wizard.selectReleaseType": "Yayın Türünü Seçin",
    "wizard.singleTrack": "Tekli Şarkı",
    "wizard.singleTrackDesc": "Tek bir parça yayınlayın. Hızlı ve kolay süreç.",
    "wizard.epAlbum": "EP / Albüm",
    "wizard.epAlbumDesc": "Birden fazla parça içeren bir yayın oluşturun.",
    "wizard.loadFromDrafts": "Taslaklarımdan Yükle",
    "wizard.goBack": "Geri Dön",
    
    // Wizard Toast Messages
    "wizard.audioUploaded": "Ses dosyası yüklendi",
    "wizard.audioUploadFailed": "Ses dosyası yüklenemedi",
    "wizard.coverMustBeSquare": "Kapak görseli kare (1:1) olmalıdır",
    "wizard.coverMinResolution": "Kapak görseli en az 3000x3000 piksel olmalıdır",
    "wizard.coverReadFailed": "Görsel okunamadı",
    "wizard.coverUploaded": "Kapak görseli yüklendi",
    "wizard.coverUploadFailed": "Kapak görseli yüklenemedi",
    "wizard.releaseLoadFailed": "Yayın yüklenemedi",
    "wizard.draftsLoadFailed": "Taslaklar yüklenemedi",
    "wizard.fixSectionErrors": "Lütfen bu bölümdeki hataları düzeltin",
    "wizard.draftSaved": "Taslak kaydedildi",
    "wizard.draftSaveFailed": "Taslak kaydedilemedi",
    "wizard.releaseSubmitted": "Yayın başarıyla gönderildi!",
    "wizard.releaseSubmitFailed": "Yayın gönderilemedi",
    "wizard.drafts": "Taslaklar",
    "wizard.noDrafts": "Henüz taslak yayın bulunmuyor",
    "wizard.untitledRelease": "İsimsiz Yayın",
    "wizard.deleteDraft": "Taslağı Sil",
    
    // Validation messages
    "validation.minContributors": "En az bir katkıda bulunan eklemelisiniz",
    "validation.minProductionTeam": "En az bir prodüksiyon ekibi üyesi eklemelisiniz",

    // Spotify
    "spotify.title": "Spotify for Artists",
    "spotify.comingSoon": "Yakında",
    "spotify.description": "Spotify Artist hesabınıza doğrudan EAM panelinden erişin. Bu özellik üzerinde çalışıyoruz.",
    
    // Admin
    "admin.dashboard": "Anasayfa",
    "admin.reviewQueue": "İnceleme Kuyruğu",
    "admin.artists": "Sanatçılar",
    "admin.announcements": "Duyurular",
    "admin.pendingUsers": "Bekleyen Kullanıcı",
    "admin.pendingReleases": "Bekleyen Yayın",
    "admin.payoutRequests": "Ödeme Talepleri",
    "admin.deleteUser": "Kullanıcıyı Sil",
    "admin.deleteUserConfirm": "⚠️ Bu kullanıcı, tüm yayınları ve destek talepleri kalıcı olarak silinecek. Bu işlem geri alınamaz!",
    "admin.yesDelete": "Evet, Sil",
    "admin.close": "Kapat",
    "admin.deleteTicket": "Destek Talebini Sil",
    "admin.deleteTicketConfirm": "Bu destek talebi ve tüm mesajları kalıcı olarak silinecek. Bu işlem geri alınamaz.",
    "admin.deleteRelease": "Yayını Sil",
    "admin.deleteReleaseConfirm": "⚠️ Bu yayın ve tüm ses dosyaları kalıcı olarak silinecek. Bu işlem geri alınamaz!",
    "admin.deleteFailed": "Silme işlemi başarısız",
    
    // Notifications
    "notifications.title": "Bildirimler",
    "notifications.markAllRead": "Tümünü Okundu İşaretle",
    "notifications.none": "Bildirim yok",
    "notifications.empty": "Henüz bildirim yok",
    
    // Common
    "common.yes": "Evet",
    "common.no": "Hayır",
    "common.cancel": "İptal",
    "common.add": "Ekle",
    "common.update": "Güncelle",
    "common.delete": "Sil",
    "common.save": "Kaydet",
    "common.current": "Mevcut",
    "common.optional": "Opsiyonel",
    "common.untitled": "Başlıksız",
    "common.unknownArtist": "Bilinmeyen Sanatçı",
    "common.operationFailed": "İşlem başarısız",
    
    // Wizard - Lyrics
    "wizard.lyrics.label": "Şarkı Sözleri (Opsiyonel)",
    "wizard.lyrics.placeholder": "Şarkı sözlerini buraya yazın...",
    "wizard.lyrics.description": "Şarkı sözleri DSP'lerde görüntülenebilir (Apple Music, Spotify vb.)",
    
    // Wizard - Publishing
    "wizard.publishing.percentPlaceholder": "Yüzde girin (1-99)",
    "wizard.publishing.hasPublisher": "Bir yayıncınız var mı?",
    "wizard.publishing.publisherName": "Yayıncı Adı",
    "wizard.publishing.publisherPlaceholder": "Yayıncı adını girin",
    "wizard.publishing.registeredPro": "Bir PRO/CMO'ya kayıtlı mısınız?",
    
    // Wizard - Uploaded files
    "wizard.uploadedCover": "Yüklü kapak",
    "wizard.uploadedFile": "Yüklü dosya",
    
    // Payout Methods
    "payoutMethods.otpSent": "Doğrulama kodu e-posta adresinize gönderildi",
    "payoutMethods.otpRequired": "6 haneli doğrulama kodunu girin",
    "payoutMethods.methodUpdated": "Ödeme yönteminiz başarıyla güncellendi",
    "payoutMethods.verificationFailed": "Doğrulama başarısız",
    "payoutMethods.editMethod": "Ödeme Yöntemi Düzenle",
    "payoutMethods.addMethod": "Yeni Ödeme Yöntemi",
    "payoutMethods.editDesc": "Mevcut ödeme yönteminizi güncelleyin",
    "payoutMethods.addDesc": "Kazançlarınızı çekmek için bir ödeme yöntemi ekleyin",
    "payoutMethods.bank": "Banka",
    "payoutMethods.accountHolder": "Hesap Sahibi Adı",
    "payoutMethods.fullName": "Ad Soyad",
    "payoutMethods.bankName": "Banka Adı",
    "payoutMethods.country": "Ülke",
    "payoutMethods.countryPlaceholder": "Türkiye",
    "payoutMethods.paypalEmail": "PayPal E-posta Adresi",
    "payoutMethods.title": "Ödeme Yöntemleri",
    "payoutMethods.subtitle": "Kazançlarınızı çekmek için ödeme yönteminizi ekleyin",
    "payoutMethods.addNew": "Yeni Ekle",
    "payoutMethods.securityNotice": "Güvenlik Bildirimi",
    "payoutMethods.securityDesc": "Ödeme yöntemlerinizdeki tüm değişiklikler e-posta doğrulaması gerektirir. Bu, hesabınızı yetkisiz erişime karşı korumak içindir.",
    "payoutMethods.noMethods": "Ödeme Yöntemi Bulunamadı",
    "payoutMethods.noMethodsDesc": "Kazançlarınızı çekebilmek için bir ödeme yöntemi eklemeniz gerekiyor.",
    "payoutMethods.bankTransfer": "Banka Transferi",
    "payoutMethods.default": "Varsayılan",
    "payoutMethods.verified": "Doğrulanmış",
    "payoutMethods.emailVerification": "E-posta Doğrulama",
    "payoutMethods.enterOtp": "E-posta adresinize gönderilen 6 haneli kodu girin",
    "payoutMethods.verificationCode": "Doğrulama Kodu",
    "payoutMethods.codeExpires": "Kod {time} içinde geçersiz olacak",
    "payoutMethods.codeExpired": "Kodun süresi doldu. Yeni kod isteyin.",
    "payoutMethods.resendIn": "Tekrar gönder",
    "payoutMethods.resendCode": "Kodu Tekrar Gönder",
    "payoutMethods.verify": "Doğrula",
    "payoutMethods.deleteMethod": "Ödeme Yöntemi Sil",
    "payoutMethods.deleteConfirm": "Bu ödeme yöntemini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    
    // Login
    "login.heroTitle": "Müziğinizi",
    "login.heroHighlight": "Dünyaya Dağıtın",
    "login.heroSubtitle": "Spotify, Apple Music, YouTube Music ve daha fazlasında müziğinizi yayınlayın.",
    "auth.forgotPassword": "Şifremi Unuttum",
    "auth.resetPassword": "Şifre Sıfırlama",
    "auth.resetPasswordDesc": "E-posta adresinizi girin, şifre sıfırlama linki göndereceğiz.",
    "auth.sendResetLink": "Sıfırlama Linki Gönder",
    "auth.backToLogin": "Giriş Sayfasına Dön",
    "auth.resetLinkSent": "Şifre sıfırlama linki e-posta adresinize gönderildi.",
    "auth.turnstileRequired": "Lütfen güvenlik doğrulamasını tamamlayın",
    
    // Artist Autocomplete
    "artist.saved": "Kayıtlı",
    "artist.noResults": "Kayıtlı sanatçı bulunamadı",
    "artist.saveArtist": "\"{name}\" sanatçısını kaydet",
    "artist.addArtist": "\"{name}\" ekle",
    "artist.addPlaceholder": "Sanatçı ekle",
    "artist.addPrimaryArtist": "Ana sanatçı ekle",
    "artist.addFeaturedArtist": "Featured sanatçı ekle",
    "artist.artistName": "Sanatçı adı",
    "artist.enterOrSearch": "Sanatçı adını girin veya arayın",
    "artist.noMatching": "Eşleşen sanatçı bulunamadı",
    "artist.addAsArtist": "\"{name}\" sanatçı olarak ekle",
    "artist.enterMinChars": "Aramak için en az 2 karakter girin",
    "artist.searchSpotify": "Ara",
    "artist.manualLink": "Link Yapıştır",
    "artist.spotifyProfileLink": "Spotify Sanatçı Linki",
    "artist.spotifyLinkHelp": "Spotify sanatçı profil URL'sini veya ID'sini yapıştırın",
    "artist.linkSpotify": "Spotify Profilini Bağla",
    "artist.addWithoutSpotify": "Spotify linki olmadan ekle",
    "artist.tryManualLink": "Spotify URL'si girmek için 'Link Yapıştır' sekmesini deneyin",
    "artist.invalidSpotifyLink": "Geçersiz Spotify linki veya ID",
    "artist.nameRequired": "Sanatçı adı gerekli",
    "artist.spotifyLinked": "Spotify profili başarıyla bağlandı",
    "artist.spotifyIdSaved": "Spotify ID kaydedildi",
    
    // Releases Page
    "releases.allReleases": "Tüm Yayınlar",
    "releases.drafts": "Taslaklar",
    "releases.tableTitle": "Başlık",
    "releases.tableArtist": "Sanatçı",
    "releases.tableTracks": "Parça",
    "releases.tableLastUpdate": "Son Güncelleme",
    "releases.tableProgress": "İlerleme",
    "releases.tableActions": "İşlemler",
    "releases.releaseDate": "Yayın Tarihi",
    "releases.deleteDraftTitle": "Taslağı Sil",
    "releases.deleteReleaseTitle": "Yayını Sil",
    "releases.deleteFailed": "Silme işlemi başarısız",
    "releases.untitled": "Başlıksız",
    "releases.needsEdits": "Düzenleme Gerekli",
    "releases.yesRemoveBtn": "Evet, Kaldır",
    "releases.deleteBtn": "Sil",
    
    // Credit Roles (Canonical IDs)
    "role.COMPOSER": "Besteci",
    "role.LYRICIST": "Söz Yazarı",
    "role.COMPOSER_LYRICIST": "Besteci & Söz Yazarı",
    "role.PRODUCER": "Yapımcı",
    "role.EXECUTIVE_PRODUCER": "Baş Yapımcı",
    "role.CO_PRODUCER": "Ortak Yapımcı",
    "role.ASSOCIATE_PRODUCER": "Yardımcı Yapımcı",
    "role.MIXING_ENGINEER": "Mikser",
    "role.MASTERING_ENGINEER": "Mastering Mühendisi",
    "role.RECORDING_ENGINEER": "Kayıt Mühendisi",
    "role.ASSISTANT_ENGINEER": "Asistan Mühendis",
    "role.ARRANGER": "Aranjör",
    "role.REMIXER": "Remikser",
    "role.ORCHESTRA": "Orkestra",
    "role.CHOIR": "Koro",
    
    // Tax Status
    "tax.required": "Vergi Bilgileri Zorunlu",
    "tax.requiredDesc": "Çekim talebi için vergi bilgilerinin doldurulması zorunludur",
    "tax.statusNone": "Belirtilmemiş",
    "tax.statusPersonal": "Bireysel",
    "tax.statusCompany": "Kurumsal",
    "tax.cannotPayout": "Çekim yapılamaz",
    
    // Validation Messages
    "validation.audioRequired": "Ses dosyası zorunludur",
    "validation.audioFormatWav": "Ses dosyası WAV veya FLAC formatında olmalıdır",
    "validation.sampleRate": "Sample rate 44.1kHz - 96kHz arasında olmalıdır",
    "validation.bitDepth": "Bit depth 16 veya 24 bit olmalıdır",
    "validation.titleRequired": "Parça başlığı zorunludur",
    "validation.titleLanguageRequired": "Başlık dili zorunludur",
    "validation.primaryArtistRequired": "En az bir ana sanatçı zorunludur",
    "validation.primaryGenreRequired": "Ana tür seçimi zorunludur",
    "validation.explicitRequired": "İçerik türü seçimi zorunludur",
    "validation.explicitWarning": "Uyarı: Clean/Edited versiyonu için aynı parçanın explicit versiyonu da olmalıdır",
    "validation.coverRequired": "Kapak görseli zorunludur",
    "validation.distributionTypeRequired": "Dağıtım türü seçimi zorunludur",
    "validation.upcRequired": "Transfer için UPC kodu zorunludur",
    "validation.isrcRequired": "Transfer için ISRC kodu zorunludur",
    "validation.originalDateRequired": "Orijinal yayın tarihi zorunludur",
    "validation.songwriterRequired": "En az bir söz yazarı zorunludur",
    "validation.songwriterNameFormat": "Söz yazarları Ad Soyad formatında olmalıdır (örn: Mahmut Demir)",
    "validation.songwriterRoleRequired": "Her söz yazarı için rol seçimi zorunludur",
    "validation.licensedContentRequired": "Lisanslı içerik durumu zorunludur",
    "validation.licenseFileRequired": "Lisans belgesi (PDF) zorunludur",
    "validation.contributorRequired": "En az bir katkıda bulunan (contributor) zorunludur",
    "validation.contributorNameFormat": "Katkıda bulunanlar Ad Soyad formatında olmalıdır (örn: Mehmet Yılmaz)",
    "validation.productionTeamRequired": "En az bir prodüksiyon ekibi üyesi zorunludur",
    "validation.productionTeamNameFormat": "Prodüksiyon ekibi üyeleri Ad Soyad formatında olmalıdır (örn: Ahmet Kaya)",
    "validation.platformRequired": "En az bir platform seçimi zorunludur",
    "validation.timeSyncRequired": "Zaman senkronizasyonu seçimi zorunludur",
    "validation.releaseDateRequired": "Yayın tarihi zorunludur",
    "validation.releaseDateMinDays": "Yayın tarihi en az 7 gün sonra olmalıdır",
    "validation.trackCountRequired": "EP/Albüm için en az 2 parça zorunludur",
    "validation.trackLanguageRequired": "Parça dili seçimi zorunludur",
    "validation.trackHasErrors": "Bu parçada düzeltilmesi gereken hatalar var",
    "validation.fixSectionErrors": "Lütfen bu bölümdeki hataları düzeltin",
    "validation.weeklyLimitReached": "Bu hafta çekim limitinize ulaştınız (2/2). Gelecek hafta tekrar deneyiniz.",
    "validation.firstArtistMustMatch": "İlk ana sanatçı şu olmalıdır:",
    "validation.artistMustMatchAlbum": "Parça sanatçıları en az bir albüm sanatçısı ile eşleşmelidir",
    "validation.isrcRequiredTransfer": "Transfer edilen yayınlarda ISRC kodu zorunludur",
    "validation.publishingRequired": "Yayın hakları yüzdesi zorunludur",
    "validation.publisherStatusRequired": "Yayıncı durumu zorunludur",
    "validation.publisherNameRequired": "Yayıncı adı zorunludur",
    "validation.proStatusRequired": "PRO/CMO kayıt durumu zorunludur",
    "validation.proSelectionRequired": "PRO seçimi zorunludur",
    "validation.ipiRequired": "IPI numarası zorunludur",
    "validation.validPercentage": "Geçerli bir yüzde girin (1-99)",
    "validation.ownershipRequired": "Sahiplik onayı zorunludur",
    "validation.termsRequired": "Şartları kabul etmeniz zorunludur",
    "releases.track": "Parça",
    
    // Toast Messages
    "toast.saveSuccess": "Başarıyla kaydedildi",
    "toast.saveFailed": "Kaydetme başarısız",
    "toast.deleteSuccess": "Başarıyla silindi",
    "toast.deleteFailed": "Silme başarısız",
    "toast.uploadSuccess": "Başarıyla yüklendi",
    "toast.uploadFailed": "Yükleme başarısız",
    "toast.submitSuccess": "Başarıyla gönderildi",
    "toast.submitFailed": "Gönderme başarısız",
    "toast.loginSuccess": "Giriş başarılı",
    "toast.loginFailed": "Giriş başarısız",
    "toast.logoutSuccess": "Çıkış başarılı",
    "toast.copySuccess": "Panoya kopyalandı",
    "toast.errorOccurred": "Bir hata oluştu",
    "toast.pleaseFixErrors": "Lütfen bu bölümdeki hataları düzeltin",
    "toast.releaseSubmitted": "Yayın başarıyla gönderildi!",
    "toast.draftSaved": "Taslak kaydedildi",
    "toast.coverUploaded": "Kapak görseli yüklendi",
    "toast.audioUploaded": "Ses dosyası yüklendi",
    "toast.invalidCredentials": "Geçersiz e-posta veya şifre",
    "toast.sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",

    // === Auto-generated i18n keys ===
    "aiAdvisor.aiName": "Yapay Zeka",
    "aiAdvisor.title": "Yapay Zeka Müzik Danışmanı",
    "aiAdvisor.subtitle": "Kariyeriniz için yapay zeka destekli stratejiler ve analizler alın.",
    "aiAdvisor.thinking": "Yapay zeka düşünüyor...",
    "aiAdvisor.stats.totalReleases": "Toplam Yayın",
    "aiAdvisor.stats.totalTracks": "Toplam Parça",
    "aiAdvisor.stats.chatHistory": "Sohbet Geçmişi",
    "aiAdvisor.stats.messages": "Mesaj",
    "aiAdvisor.support.email": "E-posta Adresiniz",
    "aiAdvisor.support.problem": "Sorununuz (Kısaca)",
    "aiAdvisor.clear": "Temizle",
    "aiAdvisor.clearChat": "Sohbeti Temizle",
    "aiAdvisor.connectAgent": "Müşteri Temsilcisine Bağlan",
    "aiAdvisor.contextDesc": "Yapay zeka kişiselleştirilmiş tavsiyeler sunar.",
    "aiAdvisor.contextTitle": "Danışman Bağlamı",
    "aiAdvisor.errors.cannotRespond": "Üzgünüm, şu anda yanıt veremiyorum.",
    "aiAdvisor.errors.fillFields": "Lütfen tüm alanları doldurun.",
    "aiAdvisor.errors.generic": "Bir hata oluştu, lütfen tekrar deneyin.",
    "aiAdvisor.errors.noChatToExport": "Dışa aktarılacak sohbet bulunamadı.",
    "aiAdvisor.errors.ticketFailed": "Destek talebi oluşturulurken hata oluştu.",
    "aiAdvisor.export": "Dışa Aktar",
    "aiAdvisor.inputPlaceholder": "Yapay zekaya müzik kariyerinizle ilgili bir soru sorun...",
    "aiAdvisor.prompts.audienceAnalysis": "Hedef kitle analizi",
    "aiAdvisor.prompts.brandingAdvice": "Marka oluşturma tavsiyeleri",
    "aiAdvisor.prompts.growthTips": "Büyüme önerileri ver",
    "aiAdvisor.prompts.livePerformance": "Canlı performans stratejisi",
    "aiAdvisor.prompts.playlistPitching": "Playlist pitching stratejisi",
    "aiAdvisor.prompts.releaseStrategy": "Yayın stratejim ne olmalı?",
    "aiAdvisor.prompts.revenueOptimization": "Gelir optimizasyonu",
    "aiAdvisor.prompts.socialMediaPlan": "Sosyal medya planı oluştur",
    "aiAdvisor.stats.accountStatus": "Hesap Durumu",
    "aiAdvisor.stats.active": "Aktif",
    "aiAdvisor.success.chatCleared": "Sohbet temizlendi.",
    "aiAdvisor.success.chatExported": "Sohbet dışa aktarıldı.",
    "aiAdvisor.success.ticketCreated": "Destek talebiniz oluşturuldu.",
    "aiAdvisor.support.cancel": "İptal",
    "aiAdvisor.support.desc": "Müşteri temsilcilerimiz en kısa sürede sizinle iletişime geçecektir.",
    "aiAdvisor.support.send": "Gönder",
    "aiAdvisor.support.title": "Destek Talebi Oluştur",
    "aiAdvisor.supportSubject": "AI Danışman - Destek Talebi",
    "aiAdvisor.tipDesc": "Daha kesin sonuçlar almak için yapay zekaya spesifik detaylar verin.",
    "aiAdvisor.tipTitle": "İpucu",
    "aiAdvisor.welcomeDesc": "Müzik endüstrisi, yayın stratejileri, pazarlama ve gelir artırma gibi konularda sorular sorabilirsiniz.",
    "aiAdvisor.welcomeTitle": "Nasıl Yardımcı Olabilirim?",
    "aiAdvisor.you": "Sen",
    "aiMatcher.aiStrategyTips": "Yapay Zeka Strateji Önerileri",
    "aiMatcher.analysisComplete": "Yapay zeka analizi tamamlandı",
    "aiMatcher.analysisResults": "Analiz Sonuçları",
    "aiMatcher.analyzingDesc": "Parçanızın özellikleri binlerce çalma listesiyle karşılaştırılıyor.",
    "aiMatcher.analyzingDna": "Müzikal DNA Analiz Ediliyor...",
    "aiMatcher.description": "Gelişmiş algoritmalarımızla müziğinizin potansiyelini keşfedin.",
    "aiMatcher.errorAnalysis": "Analiz sırasında bir hata oluştu.",
    "aiMatcher.errorLoading": "Veriler yüklenirken bir hata oluştu.",
    "aiMatcher.errorSelectRelease": "Lütfen bir yayın seçin",
    "aiMatcher.genreAnalysis": "Tür Analizi",
    "aiMatcher.highPotential": "Yüksek Potansiyel",
    "aiMatcher.newAnalysis": "Yeni Analiz",
    "aiMatcher.noPastAnalyses": "Henüz geçmiş analiz bulunmuyor.",
    "aiMatcher.noReleases": "Analiz edilecek onaylanmış müzik bulunamadı.",
    "aiMatcher.overallScore": "Genel Uyumluluk Skoru",
    "aiMatcher.pastAnalyses": "Geçmiş Analizler",
    "aiMatcher.perfectMatch": "Mükemmel Eşleşme",
    "aiMatcher.selectRelease": "Analiz Edilecek Yayını Seçin",
    "aiMatcher.single": "Single",
    "aiMatcher.startAnalysis": "Analizi Başlat",
    "aiMatcher.suggestedTiming": "Önerilen Yayın Zamanı",
    "aiMatcher.targetPlaylists": "Hedef Çalma Listeleri",
    "aiMatcher.unknown": "Bilinmiyor",
    "aiStudio.analyze": "Analiz Et",
    "aiStudio.audioRepairDesc": "Clipping ve bozulmaları onarın",
    "aiStudio.audioRepairName": "AI Ses Onarımı",
    "aiStudio.clarity": "Netlik",
    "aiStudio.clean": "Temiz",
    "aiStudio.copyrightDesc": "Olası telif sorunlarını denetleyin",
    "aiStudio.copyrightName": "AI Telif Tarayıcı",
    "aiStudio.coverGenDesc": "Metinden albüm kapağı üretin",
    "aiStudio.coverGenName": "AI Kapak Oluşturucu",
    "aiStudio.desc": "Yapay zeka destekli profesyonel müzik araçları merkezi.",
    "aiStudio.description": "Açıklama",
    "aiStudio.distReadyDesc": "Dağıtım standartlarını kontrol edin",
    "aiStudio.distReadyName": "AI Dağıtım Hazırlığı",
    "aiStudio.download": "İndir",
    "aiStudio.downloading": "Dosya indiriliyor...",
    "aiStudio.dragDropClick": "Sürükleyip bırakın veya seçmek için tıklayın",
    "aiStudio.dynamic": "Dinamik",
    "aiStudio.failed": "Başarısız",
    "aiStudio.frequency": "Frekans",
    "aiStudio.genreDetDesc": "Ses dosyasından tür tespiti",
    "aiStudio.genreDetName": "AI Tür Tespiti",
    "aiStudio.history": "Geçmiş",
    "aiStudio.intensity": "Yoğunluk",
    "aiStudio.issue": "Sorunlu",
    "aiStudio.loudnessOptDesc": "Hedef LUFS değerine optimize edin",
    "aiStudio.loudnessOptName": "AI Ses Seviyesi Opt.",
    "aiStudio.lyricVideoDesc": "Zamanlamalı şarkı sözü videosu",
    "aiStudio.lyricVideoName": "AI Lirik Videosu",
    "aiStudio.lyrics": "Şarkı Sözleri",
    "aiStudio.lyricsPlaceholder": "Şarkı sözlerini buraya yapıştırın...",
    "aiStudio.metadataGenDesc": "Başlık, açıklama ve etiket üretin",
    "aiStudio.metadataGenName": "AI Meta Veri Üretici",
    "aiStudio.modules": "Modüller",
    "aiStudio.moodDetDesc": "Enerji ve duygu analizi",
    "aiStudio.moodDetName": "AI Ruh Hali Tespiti",
    "aiStudio.musicVideoDesc": "Sese duyarlı video üretin",
    "aiStudio.musicVideoName": "AI Müzik Videosu",
    "aiStudio.needAudioFile": "Lütfen önce bir ses dosyası yükleyin",
    "aiStudio.needPrompt": "Lütfen bir istem (prompt) girin",
    "aiStudio.noFileToDownload": "İndirilecek dosya yok",
    "aiStudio.noFileToPlay": "Oynatılacak dosya yok",
    "aiStudio.noHistory": "Henüz hiçbir işlem yapmadınız.",
    "aiStudio.noiseRemovalDesc": "Arka plan gürültüsünü temizleyin",
    "aiStudio.noiseRemovalName": "AI Gürültü Temizleme",
    "aiStudio.passed": "Geçti",
    "aiStudio.processError": "İşlem sırasında hata oluştu",
    "aiStudio.processHistory": "İşlem Geçmişi",
    "aiStudio.processSuccess": "İşlem başarıyla tamamlandı!",
    "aiStudio.processing": "İşleniyor...",
    "aiStudio.promptPlaceholder": "Örn: Karanlık bir ormanda neon ışıklı bir synthwave aracı...",
    "aiStudio.qualityScoreDesc": "Ses kalitesini 0-100 arası puanlayın",
    "aiStudio.qualityScoreName": "AI Ses Kalite Skoru",
    "aiStudio.resultsReady": "Sonuçlar Hazır",
    "aiStudio.startProcess": "İşlemi Başlat",
    "aiStudio.stemSepDesc": "Vokal, davul ve bası ayırın",
    "aiStudio.stemSepName": "AI Stem Ayırma",
    "aiStudio.suggestedTitle": "Önerilen Başlık",
    "aiStudio.tags": "Etiketler",
    "aiStudio.title": "AI Studio",
    "aiStudio.uploadAudioFile": "Ses Dosyası Yükleyin",
    "aiStudio.view": "Görüntüle",
    "aiStudio.visualPrompt": "Görsel İstemi (Prompt)",
    "aiStudio.vocalEnhDesc": "Vokal netliğini ve parlaklığını artırın",
    "aiStudio.vocalEnhName": "AI Vokal İyileştirme",
    "aiVideo.addedToList": "Harika! Listeye Eklendiniz",
    "aiVideo.beFirst": "İlk Deneyenlerden Olun",
    "aiVideo.desc": "Yapay zeka destekli müzik videoları çok yakında!",
    "aiVideo.emailPlaceholder": "E-posta adresiniz...",
    "aiVideo.enterEmail": "Lütfen bir e-posta adresi girin",
    "aiVideo.hdDesc": "Profesyonel yayınlar için 1080p ve 4K çözünürlük",
    "aiVideo.hdTitle": "HD Kalite",
    "aiVideo.joinWaitlist": "Erken erişim için bekleme listesine katılın.",
    "aiVideo.notifyMe": "Bilgilendir Beni",
    "aiVideo.premiumFeature": "Premium Özellik",
    "aiVideo.styleDesc": "Sinematik, anime, soyut dahil 8+ farklı görsel stil",
    "aiVideo.styleTitle": "Stil Seçimi",
    "aiVideo.syncDesc": "Müziğin ritmine ve frekanslarına tam otomatik uyum",
    "aiVideo.syncTitle": "Otomatik Senkronizasyon",
    "aiVideo.textToVideoDesc": "Prompt yazarak hayalinizdeki sahneyi anında oluşturun",
    "aiVideo.textToVideoTitle": "Metinden Videoya",
    "aiVideo.title": "AI Video Oluşturucu",
    "aiVideo.waitlistSuccess": "Bekleme listesine eklendiniz!",
    "aiVideo.willNotify": "Özellik yayınlandığında size haber vereceğiz.",
    "analytics.audienceDemographics": "Kitle Demografisi",
    "analytics.azerbaijan": "Azerbaycan",
    "analytics.estimatedRevenue": "Tahmini Gelir",
    "analytics.female": "Kadın",
    "analytics.geographicDistribution": "Coğrafi Dağılım",
    "analytics.germany": "Almanya",
    "analytics.male": "Erkek",
    "analytics.noData": "Henüz Veri Yok",
    "analytics.noTrackData": "Henüz parça verisi yok",
    "analytics.other": "Diğer",
    "analytics.otherCountries": "Diğer",
    "analytics.popularTrack": "Popüler Parça",
    "analytics.popularityScore": "Popülerlik Skoru",
    "analytics.refresh": "Yenile",
    "analytics.refreshData": "Verileri Yenile",
    "analytics.revenueForecast": "Gelir Tahmini (6 Ay)",
    "analytics.streamsTrend": "Dinlenme Trendi",
    "analytics.totalStreamsStat": "Toplam Dinlenme",
    "analytics.turkey": "Türkiye",
    "analytics.usa": "ABD",
    "artistConnections.apiIntegration": "API Entegrasyonu",
    "artistConnections.betaTesting": "Beta Test",
    "artistConnections.centralManagement": "Tek Yerden Yönetim",
    "artistConnections.centralManagementDesc": "Tüm platformlardaki sanatçı profillerinizi tek panelden yönetin.",
    "artistConnections.comingSoon": "Yakında Geliyor",
    "artistConnections.description": "Müzik platformlarındaki sanatçı profillerinizi tek yerden bağlayın ve yönetin.",
    "artistConnections.developmentProgress": "Geliştirme İlerlemesi",
    "artistConnections.instantSync": "Anlık Senkronizasyon",
    "artistConnections.instantSyncDesc": "Profil güncellemeleri tüm bağlı platformlara otomatik yansır.",
    "artistConnections.notifyMe": "Hazır Olduğunda Bildir",
    "artistConnections.release": "Yayın",
    "artistConnections.secureConnection": "Güvenli Bağlantı",
    "artistConnections.secureConnectionDesc": "OAuth 2.0 ile güvenli platform doğrulama ve veri erişimi.",
    "artistConnections.supportedPlatforms": "Desteklenecek Platformlar",
    "artistConnections.title": "Sanatçı Bağlantıları",
    "artistConnections.uiDesign": "UI Tasarımı",
    "artistConnections.unifiedAnalytics": "Birleşik Analitik",
    "artistConnections.unifiedAnalyticsDesc": "Tüm platformlardan gelen verileri tek bir dashboard'da görün.",
    "bioLink.addNewLink": "Yeni Bağlantı Ekle",
    "bioLink.artistName": "Sanatçı Adı",
    "bioLink.avatarUpdated": "Profil resmi güncellendi!",
    "bioLink.bgUploaded": "Arka plan yüklendi",
    "bioLink.bioLabel": "Biyografi",
    "bioLink.change": "Değiştir",
    "bioLink.copy": "Kopyala",
    "bioLink.ctr": "Tıklama Oranı (CTR)",
    "bioLink.customBgImage": "Özel Arka Plan Resmi",
    "bioLink.defaultBio": "Müzik ve daha fazlası...",
    "bioLink.defaultLink1": "Yeni Teklimi Dinle",
    "bioLink.defaultLink2": "Resmi Web Sitem",
    "bioLink.description": "Tek bir link ile tüm dijital varlığınızı yönetin",
    "bioLink.errorFileSize": "Dosya boyutu 5MB'dan küçük olmalı",
    "bioLink.errorSelectImage": "Lütfen bir resim dosyası seçin",
    "bioLink.latestReleases": "Son Yayınlar",
    "bioLink.linkCopied": "Bağlantı kopyalandı!",
    "bioLink.linkTitlePlaceholder": "Bağlantı Başlığı",
    "bioLink.newLink": "Yeni Bağlantı",
    "bioLink.presetThemes": "Hazır Temalar",
    "bioLink.profileNameLabel": "Profil İsmi",
    "bioLink.qrCode": "QR Kod",
    "bioLink.save": "Kaydet",
    "bioLink.saveError": "Kaydedilirken bir hata oluştu",
    "bioLink.saveSuccess": "Bio linkiniz başarıyla kaydedildi!",
    "bioLink.saving": "Kaydediliyor...",
    "bioLink.socialsDesc": "Profilinizde görünecek sosyal medya hesaplarınızı ekleyin.",
    "bioLink.tabLinks": "Bağlantılar",
    "bioLink.tabProfile": "Profil",
    "bioLink.tabSocials": "Sosyal Medya",
    "bioLink.tabTheme": "Görünüm",
    "bioLink.title": "Akıllı Bio Link",
    "bioLink.totalClicks": "Toplam Tıklama",
    "bioLink.totalViews": "Toplam Görüntülenme",
    "bioLink.unknown": "Bilinmiyor",
    "bioLink.untitled": "Başlıksız",
    "bioLink.uploadBgImage": "Arka plan resmi yükle",
    "bioLink.uploadFailed": "Yükleme başarısız",
    "campaigns.approved": "Onaylandı",
    "campaigns.approvedCount": "Onaylanan",
    "campaigns.back": "Geri",
    "campaigns.cancelled": "İptal",
    "campaigns.createNewCampaign": "Yeni Kampanya Oluştur",
    "campaigns.createSuccess": "Kampanya başarıyla oluşturuldu!",
    "campaigns.date": "Tarih",
    "campaigns.newCampaign": "Yeni Kampanya",
    "campaigns.newPitchCampaign": "Yeni Pitch Kampanyası",
    "campaigns.next": "İleri",
    "campaigns.noCampaigns": "Kampanya Bulunamadı",
    "campaigns.noCampaignsDesc": "Bu filtrelere uygun bir kampanya bulunmuyor.",
    "campaigns.noMessage": "Mesaj girilmedi",
    "campaigns.pending": "Beklemede",
    "campaigns.pendingCount": "Bekleyen",
    "campaigns.pitchMessage": "Pitch Mesajı",
    "campaigns.pitchPlaceholder": "Örn: Bu parça yaz enerjisini yansıtıyor...",
    "campaigns.reachPotential": "Erişim Pot.",
    "campaigns.rejected": "Reddedildi",
    "campaigns.rejectedCount": "Reddedilen",
    "campaigns.selectedRelease": "Seçilen Yayın",
    "campaigns.startCampaign": "Kampanyayı Başlat",
    "campaigns.step1Desc": "Kampanyasını oluşturmak istediğiniz yayını seçin.",
    "campaigns.step1Title": "1. Yayın Seçimi",
    "campaigns.step2Desc": "Yayınınızı önermek istediğiniz küratörleri/listeleri seçin.",
    "campaigns.step2Title": "2. Hedef Listeler",
    "campaigns.step3Desc": "Küratörlere parçanızı neden listeye almaları gerektiğini anlatın.",
    "campaigns.step3Title": "3. Pitch Mesajı",
    "campaigns.subtitle": "Çalma listesi başvurularınızı yönetin ve takip edin",
    "campaigns.summaryTitle": "Özet & Onay",
    "campaigns.target": "Hedef",
    "campaigns.targetPlaylists": "Hedef Listeler",
    "campaigns.title": "Kampanyalar",
    "campaigns.totalApplications": "Toplam Başvuru",
    "canvasStudio.aiEffectsDesc": "Yapay zeka destekli görsel efektler ve filtreler",
    "canvasStudio.aiEffectsTitle": "AI Effects",
    "canvasStudio.aiVideoGenDesc": "Yapay zeka ile müzik videolarınızı otomatik oluşturun",
    "canvasStudio.aiVideoGenTitle": "AI Video Generator",
    "canvasStudio.audioVisDesc": "Müziğinize uyumlu gerçek zamanlı görselleştirme",
    "canvasStudio.audioVisTitle": "Audio Visualizer",
    "canvasStudio.autoSyncDesc": "Müzik ritmine otomatik senkronize görsel efektler",
    "canvasStudio.autoSyncTitle": "Auto Sync",
    "canvasStudio.canvasTempDesc": "Spotify Canvas için profesyonel animasyon şablonları",
    "canvasStudio.canvasTempTitle": "Canvas Templates",
    "canvasStudio.desc": "Canvas Studio şu anda yeni özellikler için bakımdadır. Çok yakında geri dönecek!",
    "canvasStudio.maintenance": "Bakımda — Yakında Yeni Özelliklerle",
    "canvasStudio.motionGraphDesc": "Profesyonel motion graphics ve animasyonlar",
    "canvasStudio.motionGraphTitle": "Motion Graphics",
    "canvasStudio.notify": "Bu özellik güncellendiğinde bildirim alacaksınız",
    "canvasStudio.title": "Canvas Studio",
    "canvasStudio.upcoming": "Gelecek Özellikler",
    "contributors.addNew": "Yeni Ekle",
    "contributors.release": "Yayın",
    "contributors.pay": "Pay",
    "contributors.invite": "Davetiye Gönder",
    "contributors.remove": "Kaldır",
    "contributors.allReleases": "Tüm Yayınlar",
    "contributors.allRoles": "Tüm Roller",
    "contributors.desc": "Ekibinizi, ortaklarınızı ve telif paylaşımlarını yönetin.",
    "contributors.empty.desc": "Arama kriterlerinize uyan kimse yok.",
    "contributors.empty.title": "Katılımcı Bulunamadı",
    "contributors.errors.fillFields": "Lütfen tüm zorunlu alanları doldurun.",
    "contributors.modal.cancel": "İptal",
    "contributors.modal.email": "E-posta",
    "contributors.modal.name": "İsim Soyisim",
    "contributors.modal.release": "İlişkili Yayın (İsteğe Bağlı)",
    "contributors.modal.role": "Rol",
    "contributors.modal.save": "Kaydet",
    "contributors.modal.split": "Pay (%)",
    "contributors.modal.title": "Yeni Katılımcı Ekle",
    "contributors.searchPlaceholder": "İsim veya e-posta ile ara...",
    "contributors.stats.avgSplit": "Ortalama Pay",
    "contributors.stats.commonRole": "En Yaygın Rol",
    "contributors.stats.total": "Toplam Katılımcı",
    "contributors.success.added": "Katılımcı başarıyla eklendi!",
    "contributors.success.deleted": "Katılımcı silindi.",
    "contributors.success.invited": "Davetiye gönderildi!",
    "contributors.title": "Katılımcı Yöneticisi",
    "feature.disabled": "Özellik Devre Dışı",
    "feature.disabledDesc": "Bu özellik hesabınız için yönetici tarafından devre dışı bırakılmıştır.",
    "lyrics.aiGenerate": "Yapay Zeka",
    "lyrics.aiGenerating": "Üretiliyor...",
    "lyrics.desc": "Şarkı sözlerinizi yönetin, senkronize edin ve çeviriler ekleyin.",
    "lyrics.editorSubtitle": "Şarkı Sözleri Düzenleyicisi",
    "lyrics.empty.notFound": "Şarkı bulunamadı",
    "lyrics.emptyState.desc": "Düzenlemeye başlamak için sol taraftan bir şarkı seçin.",
    "lyrics.emptyState.title": "Şarkı Sözlerini Yönetin",
    "lyrics.errors.aiFailed": "Söz üretilirken hata oluştu.",
    "lyrics.errors.loadFailed": "Veriler yüklenirken hata oluştu.",
    "lyrics.errors.noLyrics": "Dışa aktarılacak söz yok",
    "lyrics.errors.saveFailed": "Kaydedilirken hata oluştu.",
    "lyrics.errors.selectTrack": "Lütfen bir şarkı seçin",
    "lyrics.export": "Dışa Aktar",
    "lyrics.labels.originalLang": "Orijinal Dil",
    "lyrics.labels.translationLang": "Çeviri (İngilizce)",
    "lyrics.placeholders.editor": "Şarkı sözlerinizi buraya yazın...",
    "lyrics.placeholders.translation": "Çeviriyi buraya yazın...",
    "lyrics.save": "Kaydet",
    "lyrics.searchPlaceholder": "Şarkı veya yayın ara...",
    "lyrics.stats.completion": "Tamamlanma",
    "lyrics.stats.totalTracks": "Toplam Şarkı",
    "lyrics.success.aiGenerated": "Yapay zeka şarkı sözleri oluşturuldu!",
    "lyrics.success.downloaded": "formatında indirildi!",
    "lyrics.success.saved": "Şarkı sözleri kaydedildi!",
    "lyrics.success.updated": "Şarkı sözleri güncellendi!",
    "lyrics.synced.desc": "Çok yakında! Senkronize sözler oluşturabileceksiniz.",
    "lyrics.synced.title": "Senkronize Söz Modu",
    "lyrics.tabs.editor": "Metin Editörü",
    "lyrics.tabs.synced": "Senkronizasyon",
    "lyrics.tabs.translation": "Çeviri",
    "lyrics.title": "Şarkı Sözü Yöneticisi",
    "mastering.acoustic": "Akustik",
    "mastering.additionalProcessing": "Ek İşleme",
    "mastering.advancedParams": "Gelişmiş Parametreler",
    "mastering.aiAnalyzing": "AI Analiz Yapılıyor...",
    "mastering.aiDetected": "AI Algıladı",
    "mastering.aiRecommendations": "AI Önerileri",
    "mastering.analysis": "Analiz",
    "mastering.analyzing": "Analiz ediliyor...",
    "mastering.analyzingDesc": "Ses özellikleri, tempo, frekans dağılımı analiz ediliyor...",
    "mastering.audioFeatures": "Ses Özellikleri",
    "mastering.bass": "Bass (Low)",
    "mastering.brightness": "Parlaklık",
    "mastering.broadcast": "Yayın",
    "mastering.broadcastDesc": "TV/Radyo standartları (-23 LUFS)",
    "mastering.cdQuality": "CD Kalitesi",
    "mastering.cdQualityDesc": "Fiziksel yayın için ideal (-12 LUFS)",
    "mastering.classical": "Klasik",
    "mastering.clickToChangeFile": "MB — Başka dosya seçmek için tıklayın",
    "mastering.clubDJ": "Club/DJ",
    "mastering.clubDJDesc": "Gece kulübü ses sistemleri için (-10 LUFS)",
    "mastering.completed": "Tamamlandı",
    "mastering.compression": "Kompresyon",
    "mastering.confidence": "Güven",
    "mastering.creditDeducted": "1 master kredisi düşülecek",
    "mastering.desc": "Yapay zeka ile otomatik profesyonel mastering",
    "mastering.downloadFailed": "İndirme başarısız.",
    "mastering.downloadMaster": "Master İndir",
    "mastering.downloading": "Mastered dosya indiriliyor!",
    "mastering.dragDrop": "Sürükle & Bırak",
    "mastering.dragDropClick": "Şarkınızı sürükleyin veya tıklayın",
    "mastering.dynamicRange": "Dinamik Aralık",
    "mastering.edm": "EDM",
    "mastering.energyDistribution": "Enerji Dağılımı",
    "mastering.eq": "Ekolayzır (EQ)",
    "mastering.errors.masterFailed": "Mastering başarısız",
    "mastering.errors.uploadFailed": "Yükleme başarısız",
    "mastering.fileConstraints": "WAV, MP3, FLAC, AIFF • Maks 100MB",
    "mastering.flac": "FLAC",
    "mastering.flacDesc": "Kayıpsız sıkıştırma",
    "mastering.format": "Format",
    "mastering.genreAnalysis": "Tür Analizi",
    "mastering.hiphop": "Hip-Hop",
    "mastering.jazz": "Jazz",
    "mastering.lofi": "Lo-Fi",
    "mastering.loudMaster": "Loud Master",
    "mastering.loudMasterDesc": "Maksimum etki için yüksek ses (-8 LUFS)",
    "mastering.masterTrack": "Master Yap",
    "mastering.mastered": "Masterlanmış",
    "mastering.masteringHistory": "Mastering Geçmişi",
    "mastering.masteringPreset": "Mastering Preset",
    "mastering.masteringProcessing": "Mastering İşleniyor...",
    "mastering.metal": "Metal",
    "mastering.metricsComp": "Metrik Karşılaştırma",
    "mastering.mixMastering": "Mix Mastering",
    "mastering.mp3_192": "MP3 192kbps",
    "mastering.mp3_192Desc": "Standart kalite",
    "mastering.mp3_320": "MP3 320kbps",
    "mastering.mp3_320Desc": "Yüksek kalite, küçük boyut",
    "mastering.newFile": "Yeni Dosya",
    "mastering.noHistory": "Henüz mastering geçmişi bulunmuyor.",
    "mastering.normal": "Normal",
    "mastering.normalDesc": "Standart AI Mastering",
    "mastering.optional": "(Opsiyonel)",
    "mastering.original": "Orijinal",
    "mastering.outputFormat": "Çıkış Formatı",
    "mastering.podcast": "Podcast",
    "mastering.pop": "Pop",
    "mastering.preset": "Preset",
    "mastering.processFailed": "AI Mastering başarısız oldu.",
    "mastering.processSuccess": "AI Mastering tamamlandı! 🎉",
    "mastering.processing": "İşleme",
    "mastering.processingDesc": "EQ, kompresör, limiter, loudness normalizasyonu uygulanıyor...",
    "mastering.refTrackAiNote": "AI, bu parçanın tonal dengesini analiz edip uygulayacak",
    "mastering.refTrackUploadDesc": "Hedef ses profiline sahip bir referans parça yükleyin",
    "mastering.refTrackUploaded": "Referans parça yüklendi",
    "mastering.reference": "Referans",
    "mastering.referenceTrack": "Referans Parça",
    "mastering.resetToDefault": "Varsayılana Sıfırla",
    "mastering.reverb": "Reverb",
    "mastering.reverbDesc": "Zengin reverb efekti",
    "mastering.rnb": "R&B",
    "mastering.rock": "Rock",
    "mastering.saturation": "Satürasyon",
    "mastering.selectEffect": "Efekt Seçin",
    "mastering.selectTarget": "Hedef seç...",
    "mastering.slowed": "Slowed",
    "mastering.slowedDesc": "Yavaşlatılmış (0.82x)",
    "mastering.slowedReverb": "Slowed + Reverb",
    "mastering.slowedReverbDesc": "Yavaş + reverb",
    "mastering.speedReverb": "Speed Up + Reverb",
    "mastering.speedReverbDesc": "Hızlı + reverb",
    "mastering.speedUp": "Speed Up",
    "mastering.speedUpDesc": "Hızlandırılmış (1.25x)",
    "mastering.startAiMastering": "AI Mastering Başlat",
    "mastering.stepAnalyze": "AI Analiz",
    "mastering.stepDone": "Tamamlandı",
    "mastering.stepProcess": "İşleniyor",
    "mastering.stepUpload": "Yükle",
    "mastering.stereoWidth": "Stereo Genişlik",
    "mastering.streaming": "Streaming",
    "mastering.streamingDesc": "Spotify/Apple Music için optimize (-14 LUFS)",
    "mastering.subtitle": "Manuel profesyonel ses işleme",
    "mastering.success.masteredDesc": "Şarkınız indirmeye hazır.",
    "mastering.success.masteredTitle": "Mastering tamamlandı!",
    "mastering.success.uploaded": "Dosya yüklendi ve analiz edildi!",
    "mastering.title": "AI Mastering",
    "mastering.treble": "Treble (High)",
    "mastering.unsupportedFormat": "Desteklenmeyen dosya formatı.",
    "mastering.uploadFormat": "Master edilmemiş mixinizi yükleyin (WAV, FLAC, MP3)",
    "mastering.uploadTrack": "Parça Yükle",
    "mastering.vinyl": "Vinyl",
    "mastering.vinylDesc": "Sıcak analog hissi, dinamik aralık korunur",
    "mastering.wav16": "WAV 16-bit",
    "mastering.wav16Desc": "CD kalitesinde",
    "mastering.wav24": "WAV 24-bit",
    "mastering.wav24Desc": "En yüksek kalite, stüdyo standardı",
    "playlistExplorer.addedToFavs": "Favorilere eklendi",
    "playlistExplorer.emptyDesc": "En uygun çalma listelerini bulmak için arama çubuğunu kullanın.",
    "playlistExplorer.emptyTitle": "Arama yapın veya filtreleri kullanın",
    "playlistExplorer.filters": "Filtreler",
    "playlistExplorer.findSimilar": "Benzerlerini Bul",
    "playlistExplorer.followers": "Takipçi",
    "playlistExplorer.genre": "Tür",
    "playlistExplorer.noFavs": "Henüz favori listeniz bulunmuyor.",
    "playlistExplorer.platform": "Platform",
    "playlistExplorer.removedFromFavs": "Favorilerden çıkarıldı",
    "playlistExplorer.risky": "Riskli",
    "playlistExplorer.saveSearch": "Aramayı Kaydet",
    "playlistExplorer.search": "Ara",
    "playlistExplorer.searchPlaceholder": "Çalma listesi, küratör veya anahtar kelime ara...",
    "playlistExplorer.subtitle": "Gelişmiş filtreler ve yapay zeka ile en uygun listeleri bulun",
    "playlistExplorer.tabExplore": "Keşfet",
    "playlistExplorer.tabFavorites": "Favoriler",
    "playlistExplorer.tabSaved": "Kayıtlı Aramalar",
    "playlistExplorer.title": "Çalma Listesi Keşfet",
    "playlistExplorer.verified": "Doğrulanmış",
    "playlistExplorer.applyTitle": "Playlist Başvurusu",
    "playlistExplorer.applySuccess": "Başvuru başarıyla gönderildi!",
    "playlistExplorer.applyError": "Başvuru gönderilemedi",
    "playlistExplorer.selectRelease": "Yayın Seçin",
    "playlistExplorer.pitchMessage": "Pitch Mesajı (İsteğe bağlı)",
    "playlistExplorer.pitchPlaceholder": "Şarkım bu playlist'e çok uygun çünkü...",
    "playlistExplorer.sending": "Gönderiliyor...",
    "playlistExplorer.send": "Gönder",
    "playlistExplorer.loadingReleases": "Yayınlar yükleniyor...",
    "playlistExplorer.noReleases": "Hiç yayınınız bulunmuyor.",
    "preSave.appleMusicId": "Apple Music Kimliği",
    "preSave.applePlaceholder": "123456789",
    "preSave.spotifyPlaceholder": "spotify:album:...",
    "preSave.spotifyUri": "Spotify URI",
    "promotions.artist": "Sanatçı",
    "promotions.download": "İndir",
    "promotions.downloadInstructions": "İndirmek için karta tıklayın.",
    "promotions.downloading": "İndiriliyor...",
    "promotions.generating": "Promosyon kartları oluşturuluyor...",
    "promotions.generatingWait": "Bu işlem birkaç saniye sürebilir",
    "promotions.noApprovedRelease": "Henüz onaylanmış bir yayın yok",
    "promotions.noApprovedReleaseDesc": "Promosyon kartları, yayınınız onaylanıp yayına girdikten sonra görünecektir.",
    "promotions.noRelease": "Henüz yayınlanmış bir kayıt yok",
    "promotions.selectPlaceholder": "Bir yayın seçin...",
    "promotions.selectReleaseDesc": "Yayınlarınızı tanıtmak için dikkat çekici görseller oluşturun.",
    "promotions.selectReleasePrompt": "Promosyon kartlarını görmek için bir yayın seçin",
    "promotions.statusApproved": "Onaylandı",
    "promotions.statusLive": "Yayında",
    "promotions.subtitle": "Sosyal medyada paylaşmak için yayınını seç ve promosyon kartlarını indir.",
    "promotions.title": "Promosyon Kartları",
    "promotions.untitled": "İsimsiz",
    "promotions.untitledTrack": "İsimsiz Parça",
    "qr.cancel": "İptal",
    "qr.createError": "QR kod oluşturulamadı",
    "qr.createSuccess": "QR Kod başarıyla oluşturuldu",
    "qr.deleteError": "QR kod silinemedi",
    "qr.deleteSuccess": "QR Kod başarıyla silindi",
    "qr.fetchError": "QR kodları getirilemedi",
    "qr.formTitle": "Başlık",
    "qr.requiredFields": "Başlık ve URL zorunludur",
    "qr.subtitle": "İçeriğiniz için özel QR kodları oluşturun ve yönetin",
    "qr.titlePlaceholder": "örn. Yaz Turnesi 2024",
    "smartLinks.basicInfo": "Temel Bilgiler",
    "smartLinks.customSlug": "Özel Uzantı",
    "smartLinks.slugPlaceholder": "yeni-teklim",
    "smartLinks.titlePlaceholder": "örn. Yeni Teklim",
    "splits.accept": "Kabul Et",
    "splits.activeSplits": "Aktif Paylaşımlar",
    "splits.chooseLiveRelease": "Yayında olan bir kayıt seçin",
    "splits.contributing": "Katkıda Bulunduklarım",
    "splits.contributingTo": "Katkıda Bulunulan Paylaşım",
    "splits.createBtn": "Yeni Paylaşım Oluştur",
    "splits.createModalDesc": "Gelir paylaşımı oluşturmak üzere yayında olan bir kayıt seçin",
    "splits.createModalTitle": "Gelir Paylaşımı Oluştur",
    "splits.currentBalance": "Mevcut Bakiye",
    "splits.decline": "Reddet",
    "splits.earningsByTrack": "Parçaya Göre Kazanç",
    "splits.errorCreate": "Gelir paylaşımı oluşturulamadı",
    "splits.errorLoad": "Split verileri yüklenemedi",
    "splits.errorNoTrack": "Bu yayında parça bulunamadı",
    "splits.errorRespond": "Yanıt gönderilemedi",
    "splits.errorSelectRelease": "Lütfen bir yayın seçin",
    "splits.from": "Kimden:",
    "splits.inviteAccepted": "Davet kabul edildi!",
    "splits.inviteDeclined": "Davet reddedildi",
    "splits.live": "Yayında",
    "splits.mySplits": "Paylaşımlarım",
    "splits.noContributingSplits": "Henüz herhangi bir paylaşıma katkıda bulunmuyorsunuz.",
    "splits.noContributingSplitsDesc": "İşbirliklerinden kazanmak için davetleri kabul edin.",
    "splits.noLiveReleases": "Gelir paylaşımı oluşturmak için en az bir aktif yayınınız olmalıdır.",
    "splits.noOwnedSplits": "Henüz gelir paylaşımı oluşturmadınız.",
    "splits.noOwnedSplitsDesc": "Parça yüklerken ortak çalışanlar ekleyin.",
    "splits.onlyLiveReleases": "Sadece yayında olan yayınlar için gelir paylaşımı oluşturulabilir",
    "splits.owner": "Sahibi:",
    "splits.pendingInvitations": "Bekleyen Davetler",
    "splits.pendingInvitationsDesc": "Bekleyen gelir paylaşımı davetleriniz var",
    "splits.roleContributor": "Katkıda Bulunan",
    "splits.roleFeaturedArtist": "Eşlik Eden Sanatçı",
    "splits.roleProducer": "Prodüktör",
    "splits.roleSongwriter": "Söz Yazarı",
    "splits.selectRelease": "Yayın Seç *",
    "splits.subtitle": "Ortak çalışanlarla gelir paylaşımını yönetin",
    "splits.successCreated": "Gelir paylaşımı başarıyla oluşturuldu!",
    "splits.title": "Gelir Paylaşımı",
    "splits.totalEarned": "Toplam Kazanılan",
    "splits.trackId": "Parça ID:",
    "splits.trackSplit": "Parça Paylaşımı",
    "splits.untitled": "İsimsiz",
    "splits.you": "(Sen)",
    "splits.yourShare": "Senin Payın",
    "subscription.advanced": "Gelişmiş",
    "subscription.artistDesc": "Ciddi sanatçılar için",
    "subscription.basic": "Temel",
    "subscription.choosePlan": "Planını Seç",
    "subscription.commission": "Komisyon",
    "subscription.contactSupport": "Planlar hakkında sorularınız varsa destek ekibimizle iletişime geçin.",
    "subscription.contactSupportBtn": "Destek ile İletişim",
    "subscription.currentPlan": "Mevcut Plan:",
    "subscription.currentPlanBtn": "Mevcut Plan",
    "subscription.days25": "2-5 gün",
    "subscription.downgrade": "Düşür",
    "subscription.email": "E-posta",
    "subscription.fastDelivery": "Hızlı teslim",
    "subscription.featAnalytics": "Analitik",
    "subscription.featCommission": "Komisyon Oranı",
    "subscription.featDelivery": "Teslim Süresi",
    "subscription.featMultiArtist": "Çoklu Sanatçı",
    "subscription.featReleaseLimit": "Yayın Limiti",
    "subscription.featSplits": "Split Sistemi",
    "subscription.featSupport": "Destek",
    "subscription.feature": "Özellik",
    "subscription.featureComparison": "Özellik Karşılaştırması",
    "subscription.free": "Ücretsiz",
    "subscription.freeDesc": "Müzik yolculuğuna başla",
    "subscription.haveQuestions": "Sorularınız mı var?",
    "subscription.hours2472": "24-72 saat",
    "subscription.labelDesc": "Label ve yöneticiler için",
    "subscription.month": "ay",
    "subscription.paymentSoon": "Ödeme entegrasyonu yakında! Plan yükseltmek için destek ile iletişime geçin.",
    "subscription.popular": "Popüler",
    "subscription.priority": "Öncelikli",
    "subscription.release": "Yayın",
    "subscription.save17": "%17 tasarruf",
    "subscription.subtitle": "İhtiyacına uygun planı seç.",
    "subscription.title": "Müzik Kariyerini Büyüt",
    "subscription.unlimited": "Sınırsız",
    "subscription.upgrade": "Yükselt",
    "subscription.year": "yıl",
    "subscription.yearlyOr": "veya",
    "viral.activeCampaigns": "Aktif Kampanya",
    "viral.activeCampaignsList": "Aktif Kampanyalar",
    "viral.aiPlanning": "Yapay Zeka Planlıyor...",
    "viral.aiPlanningDesc": "En uygun viral strateji oluşturuluyor.",
    "viral.back": "Geri",
    "viral.campaignCreateError": "Kampanya oluşturulurken hata oluştu.",
    "viral.campaignLive": "Kampanya Yayında! 🎉",
    "viral.campaignLiveDesc": "Kampanyanız başarıyla oluşturuldu.",
    "viral.campaignPage": "Kampanya Sayfası",
    "viral.campaignSuccess": "Kampanya başarıyla başlatıldı!",
    "viral.cancel": "İptal Et",
    "viral.clicks": "Tıklama",
    "viral.contentCount": "İçerik Sayısı",
    "viral.contentIdeas": "İçerik Fikirleri",
    "viral.continue": "Devam Et",
    "viral.copied": "✓ Kopyalandı",
    "viral.copy": "Kopyala",
    "viral.createAIPlan": "AI Planı Oluştur",
    "viral.createNewCampaign": "Yeni Kampanya Oluştur",
    "viral.desc": "Yapay zeka destekli adım adım pazarlama planları oluşturun.",
    "viral.engagementRate": "Etkileşim Oranı",
    "viral.estReach": "Tahmini Erişim",
    "viral.globalImpactMap": "Küresel Etki Haritası",
    "viral.hashtagDesc": "Belirli bir etiket etrafında topluluk oluşturun",
    "viral.hashtagName": "Hashtag Kampanyası",
    "viral.launchCampaign": "Kampanyayı Başlat",
    "viral.launching": "Başlatılıyor",
    "viral.linkCopied": "Link kopyalandı!",
    "viral.listeningDesc": "Hayranlarla eşzamanlı çevrimiçi dinleme etkinliği",
    "viral.listeningName": "Dinleme Partisi",
    "viral.noActiveCampaigns": "Henüz aktif kampanya bulunmuyor.",
    "viral.noActiveCampaignsDesc": "İlk kampanyanızı oluşturmak için soldaki sihirbazı kullanın.",
    "viral.noReleases": "Henüz onaylı yayınınız bulunmuyor.",
    "viral.noReleasesDesc": "Kampanya oluşturmak için önce bir yayın oluşturun.",
    "viral.planError": "Plan oluşturulurken hata oluştu",
    "viral.platformLinks": "Platform Bağlantıları",
    "viral.platformLinksDesc": "Dinleyicilerin şarkınıza ulaşacağı bağlantıları girin",
    "viral.presaveDesc": "Dinleyicilerin yayını önceden kaydetmesini sağlayın",
    "viral.presaveName": "Pre-Save Kampanyası",
    "viral.progress": "İlerleme",
    "viral.release": "Yayın",
    "viral.selectCampaignType": "Kampanya Türünü Seçin",
    "viral.selectCampaignTypeDesc": "Hedefinize en uygun pazarlama stratejisini belirleyin.",
    "viral.selectRelease": "Hedef Yayını Seçin",
    "viral.selectReleaseDesc": "Hangi şarkınız için kampanya oluşturmak istiyorsunuz?",
    "viral.stepAIPlan": "AI Plan",
    "viral.stepLaunch": "Başlat",
    "viral.stepRelease": "Yayın",
    "viral.stepType": "Tür",
    "viral.task": "Görev",
    "viral.teaserDesc": "Yayın öncesi merak uyandırıcı içerikler serisi",
    "viral.teaserName": "Teaser (Ön Tanıtım)",
    "viral.tiktokDesc": "Kullanıcıları bir dans veya akım ile etkileşime geçirin",
    "viral.tiktokName": "TikTok Challenge",
    "viral.timeline": "Zaman Çizelgesi",
    "viral.title": "Viral Kampanya",
    "viral.totalCampaigns": "Toplam Kampanya",
    "viral.totalViews": "Toplam Görüntülenme",
    "viral.unknownRelease": "Bilinmeyen Yayın",
    "viral.viewCampaignPage": "Kampanya Sayfasını Görüntüle",
    "viral.views": "Gösterim",

  
  
    "email.subject_placeholder": "Konu...",
    "social.error_content_required": "İçerik zorunludur",
    "copyright.analyzing": "Analiz ediliyor...",
    "copyright.totalScans": "Toplam Tarama",
    "email.name_placeholder": "İsim...",
    "lyricsSync.lyricsPlaceholder": "Şarkı Sözlerini Buraya Satır Satır Girin...",
    "social.create_first": "İlk Gönderiyi Oluştur",
    "email.error_deleting_subscriber": "Abone silinirken hata oluştu",
    "email.campaign_created": "Kampanya oluşturuldu",
    "copyright.supportedFormats": "Desteklenen Formatlar",
    "preSave.requiredFields": "Lütfen tüm zorunlu alanları doldurun",
    "email.subscriber_deleted": "Abone silindi",
    "preSave.confirmDelete": "Bu kampanyayı silmek istediğinize emin misiniz?",
    "social.error_delete": "Gönderi silinirken hata oluştu",
    "email.email_placeholder": "E-posta...",
    "releases.fetchFailed": "Yayınlar yüklenemedi",
    "email.fill_required": "Lütfen tüm zorunlu alanları doldurun",
    "toast.releaseSubmitFailed": "Yayın gönderilemedi",
    "preSave.fetchError": "Veriler yüklenemedi",
    "_": "_",
    "email.click_rate": "Tıklama Oranı",
    "common.saving": "Kaydediliyor...",
    "aiStudio.alreadyAnalyzed": "Bu dosya zaten analiz edildi",
    "email.subscribers_list": "Aboneler Listesi",
    "copyright.recentScans": "Son Taramalar",
    ".": ".",
    "support.faq": "SSS",
    "email.add": "Ekle",
    "pressKit.success.upload": "Başarıyla yüklendi",
    "email.status": "Durum",
    "copyright.startScanBtn": "Taramayı Başlat",
    "error": "Hata",
    "contributors.errors.deleteFailed": "Katılımcı silinemedi",
    "support.submit": "Gönder",
    "album": "Albüm",
    "email.error_creating_campaign": "Kampanya oluşturulurken hata oluştu",
    "email.no_subscribers": "Abone bulunamadı",
    "releases.deleteSuccess": "Yayın başarıyla silindi",
    "referrals.error": "Referans hatası",
    "common.title": "Başlık",
    "social.confirm_delete": "Silmek istediğinize emin misiniz?",
    "pressKit.subtitle": "Elektronik Basın Kiti",
    "pressKit.error.maxPhotos": "Maksimum fotoğraf sayısına ulaşıldı",
    "email.error_adding_subscriber": "Abone eklenirken hata oluştu",
    "email.error_fetching": "Veri alınırken hata oluştu",
    "social.updated": "Başarıyla güncellendi",
    "promotions.errorGenerating": "Promosyon kartları oluşturulamadı",
    "collab.cancel": "İptal",
    "common.yesDelete": "Evet, Sil",
    "social.empty_desc": "Gönderi bulunamadı",
    "common.continue": "Devam Et",
    "email.campaign_sent": "Kampanya gönderildi",
    "SRT": "SRT",
    "email.email": "E-posta",
    "pressKit.error.upload": "Yükleme hatası",
    "TXT": "TXT",
    "social.error_upload": "Medya yüklenirken hata oluştu",
    "campaigns.all": "Tüm Kampanyalar",
    "copyright.error.noFile": "Dosya seçilmedi",
    "ref": "Referans",
    "common.select": "Seç",
    "copyright.scanStarted": "Tarama başlatıldı",
    "social.status": "Durum",
    "copyright.noDetails": "Detay bulunamadı",
    "script": "Script",
    "lyricsSync.description": "Şarkılarınız İçin Zaman Senkronizasyonlu Şarkı Sözleri Oluşturun",
    "aiStudio.maintenanceDesc": "Bu özellik şu anda bakımdadır. Yakında tekrar kullanılabilir olacak.",
    "lyricsSync.previewEmpty": "Önizleme Burada Görünecek",
    "aiAdvisor.exportFileName": "danisman_disa_aktarim",
    "copyright.uploadFile": "Dosya Yükle",
    "email.import_error": "İçe aktarma hatası",
    "error.fetch": "Veri alma hatası",
    "copyright.subtitle": "Telif Hakkı Yönetimi",
    "wizard.moreOptions.ownershipConfirmation": "Sahiplik Onayı",
    "social.media": "Sosyal Medya",
    "lyricsSync.saveSuccess": "Şarkı Sözleri Başarıyla Kaydedildi",
    "common.verifying": "Doğrulanıyor...",
    "preSave.deleteError": "Kampanya silinemedi",
    "smartLinks.uploadCover": "Kapak görseli yüklemek için tıklayın",
    "lyricsSync.selectTrackLabel": "Şarkı Seç",
    "smartLinks.uploadBg": "Arkaplan görseli yükle (opsiyonel)",
    "lyricsSync.noAudio": "Bu Parça İçin Ses Dosyası Bulunmuyor. Senkronizasyon Düzgün Çalışmayabilir.",
    "social.error_save": "Gönderi kaydedilirken hata",
    "support.attachments": "Ekler",
    "common.or": "Veya",
    "email.no_campaigns": "Kampanya yok",
    "email.import_success": "Başarıyla içe aktarıldı",
    "pressKit.error.load": "Basın kiti yüklenemedi",
    "pressKit.assets": "Varlıklar",
    "promotions.downloadError": "İndirme başarısız oldu",
    "preSave.copied": "Kopyalandı",
    "email.total_subscribers": "Toplam Abone",
    "pressKit.noReleases": "Yayın yok",
    "email.save_draft": "Taslak Kaydet",
    "preSave.createFirst": "İlk Kampanyayı Oluştur",
    "copyright.cleanDesc": "Temiz parça açıklaması",
    "preSave.createSuccess": "Kampanya başarıyla oluşturuldu",
    "lyricsSync.allSynced": "Tüm Satırlar Senkronize Edildi!",
    "copyright.error.noTrack": "Parça seçilmedi",
    "lyricsSync.saveError": "Şarkı Sözleri Kaydedilemedi",
    "playlistExplorer.all": "Tüm Çalma Listeleri",
    "contributors.errors.loadFailed": "Katılımcılar yüklenemedi",
    "pressKit.error.save": "Basın kiti kaydedilirken hata",
    "email.error_sending_campaign": "Kampanya gönderilirken hata",
    "releaseForm.selectGenre": "Tür Seçin",
    "playlistExplorer.errorFetching": "Çalma listeleri alınamadı",
    "aiStudio.maintenance": "Bakımda",
    "social.error_fetch": "Gönderiler alınamadı",
    "none": "Yok",
    "smartLinks.error.fetch": "Smart linkler alınamadı",
    "preSave.deleteSuccess": "Kampanya silindi",
    "social.editPost": "Gönderiyi Düzenle",
    "promotions.downloadSuccess": "Promosyon kartı indirildi!",
    "smartLinks.error.create": "Smart link oluşturulamadı",
    "contributors.errors.saveFailed": "Katılımcı kaydedilemedi",
    "smartLinks.confirm.delete": "Bu smart link'i silmek istediğinize emin misiniz?",
    "email.error_deleting_campaign": "Kampanya silinirken hata",
    "email.date": "Tarih",
    "social.error_platform_required": "Platform zorunludur",
    "smartLinks.error.required": "Başlık ve slug zorunludur",
    "social.created": "Gönderi oluşturuldu",
    "2d": "2D",
    "copyright.chooseTrack": "Parça Seç",
    "social.error_date_required": "Tarih zorunludur",
    "copyright.scanFailed": "Tarama başarısız",
    "copyright.flaggedTracks": "İşaretlenmiş Parçalar",
    "pressKit.bioPlaceholder": "Biyografi...",
    "status.pending": "Bekleyen",
    "social.deleted": "Gönderi silindi",
    "email.create_campaign": "Kampanya Oluştur",
    "smartLinks.success.created": "Smart link başarıyla oluşturuldu",
    "T": "T",
    "canvas": "Canvas",
    "email.actions": "İşlemler",
    "smartLinks.error.delete": "Smart link silinemedi",
    "a": "a",
    "support.guides": "Rehberler",
    "social.image_uploaded": "Görsel yüklendi",
    "pressKit.success.save": "Başarıyla kaydedildi",
    "email.open_rate": "Açılma Oranı",
    "preSave.chooseRelease": "Yayın seçin...",
    "support.searchTickets": "Bilet ara...",
    "copyright.startNewScan": "Yeni Tarama Başlat",
    "copyright.dragDrop": "Sürükle ve Bırak",
    "single": "Tekli",
    "email.content_placeholder": "İçerik...",
    "preSave.createError": "Kampanya oluşturulamadı",
    "-": "-",
    "email.campaign_deleted": "Kampanya silindi",
    "token": "Token",
    "playlistExplorer.apply": "Uygula",
    "common.verify": "Doğrula",
    "smartLinks.success.deleted": "Smart link silindi",
    "wizard.moreOptions.contentIdTerms": "Content ID Şartları",
    "social.subtitle": "Sosyal Medya Yönetimi",
    "status.scheduled": "Planlandı",
    "copyright.cleanRate": "Temizlik Oranı",
    "email.subscriber_added": "Abone eklendi",
    "fanScore.fetchError": "Hayran skoru alınamadı",
    "LRC": "LRC",
    // admin.announcements
    "admin.announcements.title": "Duyurular",
    "admin.announcements.subtitle": "Kullanıcılara gösterilecek duyuruları yönetin",
    "admin.announcements.newAnnouncement": "Yeni Duyuru",
    "admin.announcements.noAnnouncements": "Henüz duyuru yok",
    "admin.announcements.titleBodyRequired": "Başlık ve içerik zorunludur",
    "admin.announcements.updated": "Duyuru güncellendi",
    "admin.announcements.operationFailed": "İşlem başarısız",
    "admin.announcements.deleted": "Duyuru silindi",
    "admin.announcements.deleteFailed": "Silme işlemi başarısız",
    "admin.announcements.deactivated": "Duyuru devre dışı",
    "admin.announcements.activated": "Duyuru aktif",
    "admin.announcements.active": "Aktif",
    "admin.announcements.inactive": "Pasif",
    "admin.announcements.createdAt": "Oluşturulma",
    "admin.announcements.start": "Başlangıç",
    "admin.announcements.end": "Bitiş",
    "admin.announcements.deactivate": "Devre Dışı Bırak",
    "admin.announcements.activate": "Aktif Et",
    "admin.announcements.titleLabel": "Başlık",
    "admin.announcements.titlePlaceholder": "Duyuru başlığı",
    "admin.announcements.contentLabel": "İçerik",
    "admin.announcements.contentPlaceholder": "Duyuru içeriği",
    "admin.announcements.type": "Tür",
    "admin.announcements.typeInfo": "Bilgi",
    "admin.announcements.typeWarning": "Uyarı",
    "admin.announcements.typeSuccess": "Başarı",
    "admin.announcements.displayMode": "Görüntüleme Modu",
    "admin.announcements.both": "Her İkisi",
    "admin.announcements.startDateOptional": "Başlangıç Tarihi (opsiyonel)",
    "admin.announcements.endDateOptional": "Bitiş Tarihi (opsiyonel)",
    "admin.announcements.pinned": "Sabitlenmiş",
    "admin.announcements.activeLabel": "Aktif",

    // admin.aiMatcher
    "admin.aiMatcher.title": "AI Matcher Sonuçları",
    "admin.aiMatcher.subtitle": "Kullanıcıların AI Playlist Matcher eşleşme geçmişi",
    "admin.aiMatcher.totalResults": "Toplam",
    "admin.aiMatcher.results": "sonuç",
    "admin.aiMatcher.noResults": "Henüz eşleşme sonucu yok",
    "admin.aiMatcher.resultDeleted": "Sonuç silindi",
    "admin.aiMatcher.resultDeleteFailed": "Sonuç silinemedi",
    "admin.aiMatcher.user": "Kullanıcı",
    "admin.aiMatcher.release": "Yayın",
    "admin.aiMatcher.genre": "Tür",
    "admin.aiMatcher.match": "Eşleşme",
    "admin.aiMatcher.score": "Skor",
    "admin.aiMatcher.date": "Tarih",
    "admin.aiMatcher.actions": "İşlemler",
    "admin.aiMatcher.matchedPlaylists": "Eşleşen Playlistler",
    "admin.aiMatcher.followers": "takipçi",
    "admin.releaseDetail.fetchFailed": "Yayın bilgileri alınamadı",
    "admin.releaseDetail.reasonNeeded": "Bu durum için sebep gerekli",
    "admin.releaseDetail.statusUpdated": "Durum güncellendi",
    "admin.releaseDetail.updateFailed": "Güncelleme başarısız",
    "admin.releaseDetail.codesSaved": "Kodlar kaydedildi",
    "admin.releaseDetail.saveFailed": "Kaydetme başarısız",
    "admin.releaseDetail.packageDownloading": "Paket indiriliyor...",
    "admin.releaseDetail.releaseUpdated": "Yayın güncellendi",
    "admin.releaseDetail.metadataDownloaded": "Metadata indirildi",
    "admin.releaseDetail.dspSummary": "DSP Özeti",
    "admin.releaseDetail.editAll": "Tümünü Düzenle",
    "admin.releaseDetail.changeStatus": "Durumu Değiştir",
    "admin.releaseDetail.updateStatus": "Durumu Güncelle",
    "admin.releaseDetail.selectTemplate": "Hazır Şablon Seç",
    "admin.releaseDetail.templatePlaceholder": "Şablon seç veya özel mesaj yaz...",
    "admin.releaseDetail.templateHint": "Şablon seçerseniz mesaj otomatik doldurulur, düzenleyebilirsiniz.",
    "admin.releaseDetail.update": "Güncelle",
    "admin.releaseDetail.editCodes": "ISRC & UPC Kodları Düzenle",
    "admin.releaseDetail.upcCode": "UPC (Yayın Kodu)",
    "admin.releaseDetail.enterUpc": "UPC kodunu girin",
    "admin.releaseDetail.barcodeHint": "12 haneli barkod numarası",
    "admin.releaseDetail.isrcCodes": "ISRC Kodları (Parça bazlı)",
    "admin.releaseDetail.enterIsrc": "ISRC kodunu girin (örn: USRC17607839)",
    "admin.releaseDetail.isrcFormat": "ISRC formatı: CC-XXX-YY-NNNNN",
    "admin.releaseDetail.editRelease": "Yayını Düzenle",
    "admin.releaseDetail.general": "Genel",
    "admin.releaseDetail.tracks": "Parçalar",
    "admin.releaseDetail.publishing": "Yayıncılık",
    "admin.releaseDetail.platforms": "Platformlar",
    "admin.releaseDetail.links": "Linkler",
    "admin.releaseDetail.releaseType": "Yayın Türü",
    "admin.releaseDetail.releaseDate": "Yayın Tarihi",
    "admin.releaseDetail.albumTitle": "Albüm Başlığı",
    "admin.releaseDetail.albumVersion": "Albüm Versiyon",
    "admin.releaseDetail.versionPlaceholder": "Deluxe, Remastered, vs.",
    "admin.releaseDetail.primaryGenre": "Ana Tür",
    "admin.releaseDetail.secondaryGenre": "Alt Tür",
    "admin.releaseDetail.language": "Dil",
    "admin.releaseDetail.labelCompany": "Label / Şirket",
    "admin.releaseDetail.barcodeShort": "12 haneli barkod",
    "admin.releaseDetail.barcodePlaceholder": "12 haneli barkod",
    "admin.releaseDetail.releaseTime": "Yayın Zamanı",
    "admin.releaseDetail.select": "Seçin",
    "admin.releaseDetail.localTime": "Yerel Saat",
    "admin.releaseDetail.previouslyReleased": "Daha önce yayınlandı",
    "admin.releaseDetail.originalReleaseDate": "Orijinal Yayın Tarihi",
    "admin.releaseDetail.untitledTrack": "İsimsiz Parça",
    "admin.releaseDetail.trackTitle": "Parça Başlığı",
    "admin.releaseDetail.version": "Versiyon",
    "admin.releaseDetail.versionExamples": "Remix, Acoustic, vs.",
    "admin.releaseDetail.albumVersionPlaceholder": "Deluxe, Remastered, vs.",
    "admin.releaseDetail.contentType": "İçerik Tipi",
    "admin.releaseDetail.notSpecified": "Belirtilmemiş",
    "admin.releaseDetail.primaryArtistsComma": "Ana Sanatçılar (virgülle ayırın)",
    "admin.releaseDetail.featuredArtistsComma": "Featured Sanatçılar (virgülle ayırın)",
    "admin.releaseDetail.spotifyArtistIds": "Spotify Artist ID'leri",
    "admin.releaseDetail.primaryArtists": "Ana Sanatçılar",
    "admin.releaseDetail.spotifyIdNotLinked": "Spotify ID bağlı değil - Sanatçılar",
    "admin.releaseDetail.featuredArtists": "Konuk Sanatçılar",
    "admin.releaseDetail.writers": "Yazarlar",
    "admin.releaseDetail.composers": "Besteciler",
    "admin.releaseDetail.producers": "Prodüktörler",
    "admin.releaseDetail.songwritersFormat": "Söz Yazarları (Ad (Rol), formatında)",
    "admin.releaseDetail.contributors": "Katkıda Bulunanlar",
    "admin.releaseDetail.productionTeam": "Yapım Ekibi",
    "admin.releaseDetail.instrumental": "Enstrümantal",
    "admin.releaseDetail.licensedContent": "Lisanslı İçerik",
    "admin.releaseDetail.lyrics": "Şarkı Sözleri",
    "admin.releaseDetail.enterLyrics": "Şarkı sözlerini girin...",
    "admin.releaseDetail.lyricsPlaceholder": "Şarkı sözlerini girin...",
    "admin.releaseDetail.publishingInfo": "Yayıncılık Bilgileri",
    "admin.releaseDetail.publishingPercentage": "Yayıncılık Yüzdesi (%)",
    "admin.releaseDetail.hasPublisher": "Yayıncım var",
    "admin.releaseDetail.publisherName": "Yayıncı Adı",
    "admin.releaseDetail.proInfo": "PRO Bilgileri",
    "admin.releaseDetail.registeredWithPro": "PRO'ya kayıtlıyım",
    "admin.releaseDetail.affiliatedSociety": "Bağlı Kuruluş",
    "admin.releaseDetail.ipiNumber": "IPI Numarası",
    "admin.releaseDetail.distributionPlatforms": "Dağıtım Platformları",
    "admin.releaseDetail.platformLinks": "Platform Linkleri",
    "admin.releaseDetail.dspDescription": "Tüm track metadata bilgileri. DSP'ye manuel yükleme için kullanın.",
    "admin.releaseDetail.dspMetadataDesc": "Tüm track metadata bilgileri. DSP'ye manuel yükleme için kullanın.",
    "admin.releaseDetail.releaseVersion": "Yayın Versiyonu (Release Version)",
    "admin.releaseDetail.albumArtists": "Albüm Sanatçıları",
    "admin.releaseDetail.date": "Tarih",
    "admin.releaseDetail.trackCount": "Parça Sayısı",
    "admin.releaseDetail.transferInfo": "Transfer Bilgileri",
    "admin.releaseDetail.distributionType": "Dağıtım Türü",
    "admin.releaseDetail.transferFrom": "Transfer (Başka Dağıtımcıdan)",
    "admin.releaseDetail.transferDistribution": "Transfer (Başka Dağıtımcıdan)",
    "admin.releaseDetail.newRelease": "Yeni Yayın",
    "admin.releaseDetail.trackVersion": "Parça Versiyonu",
    "admin.releaseDetail.existingIsrc": "Mevcut ISRC",
    "admin.releaseDetail.fileName": "Dosya Adı",
    "admin.releaseDetail.duration": "Süre",
    "admin.releaseDetail.trackVersionFull": "Parça Versiyonu (Track Version)",
    "admin.releaseDetail.trackLanguage": "Parça Dili",
    "admin.releaseDetail.titleLanguage": "Başlık Dili",
    "admin.releaseDetail.genre": "Tür",
    "admin.releaseDetail.recordLabel": "Plak Şirketi",
    "admin.releaseDetail.credits": "Kredi Bilgileri",
    "admin.releaseDetail.creditInfo": "Kredi Bilgileri",
    "admin.releaseDetail.songwriters": "Söz Yazarları / Besteciler (Songwriters)",
    "admin.releaseDetail.songwritersSection": "Söz Yazarları / Besteciler (Songwriters)",
    "admin.releaseDetail.name": "İsim",
    "admin.releaseDetail.role": "Rol",
    "admin.releaseDetail.productionTeamFull": "Prodüksiyon Ekibi (Production Team)",
    "admin.releaseDetail.productionTeamSection": "Prodüksiyon Ekibi (Production Team)",
    "admin.releaseDetail.contributorsFull": "Katkıda Bulunanlar (Contributors)",
    "admin.releaseDetail.contributorsSection": "Katkıda Bulunanlar (Contributors)",
    "admin.releaseDetail.noCreditWarning": "Bu parça için kredi bilgisi girilmemiş (Songwriters, Production Team, Contributors)",
    "admin.releaseDetail.writersLegacy": "Yazarlar (Legacy)",
    "admin.releaseDetail.composersLegacy": "Besteciler (Legacy)",
    "admin.releaseDetail.producersLegacy": "Prodüktörler (Legacy)",
    "admin.releaseDetail.downloadLicense": "Lisans Belgesi İndir (PDF)",
    "admin.releaseDetail.licenseNotUploaded": "Lisans belgesi yüklenmemiş!",
    "admin.releaseDetail.noLicenseUploaded": "Lisans belgesi yüklenmemiş!",
    "admin.releaseDetail.lyricsLanguage": "Dil",
    "admin.releaseDetail.viewLyrics": "Sözleri Görüntüle",
    "admin.releaseDetail.noLyricsEntered": "Şarkı sözü girilmemiş",
    "admin.releaseDetail.lyricsDspNote": "Şarkı sözleri Apple Music, Spotify vb. DSP'lerde görüntülenebilir.",
    "admin.releaseDetail.lyricsVisibleOnDsp": "Şarkı sözleri Apple Music, Spotify vb. DSP'lerde görüntülenebilir.",
    "admin.releaseDetail.noTracks": "Parça yok",
    "admin.releaseDetail.contributorsTitle": "Katkıda Bulunanlar",
    "admin.releaseDetail.producersLabel": "Yapımcılar",
    "admin.releaseDetail.platformsTitle": "Platformlar",
    "admin.releaseDetail.images": "Görseller",
    "admin.releaseDetail.coverImages": "Görseller",
    "admin.releaseDetail.linksTitle": "Linkler",
    "admin.releaseDetail.pricing": "Fiyatlandırma",
    "admin.releaseDetail.singlePrice": "Tekli Fiyat",
    "admin.releaseDetail.albumPrice": "Albüm Fiyatı",
    "admin.releaseDetail.uploadDate": "Yükleme",
    "admin.artists.loadFailed": "Kullanıcı bilgileri yüklenemedi",
    "admin.artists.featureUpdated": "Özellik güncellendi",
    "admin.artists.featureUpdateFailed": "Özellik güncellenemedi",
    "admin.artists.ibanRevealed": "IBAN görüntülendi - Audit log'a kaydedildi",
    "admin.artists.ibanNotFound": "IBAN bilgisi bulunamadı",
    "admin.artists.superadminRequired": "Bu işlem için superadmin yetkisi gerekli",
    "admin.artists.ibanRevealFailed": "IBAN görüntülenemedi",
    "admin.artists.copiedToClipboard": "Panoya kopyalandı",
    "admin.artists.userApproved": "Kullanıcı onaylandı",
    "admin.artists.rejectReasonMandatory": "Reddetme sebebi zorunludur",
    "admin.artists.rejectReasonRequired": "Reddetme sebebi zorunludur",
    "admin.artists.userRejected": "Kullanıcı reddedildi",
    "admin.artists.banReasonMandatory": "Ban sebebi zorunludur",
    "admin.artists.banReasonRequired": "Ban sebebi zorunludur",
    "admin.artists.userBanned": "Kullanıcı banlandı",
    "admin.artists.banRemoved": "Ban kaldırıldı",
    "admin.artists.planUpdated": "Plan güncellendi",
    "admin.artists.badgesUpdated": "Badges güncellendi",
    "admin.artists.enterValidAmount": "Geçerli bir tutar girin",
    "admin.artists.addedByAdmin": "Admin tarafından eklendi",
    "admin.artists.balanceUpdated": "Bakiye güncellendi",
    "admin.artists.operationFailed": "İşlem başarısız",
    "admin.artists.passwordMinLength": "Şifre en az 6 karakter olmalıdır",
    "admin.artists.passwordResetSuccess": "Şifre başarıyla sıfırlandı",
    "admin.artists.passwordResetFailed": "Şifre sıfırlama başarısız",
    "admin.artists.passwordCopied": "Şifre panoya kopyalandı",
    "admin.artists.title": "Sanatçı Yönetimi",
    "admin.artists.subtitle": "Kullanıcıları yönetin ve onaylayın",
    "admin.artists.userNotFound": "Kullanıcı bulunamadı",
    "admin.artists.noUsersFound": "Kullanıcı bulunamadı",
    "admin.artists.noUsersForFilter": "Seçili filtre için kullanıcı bulunmuyor.",
    "admin.artists.user": "Kullanıcı",
    "admin.artists.balanceHeader": "Bakiye",
    "admin.artists.status": "Durum",
    "admin.artists.registrationDate": "Kayıt Tarihi",
    "admin.artists.actions": "İşlemler",
    "admin.artists.detail": "Detay",
    "admin.artists.approve": "Onayla",
    "admin.artists.reject": "Reddet",
    "admin.artists.balanceBtn": "Bakiye",
    "admin.artists.balanceAction": "Bakiye",
    "admin.artists.ban": "Banla",
    "admin.artists.unban": "Banı Kaldır",
    "admin.artists.approveUser": "Kullanıcıyı Onayla",
    "admin.artists.approveUserDialog": "Kullanıcıyı Onayla",
    "admin.artists.rejectUser": "Kullanıcıyı Reddet",
    "admin.artists.rejectUserDialog": "Kullanıcıyı Reddet",
    "admin.artists.banUser": "Kullanıcıyı Banla",
    "admin.artists.banUserDialog": "Kullanıcıyı Banla",
    "admin.artists.unbanUserDialog": "Banı Kaldır",
    "admin.artists.assignPlan": "Plan Ata",
    "admin.artists.assignPlanDialog": "Plan Ata",
    "admin.artists.addBalance": "Bakiye Ekle",
    "admin.artists.addBalanceDialog": "Bakiye Ekle",
    "admin.artists.currentBanReason": "Mevcut ban sebebi",
    "admin.artists.noteOptional": "Not (Opsiyonel)",
    "admin.artists.notePlaceholder": "Kullanıcıya gönderilecek not...",
    "admin.artists.rejectReasonLabel": "Reddetme Sebebi (Zorunlu)",
    "admin.artists.rejectReasonPlaceholder": "Reddetme sebebini belirtin...",
    "admin.artists.banReasonLabel": "Ban Sebebi (Zorunlu)",
    "admin.artists.banReasonPlaceholder": "Örn: Telif hakkı ihlali, lisans doğrulaması bekliyor...",
    "admin.artists.bannedUserRestrictions": "Banlı kullanıcılar yeni release gönderemez, payout talep edemez.",
    "admin.artists.banWarning": "Banlı kullanıcılar yeni release gönderemez, payout talep edemez.",
    "admin.artists.unbanNotePlaceholder": "Ban kaldırma notu...",
    "admin.artists.planType": "Plan Türü",
    "admin.artists.selectPlan": "Plan seçin",
    "admin.artists.amount": "Tutar ($)",
    "admin.artists.amountLabel": "Tutar ($)",
    "admin.artists.amountPlaceholder": "Örn: 100.00",
    "admin.artists.description": "Açıklama",
    "admin.artists.descriptionLabel": "Açıklama",
    "admin.artists.descriptionPlaceholder": "Örn: Streaming kazançları",
    "admin.artists.banAction": "Banla",
    "admin.artists.unbanAction": "Banı Kaldır",
    "admin.artists.add": "Ekle",
    "admin.artists.userDetails": "Kullanıcı Detayları",
    "admin.artists.basicInfo": "Temel Bilgiler",
    "admin.artists.fullName": "Ad Soyad",
    "admin.artists.email": "E-posta",
    "admin.artists.addressInfo": "Adres Bilgileri",
    "admin.artists.address": "Adres",
    "admin.artists.city": "Şehir",
    "admin.artists.country": "Ülke",
    "admin.artists.postalCode": "Posta Kodu",
    "admin.artists.loginInfo": "Giriş Bilgileri & IP Adresleri",
    "admin.artists.loginAndIpInfo": "Giriş Bilgileri & IP Adresleri",
    "admin.artists.registrationDateLabel": "Kayıt Tarihi",
    "admin.artists.lastLogin": "Son Giriş",
    "admin.artists.lastLoginIp": "Son Giriş IP",
    "admin.artists.loginHistory": "Giriş Geçmişi (Son 10)",
    "admin.artists.billingProfile": "Billing & Payout Profili",
    "admin.artists.billingAndPayoutProfile": "Billing & Payout Profili",
    "admin.artists.payoutMethodFull": "Ödeme Yöntemi (Tam Bilgiler)",
    "admin.artists.bankTransfer": "Banka Transferi",
    "admin.artists.lastUpdate": "Son güncelleme",
    "admin.artists.lastUpdated": "Son güncelleme",
    "admin.artists.statistics": "İstatistikler",
    "admin.artists.stats": "İstatistikler",
    "admin.artists.totalReleases": "Toplam Yayın",
    "admin.artists.supportTickets": "Destek Talebi",
    "admin.artists.payoutRequests": "Ödeme Talebi",
    "admin.artists.banInfo": "Ban Bilgileri",
    "admin.artists.banReason": "Ban Sebebi",
    "admin.artists.banReasonDetail": "Ban Sebebi",
    "admin.artists.notSpecified": "Belirtilmemiş",
    "admin.artists.banDate": "Ban Tarihi",
    "admin.artists.referralInfo": "Referans Bilgileri",
    "admin.artists.referralCode": "Referans Kodu",
    "admin.artists.featureControl": "Özellik Kontrolü (Devre Dışı Bırak)",
    "admin.artists.off": "(Kapalı)",
    "admin.artists.on": "(Açık)",
    "admin.artists.adminFullAccess": "Admin olarak tüm ödeme bilgilerine tam erişiminiz vardır.",
    "admin.artists.adminPaymentAccess": "Admin olarak tüm ödeme bilgilerine tam erişiminiz vardır.",
    "admin.artists.noPayoutMethod": "Ödeme yöntemi tanımlanmamış",
    "admin.artists.paymentMethodNotDefined": "Ödeme yöntemi tanımlanmamış",
    "admin.artists.resetPassword": "Şifre Sıfırla",
    "admin.artists.resetPasswordBtn": "Şifre Sıfırla",
    "admin.artists.resetPasswordTitle": "Şifre Sıfırla",
    "admin.artists.setNewPassword": "için yeni şifre belirleyin",
    "admin.artists.setNewPasswordFor": "için yeni şifre belirleyin",
    "admin.artists.newPassword": "Yeni Şifre",
    "admin.artists.enterNewPassword": "Yeni şifre girin",
    "admin.artists.newPasswordPlaceholder": "Yeni şifre girin",
    "admin.artists.minChars": "En az 6 karakter olmalıdır",
    "admin.artists.min6Chars": "En az 6 karakter olmalıdır",
    "admin.artists.forcePasswordChange": "Kullanıcı ilk girişte şifre değiştirmek zorunda olsun",
    "admin.artists.generatedPassword": "Oluşturulan şifre",
    "admin.artists.resetPasswordAction": "Şifreyi Sıfırla",
    "admin.artists.resetPasswordConfirm": "Şifreyi Sıfırla",
    "admin.artists.auditLog": "Ödeme İşlem Geçmişi (Audit Log)",
    "admin.payoutMethods.loadFailed": "Ödeme yöntemleri yüklenemedi",
    "admin.payoutMethods.revealFailed": "Bilgiler gösterilemedi",
    "admin.payoutMethods.billingLoadFailed": "Billing profili yüklenemedi",
    "admin.payoutMethods.noUserSelected": "Kullanıcı seçilmedi",
    "admin.payoutMethods.methodAdded": "Ödeme yöntemi eklendi",
    "admin.payoutMethods.operationFailed": "İşlem başarısız",
    "admin.payoutMethods.methodUpdated": "Ödeme yöntemi güncellendi",
    "admin.payoutMethods.methodDeleted": "Ödeme yöntemi silindi",
    "admin.payoutMethods.title": "Ödeme Yöntemleri Yönetimi",
    "admin.payoutMethods.subtitle": "Tüm kullanıcıların ödeme yöntemlerini görüntüle ve yönet",
    "admin.payoutMethods.description": "Tüm kullanıcıların ödeme yöntemlerini görüntüle ve yönet",
    "admin.payoutMethods.searchPlaceholder": "Kullanıcı adı veya e-posta ile ara...",
    "admin.payoutMethods.filterByUserId": "User ID ile filtrele",
    "admin.payoutMethods.filterUserId": "User ID ile filtrele",
    "admin.payoutMethods.clear": "Temizle",
    "admin.payoutMethods.notFound": "Ödeme Yöntemi Bulunamadı",
    "admin.payoutMethods.notFoundTitle": "Ödeme Yöntemi Bulunamadı",
    "admin.payoutMethods.noMethodForUser": "Bu kullanıcıya ait ödeme yöntemi yok",
    "admin.payoutMethods.noMethodsYet": "Henüz ödeme yöntemi eklenmemiş",
    "admin.payoutMethods.noMethodAddedYet": "Henüz ödeme yöntemi eklenmemiş",
    "admin.payoutMethods.addMethod": "Ödeme Yöntemi Ekle",
    "admin.payoutMethods.bankTransfer": "Banka Transferi",
    "admin.payoutMethods.default": "Varsayılan",
    "admin.payoutMethods.verified": "Doğrulanmış",
    "admin.payoutMethods.pendingVerification": "Doğrulama Bekliyor",
    "admin.payoutMethods.pending": "Doğrulama Bekliyor",
    "admin.payoutMethods.notVerified": "Doğrulanmadı",
    "admin.payoutMethods.unverified": "Doğrulanmadı",
    "admin.payoutMethods.accountHolder": "Hesap Sahibi",
    "admin.payoutMethods.bank": "Banka",
    "admin.payoutMethods.bankLabel": "Banka",
    "admin.payoutMethods.country": "Ülke",
    "admin.payoutMethods.countryLabel": "Ülke",
    "admin.payoutMethods.currency": "Para Birimi",
    "admin.payoutMethods.currencyLabel": "Para Birimi",
    "admin.payoutMethods.paypalEmail": "PayPal E-posta",
    "admin.payoutMethods.lastUpdate": "Son güncelleme",
    "admin.payoutMethods.lastUpdated": "Son güncelleme",
    "admin.payoutMethods.profile": "Profil",
    "admin.payoutMethods.revealFull": "Tam Göster",
    "admin.payoutMethods.editMethod": "Ödeme Yöntemi Düzenle",
    "admin.payoutMethods.addNewMethod": "Yeni Ödeme Yöntemi Ekle",
    "admin.payoutMethods.addMethodTitle": "Yeni Ödeme Yöntemi Ekle",
    "admin.payoutMethods.adminOtpNotice": "Admin olarak değişiklik yaparken OTP doğrulaması gerekmez. Kullanıcıya e-posta bildirimi gönderilecektir.",
    "admin.payoutMethods.addEditDescription": "Admin olarak değişiklik yaparken OTP doğrulaması gerekmez. Kullanıcıya e-posta bildirimi gönderilecektir.",
    "admin.payoutMethods.userId": "Kullanıcı ID *",
    "admin.payoutMethods.userIdLabel": "Kullanıcı ID *",
    "admin.payoutMethods.enterUserId": "User ID girin",
    "admin.payoutMethods.userIdPlaceholder": "User ID girin",
    "admin.payoutMethods.ibanLabel": "IBAN *",
    "admin.payoutMethods.accountHolderName": "Hesap Sahibi Adı *",
    "admin.payoutMethods.accountHolderNameLabel": "Hesap Sahibi Adı *",
    "admin.payoutMethods.fullName": "Ad Soyad",
    "admin.payoutMethods.fullNamePlaceholder": "Ad Soyad",
    "admin.payoutMethods.bankName": "Banka Adı",
    "admin.payoutMethods.bankNameLabel": "Banka Adı",
    "admin.payoutMethods.optional": "Opsiyonel",
    "admin.payoutMethods.optionalPlaceholder": "Opsiyonel",
    "admin.payoutMethods.paypalEmailLabel": "PayPal E-posta Adresi *",
    "admin.payoutMethods.update": "Güncelle",
    "admin.payoutMethods.add": "Ekle",
    "admin.payoutMethods.fullPaymentInfo": "Tam Ödeme Bilgileri",
    "admin.payoutMethods.fullPaymentDetails": "Tam Ödeme Bilgileri",
    "admin.payoutMethods.auditLogNotice": "Bu bilgiler audit log'a kaydedilmektedir.",
    "admin.payoutMethods.auditLogWarning": "Bu bilgiler audit log'a kaydedilmektedir.",
    "admin.payoutMethods.sensitiveDataWarning": "Bu bilgiler hassastır ve görüntülemeniz loglanmıştır.",
    "admin.payoutMethods.userLabel": "Kullanıcı",
    "admin.payoutMethods.user": "Kullanıcı",
    "admin.payoutMethods.bankInfo": "Banka Bilgileri",
    "admin.payoutMethods.bankDetails": "Banka Bilgileri",
    "admin.payoutMethods.ibanFull": "IBAN (TAM)",
    "admin.payoutMethods.accountHolderLabel": "Hesap Sahibi",
    "admin.payoutMethods.paypalInfo": "PayPal Bilgileri",
    "admin.payoutMethods.paypalDetails": "PayPal Bilgileri",
    "admin.payoutMethods.paypalEmailFull": "PayPal E-posta (TAM)",
    "admin.payoutMethods.statusVerified": "Doğrulanmış",
    "admin.payoutMethods.statusPending": "Beklemede",
    "admin.payoutMethods.statusNotVerified": "Doğrulanmamış",
    "admin.payoutMethods.statusUnverified": "Doğrulanmamış",
    "admin.payoutMethods.statusUnverifiedText": "Doğrulanmadı",
    "admin.payoutMethods.statusLabel": "Durum",
    "admin.payoutMethods.close": "Kapat",
    "admin.payoutMethods.deleteMethod": "Ödeme Yöntemi Sil",
    "admin.payoutMethods.deleteWarning": "Bu işlem geri alınamaz ve kullanıcıya e-posta bildirimi gönderilecektir.",
    "admin.payoutMethods.userColon": "Kullanıcı",
    "admin.payoutMethods.delete": "Sil",
    "admin.payoutMethods.billingPayoutProfile": "Billing & Payout Profile",
    "admin.payoutMethods.billingProfileTitle": "Billing & Payout Profile",
    "admin.payoutMethods.maskedDataNotice": "Hassas veriler güvenlik için maskelenmiştir.",
    "admin.payoutMethods.maskedDataWarning": "Hassas veriler güvenlik için maskelenmiştir.",
    "admin.payoutMethods.identityInfo": "A) Kimlik Bilgileri",
    "admin.payoutMethods.profileType": "Profil Türü",
    "admin.payoutMethods.business": "İşletme / Şirket",
    "admin.payoutMethods.individual": "Bireysel",
    "admin.payoutMethods.legalName": "Yasal Ad Soyad",
    "admin.payoutMethods.displayName": "Görünen Ad",
    "admin.payoutMethods.email": "E-posta",
    "admin.payoutMethods.phone": "Telefon",
    "admin.payoutMethods.businessInfo": "İşletme Bilgileri",
    "admin.payoutMethods.companyName": "Şirket Adı",
    "admin.payoutMethods.registrationNumber": "Şirket Sicil No",
    "admin.payoutMethods.companyRegNo": "Şirket Sicil No",
    "admin.payoutMethods.vatNumber": "VAT Numarası",
    "admin.payoutMethods.addressInfo": "B) Adres Bilgileri",
    "admin.payoutMethods.city": "Şehir",
    "admin.payoutMethods.stateRegion": "İl/Bölge",
    "admin.payoutMethods.state": "İl/Bölge",
    "admin.payoutMethods.postalCode": "Posta Kodu",
    "admin.payoutMethods.addressLine1": "Adres Satırı 1",
    "admin.payoutMethods.addressLine2": "Adres Satırı 2",
    "admin.payoutMethods.taxInfo": "C) Vergi Bilgileri (Çekim için Zorunlu)",
    "admin.payoutMethods.taxStatus": "Vergi Durumu",
    "admin.payoutMethods.taxMissing": "Eksik (Çekim Yapamaz)",
    "admin.payoutMethods.taxPersonal": "Bireysel",
    "admin.payoutMethods.personal": "Bireysel",
    "admin.payoutMethods.taxCorporate": "Kurumsal",
    "admin.payoutMethods.corporate": "Kurumsal",
    "admin.payoutMethods.taxCountry": "Vergi Ülkesi",
    "admin.payoutMethods.taxIdMasked": "Vergi / TC Kimlik No (Maskeli)",
    "admin.payoutMethods.taxWarning": "Bu kullanıcı vergi bilgilerini tamamlamadan çekim talebi oluşturamaz",
    "admin.payoutMethods.activeMethod": "D) Aktif Ödeme Yöntemi",
    "admin.payoutMethods.method": "Yöntem",
    "admin.payoutMethods.verificationStatus": "Doğrulama Durumu",
    "admin.payoutMethods.ibanMasked": "IBAN (Maskeli)",
    "admin.payoutMethods.paypalMasked": "PayPal E-posta (Maskeli)",
    "admin.payoutMethods.updatedBy": "Güncelleyen",
    "admin.payoutMethods.securityNotice": "Hassas veriler (IBAN, Vergi Kimlik No) güvenlik için maskelenmiştir. Tam bilgileri görmek için 'Tam Göster' butonunu kullanın.",
    "admin.payoutMethods.revealIban": "Tam Göster (IBAN)",

    // changePassword
    "changePassword.title": "Şifre Değiştir",
    "changePassword.description": "Güvenliğiniz için lütfen şifrenizi değiştirin.",
    "changePassword.currentPassword": "Mevcut Şifre",
    "changePassword.newPassword": "Yeni Şifre",
    "changePassword.confirmPassword": "Yeni Şifre (Tekrar)",
    "changePassword.showPasswords": "Şifreleri göster",
    "changePassword.submitBtn": "Şifreyi Değiştir",
    "changePassword.passwordsNotMatch": "Yeni şifreler eşleşmiyor",
    "changePassword.passwordLength": "Şifre en az 6 karakter olmalı",
    "changePassword.passwordChanged": "Şifre değiştirildi",
    "changePassword.passwordChangeFailed": "Şifre değiştirilemedi",

    // suspended
    "suspended.title": "Hesap Askıya Alındı",
    "suspended.greeting": "Merhaba ",
    "suspended.reason": ", hesabınız lisans ihlali nedeniyle askıya alınmıştır.",
    "suspended.restrictions": "Kısıtlamalar",
    "suspended.noUpload": "Yeni yayın yükleyemezsiniz",
    "suspended.noPayout": "Ödeme talep edemezsiniz",
    "suspended.noIban": "IBAN bilgilerini güncelleyemezsiniz",
    "suspended.accessible": "Erişilebilir Özellikler",
    "suspended.viewReleases": "Mevcut yayınlarınızı görüntüleyebilirsiniz",
    "suspended.reviewHistory": "Takedown ve claim geçmişinizi inceleyebilirsiniz",
    "suspended.createSupport": "Destek talebi oluşturabilirsiniz",
    "suspended.contactSupport": "Askı kaldırılması için lütfen destek ekibimizle iletişime geçin.",
    "suspended.contactBtn": "Destek Talebi",
    "suspended.createTicketTitle": "Destek Talebi Oluştur",
    "suspended.ticketSubmitted": "Talebiniz Alındı!",
    "suspended.ticketTeamReply": "Destek ekibimiz en kısa sürede size dönüş yapacaktır.",
    "suspended.fillFields": "Lütfen tüm alanları doldurun",
    "suspended.ticketCreated": "Destek talebi oluşturuldu",
    "suspended.ticketFailed": "Talep oluşturulamadı",
    "suspended.subjectPlaceholder": "Örn: Hesap askı durumu hakkında",
    "suspended.messagePlaceholder": "Hesabınızın neden askıya alındığını düşünüyorsunuz? İtirazınızı detaylı açıklayın...",
    "suspended.catAccount": "Hesap / İtiraz",
    "suspended.catTechnical": "Teknik Sorun",
    "suspended.catRelease": "Yayın Sorunu",
};

export default tr;
